var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g3, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeCup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69 103h2v-1h1v3h-1v2h2v3h-2v10h-1v2h-2v1h-3v-1h-1v-2h2v1h3v-7zm2 6h1v-1h-1zm3-68v-1h1v-1h1v-1h2v-1h2v-1h1v2h1v-1h1v-1h1v2h-1v1h-2v1h-2v1h-1v-1h-1v1zm0 64v2h-1v-2zm-3-62v-1h1v1zm2 1h1v1h-1zm1 58h1v1h-1z",
    fill: "#ede9e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 123h1v-5h1v-5h1v2h3v2h-1v3h-1v2h-2v3h-1v-1h-1zm7-84v1h-2v-2h1v-1h4v1h3v1h-5zm-9 70v-1h5v2h-3v-1zm-1-67h1v1h2v2h-1v1h-1v-2h-1zm-4 4v-1h1v-1h2v2zm11-5v-1h1v1zm5-1v1h-1v-1zm-6 5h-1v-1h1zm1 62h1v1h-1z",
    fill: "#e9e6e1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h2v-13h2v2h1v5h-1v5h-1v3h-1v-1h-1v1h-1zm12-86v-1h10v1zm-12 71h1v1h-2v-1zm3-67h1v1h-1zm-4 2v-1h1v1zm2 66h1v1h-1z",
    fill: "#e7e3e0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v-2h3v2h1v2h1v2h-4v-1h-1zm0-68h-2v-2h2zm6-2v-1h3v1zm8-3v-1h1v1zm-2 0h1v1h-1zm-1 2v-1h1v1zm-10 0v1h-1v-1zm9 0h1v1h-1zm-8 79h1v1h-1z",
    fill: "#eae6e3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 62v1h-1v-2h1zm4 1h-2v-1h2zm-2-11v-1h1v1zm-3 2h-1v-1h1zm1 2v-1h1v1zm3-1h1v1h-1zm-1 2h1v1h-1zm-3 3v-1h1v1zm2 5h1v1h-1zm2 1h1v1h-1zm-1 1v1h-1v-1zm-1 3v-1h1v1zm1 1v-1h1v1zm-5 1v-1h1v1zm12 0h-1v-1h1zm-9 1v-1h1v1zm4 0h-1v-1h1zm0 1v-1h1v1zm-3 0h1v1h-1zm4 1h1v1h-1zm-2 1v1h-1v-1zm-3 2v-1h1v1zm4 1h-1v-1h1zm5 2v1h-1v-1zm-4 1h1v1h-1zm1 2v-1h1v1zm2 0h1v1h-1zm0 2h-1v-1h1zm1 2h-1v-1h1zm-4 2h1v1h-1zm5 2h-1v-1h1zm-12 1h-1v-1h1zm1 0h1v1h-1zm11 2v-1h1v1z",
    fill: "#895d3a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 62h-1v-2h1v1zm-2 1h1v2h-1v-1zm6 11v-1h1v2h-1zm2 12h1v1h-2v-1zm-8-35v-1h1v1zm2 1v1h-1v-1zm-2 4v1h-1v-1zm-6 1h1v1h-1zm3 0h1v1h-1zm-2 6h-1v-1h1zm7 7h-1v-1h1zm-7 0h1v1h-1zm3 0h1v1h-1zm3 0v1h-1v-1zm-3 2h-1v-1h1zm7-1v1h-1v-1zm-3 1v1h-1v-1zm3 2h-1v-1h1zm-5 1h-1v-1h1zm1-1h1v1h-1zm-1 2v1h-1v-1zm0 2v-1h1v1zm-1 2v-1h1v1zm4 0v1h-1v-1zm2 0h1v1h-1zm-7 2v-1h1v1zm0 6h-1v-1h1zm1 2v-1h1v1zm1 1v-1h1v1zm5 0h1v1h-1zm5 3h1v1h-1z",
    fill: "#8a5e3b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67 108v-2h-1v-1h3v9h-1v-1h-1zm-1 13v-1h2v-1h1v2zm15-83v-2h2v1h-1v1zm-9 77h1v1h-2v-1zm-3 1v1h-2v-1h1zm6-71h-1v-1h1zm-9 1h-1v-1h1z",
    fill: "#edeae5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 122h-1v-3h-2v-2h1v-1h-1v-1h-1v-1h-1v-1h2v-1h-2v-2h4v5h1v1h-1v1h1v1z",
    fill: "#e4e3df"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-2h-1v-3h1v2h1zm-6-70v-1h5v1h-1zm-1 1v-1h1v3h-2v-2zm2 60h1v2h1v1h-2zm7 14h1v3h-1zm2 4v1h-1v-2h1zm5-84v1h-1v-1zm-9 3h-1v-1h1zm-2 66v1h-1v-1zm4 10v1h-1v-1z",
    fill: "#dbd7cb"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55v-1h1v-1h1v2zm3 33h2v1h-1v1h-1zm-4-35h1v1h-2v-1zm3 11h1v1h-2v-1zm5 16v1h-1v-2h1zm-3 5h-1v-2h1v1zm-4-28h-1v-1h1zm-1 0v1h-1v-1zm2 3v-1h1v1zm3 7v-1h1v1zm-5 2v-1h1v1zm3-1v1h-1v-1zm0 4h-1v-1h1zm3 1h-1v-1h1zm0 3h-1v-1h1zm-5 2v1h-1v-1zm2 2h-1v-1h1zm-1 4h-1v-1h1zm-5 6h1v1h-1zm7 2v-1h1v1zm3 0v-1h1v1z",
    fill: "#875b38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ece9e4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64 104h2v-1h1v1h1v1h-2v1h-1v2h-1v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 113h-1v-4h-1v-1h1v-1h1zm1-69v1h-3v-1h1zm-1 72v-3h1v3zm3-74v1h-1v-1zm-9 4h-1v-1h1zm3 0v-1h1v1zm4 57h1v1h-1zm-2 13h1v1h-1z"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1h1v1h1v-2h1v3h-3v1h-3v-3h1zm0 1h-1v1h1zM57 4v1h-3V4zm-5 1h-1V4h2v1zm10-1h1v1h-1zm16 9v1h-1v-1zm-60 7v-1h1v1zm52 1v-1h1v1zm-40 4h-1v-1h1zm13 3v1h-1v-1z",
    fill: "#131416"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31 106v-2h2v3h-1v-1zm0-66v1h-3v-1h1v-1h1v1zm-4 4h-1v-3h2v1h-1zm12 74h-1v-3h1v1zM29 43v-1h2v1h-1zm12 78v1h-1v-2h1zm1-83h-1v-1h1zm-8 70h-1v-1h1zm-2 0h1v1h-1zm3 0v1h-1v-1zm4 12v-1h1v1zm0 3h1v1h-1z",
    fill: "#d9d5ca"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24 76v-1h3v1zm5-19h2v1h-2zm-5 16v-1h2v1h-1zm-3-21h1v1h-1zm3 3v-1h1v1zm1 2h-1v-1h1zm2 1v1h-1v-1zm6 11v1h-1v-1zm-9 2h-1v-1h1zm4 0h1v1h-1zm4 2h-1v-1h1zm1 0v1h-1v-1zm-10 4v-1h1v1zm5 4h1v1h-1zm-1 1h1v1h-1zm-4 1v1h-1v-1zm-3 8v1h-1v-1zm18 3h-1v-1h1z",
    fill: "#8d613e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49 92v-2h2v1h-1v1zm-3-34v-2h1v2zm7-6h1v1h-1zm-1 6v-1h1v1zm1 3h-1v-1h1zm-4 2v-1h1v1zm-1 1v1h-1v-1zm2 2v-1h1v1zm5 3h-1v-1h1zm-4 2v-1h1v1zm0 2v1h-1v-1zm-2 1h1v1h-1zm-1 1v1h-1v-1zm5 2h1v1h-1zm-3 4h-1v-1h1zm1 6h1v1h-1zm2 3v1h-1v-1zm-3 5v1h-1v-1zm5 5v-1h1v1z",
    fill: "#a7714d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23 71v1h-3v-1zm4 9h2v1h-1v1h-1zm-7 4v-1h2v2h-1v-1zm3-31h1v1h-2v-1zm-2 23v-2h1v2zm8-24h1v1h-1zm-11 4v-1h1v1zm6-1v1h-1v-1zm2 4h1v1h-1zm-4 3v-1h1v1zm0 11h1v1h-1zm2 1h1v1h-1zm1 15h-1v-1h1z",
    fill: "#8f6340"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28 66v-1h2v1h-1zm4 3v-2h1v2zm1 17h-2v-1h2zm-8-30h1v1h-1zm5 2v1h-1v-1zm-3 3v1h-1v-1zm8 12h-1v-1h1zm-9 0h1v1h-1zm4 2v1h-1v-1zm-3 1h1v1h-1zm2 1v1h-1v-1zm-3 1h1v1h-1zm7 1h1v1h-1zm0 3v1h-1v-1zm1 2v1h-1v-1zm-6 9v-1h1v1zm7 0v-1h1v1zm-1 1v1h-1v-1z",
    fill: "#885c39"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h2v1h-3v-4h1zm3 4h-1v-3h1zm8-73h2v1h-2zm-5 2h-2v-1h2zm1 83v-2h1v2zm9-86v1h-1v-1zm-17 5v1h-1v-1zm-2 2v-1h1v1zm6 67h1v1h-1zm4 16v-1h1v1z",
    fill: "#dad6ca"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28 73h2v1h-3v-2h1zm2 0v-2h1v2zm-2-21h-1v-1h1zm-1 4v-1h1v1zm-2 2h1v1h-1zm1 5v-1h1v1zm4 0v1h-1v-1zm-1 4v1h-1v-1zm1 0h1v1h-1zm0 9h1v1h-1zm-1 6v-1h1v1zm4 1v-1h1v1zm2 5v1h-1v-1zm1 2v1h-1v-1zm1 2h1v1h-1zm-4 1h1v1h-1z",
    fill: "#865a37"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h1v3h-2v-1h1zm3 10v1h-2v-1h1zm-4-25v-1h1v1zm2 1v-1h1v1zm-3 2h-1v-1h1zm8 7h1v1h-1zm-5 2h1v1h-1zm5 5h1v1h-1zm-6 3v1h-1v-1zm6 0h1v1h-1zm-4 1v1h-1v-1zm7 0v1h-1v-1zm-13 2v-1h1v1zm9 5h-1v-1h1zm-7 0v1h-1v-1zm1 10v1h-1v-1z",
    fill: "#8b5f3c"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29 75v-1h3v1h-1zm0-18h-1v-1h2v1zm-3 4v-1h2v1h-1zm1-7v1h-1v-1zm-1 4h-1v-1h1zm1 0h1v1h-1zm1 6v-1h1v1zm4 4h-1v-1h1zm2 6h1v1h-1zm-5 3v-1h1v1zm0 2h-1v-1h1zm3 12v-1h1v1zm1 2h-1v-1h1zm2-1v1h-1v-1zm-8 1h1v1h-1zm8 0h1v1h-1z",
    fill: "#855936"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h-1v-4h1v1zm5-79v1h-3v-1zm-11 6v1h-3v-1zm6 79h1v2h-1v-1zm6-85v-1h1v1zm-10 3h1v1h-1zm-1 2h-1v-1h1zm1 64h-1v-1h1zm0 2v-1h1v1zm2 0v1h-1v-1zm1 4h-1v-1h1z",
    fill: "#dedace"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74 66v-1h3v1h-1zm1-9v1h-2v-1h1zm-1 27v-2h1v2zm4-30v-1h1v1zm-7 3v-1h1v1zm1 2h-1v-1h1zm1 0h1v1h-1zm-1 1h1v1h-1zm2 1h1v1h-1zm2 9v-1h1v1zm-6 3h1v1h-1zm7 1v1h-1v-1zm-2 3h-1v-1h1zm-4 2v-1h1v1zm4-1h1v1h-1z",
    fill: "#c28d61"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#eae7e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 44h1v-1h1v2h-1v1h-2v-1h1zm4 65h-1v-3h1v2h2v1h-1zm4 7h-1v1h-1v-2h2zm-5-72h2v1h-2zm2 61v1h-1v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 107h-1v-1h1zm-3 18h-1v-1h1z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M74 63v-1h1v-1h1v2zm1-11h-1v-1h1zm-1 4v-1h1v1zm-4 2h1v1h-1zm0 6h-1v-1h1zm3 0v-1h1v1zm-1 0h1v1h-1zm3 1h-1v-1h1zm-7 2v-1h1v1zm2 10v-1h1v1zm6 1v-1h1v1zm-3 1v1h-1v-1zm1 1v-1h1v1zm-1 4v-1h1v1zm-1 1v-1h1v1zm2 0h1v1h-1z",
    fill: "#c08b5f"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21 57v-1h2v1h-1zm6-4h-1v-1h1zm-3 4v1h-1v-1zm0 5h1v1h-1zm3 1v1h-1v-1zm-1 4v1h-1v-1zm2 2v-1h1v1zm-4 1h1v1h-1zm1 3v1h-1v-1zm-1 1v1h-1v-1zm4 2v-1h1v1zm2 2h-1v-1h1zm2 6h1v1h-1zm-8 5h-1v-1h1zm10 0h1v1h-1zm-10 2v1h-1v-1zm16 1v1h-1v-1z",
    fill: "#8e623f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51 64v1h-1v-2h2v1zm6-11v1h-1v-2h1zm3 1h-2v-1h2zm-9 5h1v2h-1v-1zm-3 12v-1h2v1h-1zm5-17h-1v-1h1zm-2 2v-1h1v1zm7-1h1v1h-1zm-5 7h1v1h-1zm-5 19h1v1h-1zm3 1v-1h1v1zm-1 3h-1v-1h1z",
    fill: "#ac7652"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v-1h1v-1h1v2zm1 16v-3h1v3zm7-34h1v1h-1zm-7 2v-1h1v1zm5 1h1v1h-1zm-9 1h1v1h-1zm5 1h-1v-1h1zm-1 1v1h-1v-1zm2 8h-1v-1h1zm-3 0h1v1h-1zm3 13h-1v-1h1zm-3 2v-1h1v1zm2 5h1v1h-1zm4 5v1h-1v-1z",
    fill: "#aa7450"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62 94v-1h2v1h1v1h-2v-1zm-2-35v2h-1v-1h-1v-1zm3-5v2h-1v-2zm-2 3h-1v-1h1zm-3 0h1v1h-1zm4 1h-1v-1h1zm3 0h1v1h-1zm1 3h-1v-1h1zm-11 6v-1h1v1zm4 2v-1h1v1zm2 9h-1v-1h1zm2 12h-1v-1h1z",
    fill: "#b47e58"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M36 15h1v1h3v2h-3v1h-1zm2 15v-1h2v2h-1v-1zm39-9h-1v-1h1zm-7 0h1v1h-1zm-36 9h1v1h-1zm2 1v-1h1v1z",
    fill: "#0b0c0e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58 110h3v2h-3zm20-73h-2v-1h2zm-25 7h-2v-1h2zm2 62h-1v-1h2v1zm3 17v2h-1v-2zm-4-16h1v1h-1zm1 1h1v1h-1zm4 10h-1v-1h1z",
    fill: "#e8e4e1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40h1v-1h1v2h-2zm-1 69v-1h-1v-1h2v2zm-7-66v1h-1v-2h1zm11 72h1v2h-1v-1zm3-77v-1h1v1zm2 0v-1h1v1zm-4 1v-1h1v1zm-11 6h-1v-1h1zm9 70v-1h1v1zm1 4v-1h1v1zm1 1v-1h1v1z",
    fill: "#dad6cb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117v-4h1v1h1v3zm-6-72v-2h1v-1h1v1h1v1h-1v1zm10-5h-1v-1h1zm-6 2h-1v-1h1zm-5 3v1h-1v-1zm3 63v-1h1v1z",
    fill: "#dfdbcf"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#dad3c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 111h1v2h-1v1h-1v-2h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 110v1h-1v1h-1v-2zm-8-7h2v1h-2zm9 11v-1h1v2h-1zm2 3h-1v-2h1v1zM24 41v-1h1v1zm0 2v-1h1v1zm6 60h1v1h-1zm-1 2v-1h1v1z"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29 60h1v2h-1v-1zm-3 5h1v2h-1v-1zm1-13h1v1h-1zm1 6h-1v-1h1zm-1 2v-1h1v1zm5 8v1h-1v-1zm-4 3v1h-1v-1zm-4 3h-1v-1h1zm2 0h-1v-1h1zm-3 1h-1v-1h1zm-2 2v-1h1v1zm3 2v1h-1v-1zm3 1v1h-1v-1zm-4 11v-1h1v1zm9 2h-1v-1h1z",
    fill: "#8c603d"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33 65v-1h1v-1h1v2zm-2-11v-2h1v2zm2 0h1v1h-1zm1 3v1h-1v-1zm-3 4v-1h1v1zm2 7v-1h1v1zm5 5v-1h1v1zm-2 0h1v1h-1zm-1 5h-1v-1h1zm3-1v1h-1v-1zm-1 2h-1v-1h1zm1 11v1h-1v-1zm0 6v-1h1v1zm0 1h-1v-1h1z",
    fill: "#875937"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M32 82h-1v-1h-1v-1h2zm-3-28h-1v-1h1zm2 10h-1v-1h1zm-3 0h1v1h-1zm2 3v1h-1v-1zm0 4h-1v-1h1zm4 1v1h-1v-1zm-1 12v-1h1v1zm2 2h-1v-1h1zm-4 1v-1h1v1zm2-1h1v1h-1zm2 4v1h-1v-1zm-8 3v1h-1v-1zm5 0v1h-1v-1zm2 4v-1h1v1z",
    fill: "#845835"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h2v1h-1zM18 3h1v1h-1zm15 4V6h1v1zm-4 4v-1h1v1zm48 1h-1v-1h1zm-61 1h1v1h-1zm10 0v1h-1v-1zm51 11h-1v-1h1zm-5 2h-1v-1h1zm-33 0v1h-1v-1zm2 1h-1v-1h1zm25 0v-1h1v1zm3-1v1h-1v-1zm-27 1v1h-1v-1zm9 1v-1h1v1z",
    fill: "#262729"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v3h-1v-3zm6 1v-2h1v2zM58 5h-1V4h1zm1 0V4h1v1zm17-1v1h-1V4zM19 18h-1v-1h1zm63 0h-1v-1h1zm-10 2h-1v-1h1zm-54 1v1h-1v-1zm45 2h-1v-1h1zm21 0v-1h1v1zm-56 5v1h-1v-1zm16 0v1h-1v-1z",
    fill: "#151618"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31h-1v-1h-1v1h-1v-1h-1v-1h4zm-5-3v2h-1v-1h-1v-1zm41-6v-2h1v2zm-33-7v1h-1v-1zm-23 5h-1v-1h1zm50 2v1h-1v-1zm-16 2h-1v-1h1zm-12 6v-1h1v1z",
    fill: "#0c0d0f"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M44 123v-3h1v2h1v1zm1-8h1v3h-1v-1zm-4-72v1h-1v-2h1zm10-6h1v1h-1zm-1 2v-1h1v1zm-7 4v-1h1v1zm-1 0h1v1h-1zm-3 3h-1v-1h1zm4 64h-1v-1h1zm3 15v1h-1v-1z",
    fill: "#e0dcd1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34 43h-1v-1h4v1zm8 71v3h-1v-3zm-4-9v2h-1v-2zm1 5h1v2h-1v-1zm4 9v1h-1v-2h1zM29 45h1v1h-1zm2 1v-1h1v1zm8 62v1h-1v-1z",
    fill: "#dcd8cc"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h-2v-1h2zm-1 29v2h-1v-2zm8-39h-1v-1h1zm-5 5v1h-1v-1zm-7 3h-1v-1h1zm6 0h-1v-1h1zm-4 0v1h-1v-1zm-3 9h-1v-1h1zm1-1h1v1h-1zm0 2v1h-1v-1zm0 5h-1v-1h1zm0 4v-1h1v1zm1 9v-1h1v1zm1 2h1v1h-1z",
    fill: "#b7815b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1zm-7 6h1v1h-1zm3 3h1v1h-1zm0 2h-1v-1h1zm3 1h1v1h-1zm1 2v1h-1v-1zm-3 7v-1h1v1zm-1 3v-1h1v1zm0 1v1h-1v-1zm1 0h1v1h-1zm0 2v1h-1v-1zm-2 1h1v1h-1zm2 0h1v1h-1zm-3 2v-1h1v1zm3 1h1v1h-1zm-1 2h-1v-1h1z",
    fill: "#c18c60"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77v2h-1v-2zm-1-21v1h-1v-1zm1 3h1v1h-1zm3 3h-1v-1h1zm-2 0h1v1h-1zm-1 1v1h-1v-1zm-1 4v-1h1v1zm2 0h1v1h-1zm3 0h1v1h-1zm-4 2v-1h1v1zm0 2h1v1h-1zm2 7v-1h1v1zm0 4v1h-1v-1zm-1 4h1v1h-1zm0 5v-1h1v1z",
    fill: "#a6704c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v2h-1zm10 1h-2v-1h2zm1 2v1h-1v-2h1zm1 4h-2v-1h2zm7-22h1v1h-1zm-9 14h1v1h-1zm-10 4v-1h1v1zm-1 0h1v1h-1zm9 3h1v1h-1zm41 5h1v1h-1zm-3 2h-1v-1h1z",
    fill: "#0d0d0d"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23v-1h3v1zm19 1v-1h3v1zm-12-8v-1h2v1h-1zm8 1v-1h2v1h-1zM62 3h-1V2h1zm-6 0h1v1h-1zm4 1V3h1v1zM35 21v1h-1v-1zm9 0h1v1h-1z",
    fill: "#0c0c0c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M80 15h-1v-1h-1v-1h2zm-2 0v1h-1v-2h1zm0 3h1v1h-2v-1zm-5 2v-1h2v1h-1zM63 4h1v1h-1zm3 1h-1V4h1zM37 15h-1v-1h1zm42 1v1h-1v-1zm7 5h1v1h-1zm-58 8v-1h1v1z",
    fill: "#121315"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27 110v1h1v1h-4v-3h1v1zm-4-2v2h-2v-2zm31-75h1v1h-1zm-27 82h-1v-1h1zm7 8v1h-1v-1z",
    fill: "#d1cec5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M84 34v-1h1v2h-2v-1zm-5 8v1h-1v-2h1zm-8 2v1h-2v-1h1zm1 63h-1v-2h1v1zm2 0v2h-1v-2zm3-65v1h-1v-1zm-3 69h-1v-1h1zm-3 0h1v1h-1zm1 7v1h-1v-1z",
    fill: "#ebeae6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47v1h-1v-1zm7 3v1h-1v-1zm-5 2v-1h1v1zm0 1v1h-1v-1zm-1 2h-1v-1h1zm2 0v-1h1v1zm4 0h-1v-1h1zm-6 5h-1v-1h1zm9-1v1h-1v-1zm2 11v-1h1v1zm-8 2h1v1h-1zm0 9v-1h1v1zm-1 1v-1h1v1zm8 2v1h-1v-1zm-10 1h1v1h-1z",
    fill: "#906441"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-2v-1h2zm-2-9v-1h1v1zm0 7v-1h1v1zm0 5h-1v-1h1zm1-1h1v1h-1zm2 10v-1h1v1zm4 3v-1h1v1zm0 2h-1v-1h1zm-2 1v-1h1v1zm-4 1v1h-1v-1zm4 2v-1h1v1zm1 7h-1v-1h1zm2 8v-1h1v1zm-1 0h1v1h-1z",
    fill: "#8b5d3b"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v2h-1v-1zm1 5v-1h1v2h-1zm-1 2v2h-1v-2zm0-4h1v1h-1zm-5 5v1h-1v-1zm7 1v-1h1v1zm-1 1h1v1h-1zm-6 3h1v1h-1zm-2 11v1h-1v-1zm11 0v1h-1v-1zm-3 1h1v1h-1zm1 17v1h-1v-1z",
    fill: "#b8825c"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51 59v-2h1v2zm2-7v1h-1v-1zm-3 1v1h-1v-1zm4 1v-1h1v1zm-2 1h-1v-1h1zm-3 5h1v1h-1zm-2 2h-1v-1h1zm5 0h-1v-1h1zm1 6h-1v-1h1zm0 2v1h-1v-1zm-2 9h-1v-1h1zm0 2v1h-1v-1zm-1 11v1h-1v-1zm3 5v1h-1v-1z",
    fill: "#a8724e"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h2v1h-2zm1-11h-1v-1h1zm-2 4v1h-1v-1zm2 2v-1h1v1zm0 2h-1v-1h1zm-1 0v1h-1v-1zm5 0v1h-1v-1zm-6 4h-1v-1h1zm2 8v-1h1v1zm3 3v1h-1v-1zm1 2v1h-1v-1zm-4 11v1h-1v-1zm1 4h-1v-1h1zm-1 3v-1h1v1z",
    fill: "#a46e4a"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48 61h-1v-1h2v1zm2 0h1v1h-2v-1zm0-7h1v1h-1zm-3 5v-1h1v1zm1 4h1v1h-1zm-1 3v-1h1v1zm1 1v-1h1v1zm2 1v1h-1v-1zm-2 1v1h-1v-1zm3 19h1v1h-1zm-2 3v1h-1v-1zm4 0v1h-1v-1zm4 5v1h-1v-1z",
    fill: "#a56f4b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17h1v3h1v1h-2zM62 3V2h2v1h-1zM44 15v1h-2v-1h1zM23 4v1h-1V4zm10 13h-1v-1h1zm0 3h-1v-1h1zm2 4h-1v-1h1zm21-1h1v1h-1z",
    fill: "#0f0f0f"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v-1h2v-1h1v2zm-3 2v2h-1v-2zm-2 3v-1h1v2h-1zm4-14h1v1h-1zm0 9v1h-1v-1zm-6 7h1v1h-1zm-3 3h1v1h-1zm-37 1h1v1h-1zm0 6h1v1h-1z",
    fill: "#191a1c"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v2h-2v-1h-1v-1zm2-68v2h-1v-2zm-4 3v-1h2v1h-1zm21-8h1v1h-1zm-6 1v1h-1v-1zm-7 2h1v1h-1zm-9 69v1h-1v-1zm5 15h1v1h-1z",
    fill: "#e6e2df"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37v2h-1v-1h-2v2h-1v-3zm-19 6v-1h2v1h-1zm7 74h1v2h-1v-1zm-4-75h-1v-1h1zm-8 3v-1h1v1zm10 69h1v1h-1z",
    fill: "#e9e5e2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52v2h-1v-1h-1v-1zm4-2h1v1h-1zm-8 6v-1h1v1zm-2 6v1h-1v-1zm-5 8h-1v-1h1zm5 0v-1h1v1zm-1 1v-1h1v1zm-2 4v-1h1v1zm3 3v-1h1v1zm-3 3v-1h1v1zm0 2v-1h1v1zm11 13v1h-1v-1z",
    fill: "#b07a56"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M54 71h-1v-2h1v1zm6-20v1h-1v-1zm-6 10v1h-1v-1zm-6 1h1v1h-1zm2 1v-1h1v1zm3 1v1h-1v-1zm-4 3h1v1h-1zm1 17h1v1h-1zm3 1h-1v-1h1zm-3 0v1h-1v-1zm12 1h-1v-1h1zM48 97h1v1h-1zm5 0h1v1h-1z",
    fill: "#a9734f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M49 68v1h-2v-1h1zm1-12h-1v-1h1zm-2 1h1v1h-1zm0 3h-1v-1h1zm-2 2h1v1h-1zm2 2h1v1h-1zm0 10h1v1h-1zm0 12h-1v-1h1zm-2 3v1h-1v-1zm3 0h1v1h-1zm0 4h-1v-1h1zm-3 1h1v1h-1zm1 2v1h-1v-1z",
    fill: "#a16b47"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h3v1h-3zm4-1h2v1h-2zM15 3h1v1h-1zm20 2h1v1h-1zm17 0h1v1h-1zM33 7v1h-1V7zM20 9h-1V8h1zm-4 16v-1h1v1zm60 1v1h-1v-1zm-27 2v-1h1v1z",
    fill: "#252628"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26h1v1h-2v-1zm6 2h-1v-1h2v1zM72 5V4h1v1zM18 24v1h-1v-1zm59 1v-1h1v1zm-48 2h-1v-1h1zm12-1h1v1h-1zm4 1v-1h1v1zm33 0v-1h1v1zm-27 0v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#242527"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M45 36v1h-4v-1h1zm-30 4v-1h2v1h-1zm15 66v1h-1v-2h1zm7 10v1h-1v-2h1zM25 40h-1v-1h1zm-2 1v-1h1v1zm11 72h-1v-1h1z",
    fill: "#d9d2c8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39 113h1v1h1v2h-1v-1h-1v-1zm2-74v-1h3v1zm-1 79v-1h1v2h-1zm11-82v1h-1v-1zM22 98v1h-1v-1zm17 14v1h-1v-1zm1 13h1v1h-1z",
    fill: "#dbd7cc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109v2h-1v-2zm1 2v2h-1v-2zm-3 10v-1h1v2h-1zm16-84h-1v-1h1zm-2 0v1h-1v-1zm-1 1v1h-1v-1zm-2 2h-1v-1h1zm-1 0v1h-1v-1zm-4 1h1v1h-1zm-4 77v1h-1v-1z",
    fill: "#ebe7e4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-3v2h-1v-3h4zm11-6v-1h1v1zm-9 3v1h-1v-1zm0 68h1v1h-1zm1 4v-1h1v1zm1 0h1v1h-1zm2 5h-1v-1h1zm0 7h1v1h-1z",
    fill: "#ddd9cd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1zm-2 0h1v1h-1zm0 2v1h-1v-1zm1 1v1h-1v-1zm1 4v1h-1v-1zm-2 2v-1h1v1zm2 3h-1v-1h1zm5 8h1v1h-1zm2 0h1v1h-1zm-4 5v1h-1v-1zm-4 2v-1h1v1zm4 10v1h-1v-1zm2 9v-1h1v1z",
    fill: "#8a5c3a"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55v3h-1v-3zm2 21v1h-1v-2h2v1zm-4-22v-1h1v1zm-1 1v-1h1v1zm-1 1h1v1h-1zm1 3h1v1h-1zm4 21v-1h1v1zm2 5v1h-1v-1zm1 10h-1v-1h1z",
    fill: "#885a38"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-2h1v2zm-4 9v1h-1v-2h1zm3-13v-1h1v1zm-4 2v1h-1v-1zm3 1v-1h1v1zm-3 7v1h-1v-1zm0 5h-1v-1h1zm-5 14v-1h1v1zm9 1v1h-1v-1zm4 12v-1h1v1zm1 2h1v1h-1z",
    fill: "#b37d57"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h-1v-2h1v1zm-1 36v-2h1v2zm-1-41h-1v-1h1zm6 2h-1v-1h1zm-5 7h-1v-1h1zm-1 3v-1h1v1zm2 13v-1h1v1zm1 2h-1v-1h1zm-2 0h1v1h-1zm0 3v-1h1v1zm0 13h1v1h-1z",
    fill: "#a36d49"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1zm-7 0v1h-1v-1zm-1 2h1v1h-1zm6 5h-1v-1h1zm-4 6h1v1h-1zm2 1h1v1h-1zm-3 4h-1v-1h1zm3 5v1h-1v-1zm0 1h1v1h-1zm2 2h-1v-1h1zm-2 5h-1v-1h1zm8-1h1v1h-1zm-1 14v-1h1v1z",
    fill: "#af7955"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1zm1 2h1v1h-1zm-2 4h1v1h-1zm0 2v1h-1v-1zm0 5v1h-1v-1zm2 8h-1v-1h1zm3 3h-1v-1h1zm-2 1v-1h1v1zm-2 11v1h-1v-1zm-1 2h-1v-1h1zm3 0v-1h1v1zm-2 2h-1v-1h1zm5 4v1h-1v-1z",
    fill: "#a06a46"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M46 27v1h-3v-1zm24-1h1v1h-2v-1zM49 3v1h-1V3zm26 0v1h-1V3zM57 6h-1V5h1zM17 8h1v1h-1zm0 10v1h-1v-1zm1 2h1v1h-1zm18 7v-1h1v1z",
    fill: "#28292b"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-3v-1h3zm40-2v2h-1v-2zM61 4v1h-1V4zm14 14v-1h1v1zm6 0h-1v-1h1zm-8 2h-1v-1h1zm-6 2v-1h1v1zm-39 1v1h-1v-1zm1 7h1v1h-1z",
    fill: "#141517"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20h1v1h-2v-1zM31 6h1v1h-1zm2 3V8h1v1zM19 9h1v1h-1zm-1 4v-1h1v1zm-5 6h-1v-1h1zm-5 0v1H7v-1zm59 0h1v1h-1zm-48 2v-1h1v1zm-3 1h-1v-1h1zm14 5h-1v-1h1z",
    fill: "#232426"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9h-2V8h2zM21 25h1v1h-2v-1zM77 6h1v1h-1zm-60 9v1h-1v-1zm52 1h1v1h-1zm16 6v-1h1v1zm-59 3v-1h1v1zm3 0h1v1h-1zm-2 2h1v1h-1zm6 0h1v1h-1z",
    fill: "#1f2022"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17v2h-1v1h-1v-4h2zm-15-2h1v1h-1zm13 1h-1v-1h1zm-12 2v1h-1v-1zm3 6v-1h1v1zm42 5v1h-1v-1z",
    fill: "#101010"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34 29v1h-1v-2h4v1zm36-7h1v1h-2v-2h1zm10-4h1v1h-1zm-7 2h1v1h-1zM42 30h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#0d0e10"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h-1v-1h2v1zm8-41h1v1h-1zm-2 3h-1v-1h1zm-4 2h-1v-1h1zm-2 2h1v1h-1zm4 3v-1h1v1zm-5 13h-1v-1h1zm-1 2v-1h1v1zm4 14h-1v-1h1zm3 4h-1v-1h1zm-2 1v1h-1v-1z",
    fill: "#b6805a"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M55 75h-1v-2h1v1zm-3-23h-1v-1h1zm2 2h-1v-1h1zm0 8v-1h1v1zm5 1v1h-1v-1zm-11 6h1v1h-1zm5 13h-1v-1h1zm1 0v-1h1v1zm-1 7v1h-1v-1zm1 1v1h-1v-1zm2 6v-1h1v1z",
    fill: "#ae7854"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h2v1h-1v1h-1zm4-26h1v1h-1zm-2 4v1h-1v-1zm2 9h-1v-1h1zm1 0h1v1h-1zm-8 8v1h-1v-1zm2 2v1h-1v-1zm-3 8v-1h1v1zm5-1v1h-1v-1zm0 5v1h-1v-1z",
    fill: "#bf8a5e"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v-1h1v2h-1zm-1 15h-1v-2h1v1zm6-22v-1h1v1zm-1 0h1v1h-1zm2 0h1v1h-1zm-3 6h-1v-1h1zm2 19v1h-1v-1zm-5 2h-1v-1h1zm-1 1h-1v-1h1zm4 5v-1h1v1z",
    fill: "#ba8559"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h-1v-1h1zm1 1v-1h1v1zm-2 11v1h-1v-1zm2 13v1h-1v-1zm-1 5v-1h1v1zm0 1h1v1h-1zm-3 3h1v1h-1zm3 1v-1h1v1zm0 2h-1v-1h1zm1 2v1h-1v-1zm-2 2v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#9f6945"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1zm-11 4v-1h1v1zm5 1h1v1h-1zm-2 2v-1h1v1zm0 7v-1h1v1zm-2 3h-1v-1h1zm2 0v-1h1v1zm6 3h-1v-1h1zm-3 2v-1h1v1zm-1 10v-1h1v1zm-4 11v-1h1v1zm18 1v1h-1v-1z",
    fill: "#ab7551"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0v1h-1V0zm48 3V2h1v1zM9 34H8v-1h1zm77 11h1v1h-1zm-1 7h1v1h-1zm-75 6h1v1h-1zm70 31v-1h1v1zm-66 0v1h-1v-1zm3 15h1v1h-1zm57 17v1h-1v-1zm-4 3v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h1v2h-1v-1zM18 2V1h1v1zm47 0v1h-1V2zM46 13v-1h1v1zm-14 2v-1h1v1zm14 0v1h-1v-1zm1 5h1v1h-1zm2 1v1h-1v-1zm-25 2h-1v-1h1zm21 8v1h-1v-1z",
    fill: "#121212"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M71 4h1v1h-1zM28 7h-1V6h1zm-5 1h-1V7h1zm-3 14v1h-1v-1zm-3 1v1h-1v-1zm18 4v-1h1v1zm3-1v1h-1v-1zm30 1h-1v-1h1zm-26 0h1v1h-1zm6 0v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#27282a"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10v1h-1V9h1zm41-5v1h-1V5zM21 7V6h1v1zm-5 6v-1h1v1zm8 0v1h-1v-1zm35 1v1h-1v-1zm8 6h-1v-1h1zM7 26h1v1H7zm66 1v-1h1v1zm-46 2v1h-1v-1z",
    fill: "#2b2c2e"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M17 23h-1v-1h2v1zM47 7V6h1v1zm30 0h1v1h-1zm-56 8v1h-1v-1zm-2 4v-1h1v1zm-8 3v-1h1v1zm64 1v-1h1v1zm-8 5v-1h1v1zm5 0v-1h1v1zm3 0v1h-1v-1z",
    fill: "#393a3c"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-2v-1h1v-2h1zm9-3v1h-1v-1zm1 1v1h-1v-1zm-68 1h1v1h-1zm4 1h1v1h-1zm52 0v1h-1v-1zM45 29h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#17181a"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v-2h2v-1h2v1h-1v2zm-8 3v-1h1v-1h1v2z",
    fill: "#e9e6df"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41h1v1h1v1h-2zm11 62h1v1h-2v-1zm7 18v-1h1v2h-1zm-11-16h-1v-1h1zm4 2h-1v-1h1zm1 2v1h-1v-1zm5 9h1v1h-1z",
    fill: "#d8d4c9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23 77h1v1h-2v1h-2v-1h1v-1h1zm-4-27h-1v-1h1zm5 1h-1v-1h1zm-2 8v-1h1v1zm-1 22v-1h1v1zm5 2v-1h1v1zm-3 3h-1v-1h1z",
    fill: "#916443"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v-1h-1v-1h2v2zm-2-40h-1v-1h1zm2 1h-1v-1h1zm-2 3h-1v-1h1zm-8 1h1v1h-1zm1 10v-1h1v1zm-1 17h1v1h-1zm3 8v1h-1v-1zm8 1v1h-1v-1z",
    fill: "#b27c56"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h2v1zm4-9v1h-1v-1zm-2 6h-1v-1h1zm2-1v1h-1v-1zm-1 1v1h-1v-1zm3 2h-1v-1h1zm-8 5v1h-1v-1zm-1 3h1v1h-1zm1 21v1h-1v-1zm3 4v-1h1v1z",
    fill: "#b9835d"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M75 59h1v2h-1v-1zm-1-6v-1h1v1zm4 0v1h-1v-1zm-2 2v1h-1v-1zm-2 3h1v1h-1zm-3 4v-1h1v1zm6 0v-1h1v1zm0 3h-1v-1h1zm0 8v-1h1v1zm-3 4h-1v-1h1z",
    fill: "#c38e62"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65h1v1h-2v-1zm4 9v1h-2v-1h1zm-2-17h-1v-1h1zm3 0h-1v-1h1zm-4 5v1h-1v-1zm3 0h1v1h-1zm1 3v1h-1v-1zm-2 15h1v1h-1zm1 4h1v1h-1z",
    fill: "#be895d"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M27 83v3h-1v-3zm-4-14h-1v-2h1v1zm2 7v1h-1v-1zm3 10v-1h1v1zm0 2v-1h1v1zm1 1v1h-1v-1zm1 1v1h-1v-1zm-7 1v1h-1v-1z",
    fill: "#8a5d3c"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M59 4v1h-1V4zm2 1V4h1v1zM33 5h1v1h-1zm48 11v-1h1v1zm-62 1h-1v-1h1zm-3 3v-1h1v1zm54 1h-1v-1h1zm9 3v-1h1v1zm-48 6h-1v-1h1zm44-1h1v1h-1z",
    fill: "#161719"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M74 5h-1V4h1zM17 15h-1v-1h1zm57 7v1h-1v-1zm3 2v-1h1v1zm-57 0v1h-1v-1zm33 3h-1v-1h1zm-19 1v-1h1v1zm44 1h-1v-1h1zm-50 0h1v1h-1zm22 0v1h-1v-1z",
    fill: "#202123"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17h1v3h-1v-1zM22 6h1v1h-1zm57 0v1h-1V6zM32 7v1h-1V7zm40 6v-1h1v1zm-19 8v-1h1v1zm5 1v1h-1v-1zm-10 3h1v1h-1z",
    fill: "#1b1b1d"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28h1v-1h1v1h1v1h-3zM35 9h-1V8h1zm-4 0h1v1h-1zm35 9v1h-1v-1zm-2 1h1v1h-1zm-6 2h1v1h-1zm4 1v-1h1v1z",
    fill: "#3a3b3d"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19v-1h2v1h-1zm1-9V9h1v1zm0 2h-1v-1h1zm5 3h-1v-1h1zm41-1h1v1h-1zm-44 2v1h-1v-1zm-2 6h1v1h-1zm56 2v-1h1v1zm6 1h1v1h-1z",
    fill: "#2f3032"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v-1h1v5h-1zm-20-4v-1h1v1zm49-1v1h-1v-1zm-7 3h-1v-1h1zm-1 8v-1h1v1zm-24 3h-1v-1h1z",
    fill: "#171719"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M48 21v-2h1v-1h1v3zm1-4v-1h2v1h-1zm-1-4h-1v-1h1zm1 2v1h-1v-1zm-27 8v-1h1v1z",
    fill: "#141414"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21h1v1h-2v-1zm11 10h1v1h-2v-1zm-8-13v-1h1v1zm1 3h-1v-1h1zm7-1v1h-1v-1zm-13 2h-1v-1h1zm0 1v-1h1v1zm54 5h1v1h-1z",
    fill: "#090909"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41h1v1h-4v-1zm8-3v-1h2v1h-1zm9-2h1v1h-1zm-23 6v-1h1v1zm11 69v-1h1v1zm1 0h1v1h-1z",
    fill: "#d9d5c9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M60 117h-1v-4h1v1zm2-80h1v1h-1zm-7 5v-1h1v1zm-1 0h1v1h-1zm0 65v1h-1v-1zm-1 17h1v1h-1zm0 1v1h-1v-1z",
    fill: "#e7e4df"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1zm3 1v-1h1v1zm-5 20v-1h1v1zm2 10v-1h1v1zm4 4v-1h1v1zm-5 0h1v1h-1zm-6 6v-1h1v1zm10 0h-1v-1h1zm-1 3v-1h1v1zm2 1h-1v-1h1z",
    fill: "#835734"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73 49v1h-1v-1zm-6 6v1h-1v-1zm0 14v1h-1v-1zm1 9v1h-1v-1zm-8 4h1v1h-1zm6 1v1h-1v-1zm-1 3v1h-1v-1zm3 2v1h-1v-1zm5 3v-1h1v1zm-2 1h1v1h-1z",
    fill: "#bb865d"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1zm-2 3v-1h1v1zm-4 9v-1h1v1zm0 11h-1v-1h1zm2 4v-1h1v1zm-2 2h-1v-1h1zm-3 2h1v1h-1zm6 8v1h-1v-1zm-4 2v1h-1v-1zm6 2h1v1h-1z",
    fill: "#ad7753"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M69 76v-2h1v2zm7-24h-1v-1h1zm0 1v1h-1v-1zm-3 2v-1h1v1zm-3 3v-1h1v1zm2-1h1v1h-1zm0 2v1h-1v-1zm-1 21h-1v-1h1zm3 0v1h-1v-1z",
    fill: "#bd885c"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62v1h-2v-2h1v1zm5 13h-2v-1h1v-1h1zm-4-21h-1v-1h1zm0 5v1h-1v-1zm-3 19v-1h1v1zm7 19h-1v-1h1z",
    fill: "#895b39"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67h1v1h-2v-1zm-2 2h1v2h-1v-1zm3 10h2v1h-2zm-3-26h1v1h-1zm1 3h-1v-1h1zm3 14v1h-1v-1zm1 30v-1h1v1z",
    fill: "#8c5b3a"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1zm0 8h1v1h-1zm2 1h1v1h-1zm-2 1v1h-1v-1zm0 4h-1v-1h1zm2 1h-1v-1h1zm0 18v1h-1v-1zm2 7v-1h1v1zm-2 1h1v1h-1zm2 3v-1h1v1z",
    fill: "#8e5d3c"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63v1h-1v-2h1zm-6-7v-1h1v1zm3 5h-1v-1h1zm-3 1v1h-1v-1zm0 3h1v1h-1zm6 2v1h-1v-1zm-7 9h-1v-1h1zm3 0v-1h1v1zm-3 3h-1v-1h1z",
    fill: "#c48f63"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M59 73v-1h1v2h-1zm9-14h-1v-1h1zm-4 9v1h-1v-1zm-2 5v1h-1v-1zm1 2h-1v-1h1zm1 3v-1h1v1zm-1 5h1v1h-1zm-3 5v-1h1v1zm6 1h1v1h-1z",
    fill: "#be8961"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31 95v-1h2v1h-1zm3-19h-1v-1h1zm-1 10v1h-1v-1zm0 2v-1h1v1zm0 2h-1v-1h1zm2 4v1h-1v-1zm-1 2h-1v-1h1zm-2 1v-1h1v1zm-3 2h-1v-1h1z",
    fill: "#805431"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M23 109h1v3h-3v-2h2zm3 3h1v2h-1v-1zm1 3v1h-1v-1z",
    fill: "#d0cdc4"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7h-1V5h1v1zm13-2v1h-1V5zm-16 6v1h-1v-1zm6 4h1v1h-1zm52 8h-1v-1h1zm-56 0v1h-1v-1zm56 2v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#2c2d2f"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6h-1V5h1zM27 7h1v1h-1zm1 5h1v1h-1zm26 2h1v1h-1zm0 3h-1v-1h1zm0 2v1h-1v-1zm1 2v1h-1v-1zm23 1h-1v-1h1zm-20 1v-1h1v1z",
    fill: "#1d1d1f"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h2v1h-1zm6 0h-1v-1h1zm-6 2v1h-1v-1zm-2 3v-1h1v1zm13 0h-1v-1h1zm-8 3v1h-1v-1zm-12 2h1v1h-1zm-18 5v1h-1v-1z",
    fill: "#18191b"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h2v4h-1zm-19 0v-3h1v3zm19-2h-1v-1h1z",
    fill: "#151515"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M17 37h-1v-1h2v1zm15 73v2h-1v-2zM22 38h-1v-1h1zm-9 1v1h-1v-1zm5 1v-1h1v1zm2 0v-1h1v1zm6 65v-1h1v1z",
    fill: "#d5d3c7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v-1h1v2h-4v-1zm-2 75v-2h1v2zm-4-75v1h-1v-1zm9 79h-1v-1h1z",
    fill: "#d4d0c5"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M64 120v-1h1v-1h1v2zm1-9v-2h1v2zm14-75h1v1h-1zm-2 1h1v1h-1zm-3 2h1v1h-1zm-4 4v-1h1v1z",
    fill: "#ece8e5"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h3v1zm-9-1h1v2h-1v-1zm16 0v1h-1v-1zm-11 3h-1v-1h1zm10 68v1h-1v-1zm5 9h1v1h-1z",
    fill: "#d7d3c8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-2v-1zm0 72v-2h1v2zm3 0v2h-1v-2zM22 39v1h-1v-1zm7 67h-1v-1h1zm7 12h1v1h-1z",
    fill: "#d6d2c7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M45 120h-1v-3h1v1zm2-81h1v1h-1zm-1 1h1v1h-1zm-6 3h-1v-1h1zm5 71h-1v-1h1zm0 1v-1h1v1zm-1 9h1v1h-1z",
    fill: "#e0dcd0"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42h-3v-1h3zm-1 75v-3h1v3zm-3-8h2v1h-2zm1-4v1h-1v-1z",
    fill: "#e1ddd2"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54v-2h1v2zm-2-4v-1h1v1zm6 1v1h-1v-1zm-4 11v1h-1v-1zm1 1v1h-1v-1zm0 7h-1v-1h1zm0 1v-1h1v1zm1 2h-1v-1h1z",
    fill: "#936744"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M25 58v2h-1v-2zm-1-7h1v1h-1zm-2 14h-1v-1h1zm2 1h-1v-1h1zm0 3h-1v-1h1zm0 14h1v1h-1zm1 4h1v1h-1zm-3 4v-1h1v1z",
    fill: "#8b5e3d"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1zm2 0v1h-1v-1zm0 2v1h-1v-1zm-4 2h-1v-1h1zm6 0v-1h1v1zm-5 29h-1v-1h1zm-5 3h1v1h-1zm6 1v1h-1v-1zm-1 3h1v1h-1z",
    fill: "#b57f59"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M48 54h1v1h-1zm1 3v-1h1v1zm0 1h1v1h-1zm3 0h1v1h-1zm-6 2h1v1h-1zm0 4h1v1h-1zm4 1h-1v-1h1zm-2 29h-1v-1h1zm1 0h1v1h-1z",
    fill: "#a26c48"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1zm-1 3h-1v-1h1zm3 3h1v1h-1zm-4 5v1h-1v-1zm3 2h-1v-1h1zm-4 7h-1v-1h1zm2 9v1h-1v-1zm0 1h1v1h-1zm2 6v1h-1v-1z",
    fill: "#b07a54"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v-1h1v2h-1zm-3 17h-1v-2h1v1zm7-22v1h-1v-1zm-3 1v1h-1v-1zm5 5v1h-1v-1zm-3 15v1h-1v-1zm-1 17v-1h1v1z",
    fill: "#bb855f"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h-1v-1h2v1zm3-26v-1h1v1zm2 0v1h-1v-1zm-7 3h-1v-1h1zm4 0h-1v-1h1zm3 31v-1h1v1zm4 2v-1h1v1zm-4 0h1v1h-1z",
    fill: "#b17b55"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67h-1v-1h1zm1 1v1h-1v-1zm-2 11h-1v-1h1zm0 5v-1h1v1zm3 0v1h-1v-1zm-5 2v-1h1v1zm9-1v1h-1v-1zm0 3v1h-1v-1zm-9 3h1v1h-1z",
    fill: "#8c5f3e"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h2v1h-1zm-5 12v1h-1v-2h1zM37 2h1v1h-1zM18 6h1v1h-1zm5 3h-1V8h1zm51 19v1h-1v-1z",
    fill: "#38393b"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4h1v1h-1zm13 1V4h1v1zm1 2h1v1h-1zM19 8v1h-1V8zm12 2v1h-1v-1zm39 2v1h-1v-1zm-53 8v1h-1v-1zm64 5h-1v-1h1z",
    fill: "#333436"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19v1h-1v-2h1zM24 5h-1V4h1zm11 10h-1v-1h1zm13 1h-1v-1h1zm0 3v-1h1v1zm0 1h-1v-1h1zm2 1v1h-1v-1z",
    fill: "#131313"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v2h-1v-2zM65 5h-1V4h1zm14 14v-1h1v1zm4 4v-1h1v1zm-42 5h1v1h-1zm-10 1h1v1h-1zm12 1v1h-1v-1z",
    fill: "#111214"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6V5h1v1zm-34 6v1h-1v-1zm30 1v-1h1v1zm-30 4h-1v-1h1zm-15 1v-1h1v1zm58 7h1v1h-1zm14 0v1h-1v-1zm-30 4v1h-1v-1z",
    fill: "#2a2a2c"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h2v2h-1v-1zm9 10h1v1h-2v-1zM25 8h-1V7h1zm16 9v1h-1v-1zm-2 14h-1v-1h1z",
    fill: "#0c0c0e"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M34 7h1v1h-1zm36 8h-1v-1h1zm-2 5v-1h1v1zm-1 1v-1h1v1zm-47 0v1h-1v-1zm47 2v1h-1v-1zm-34 4v1h-1v-1zm14 2v-1h1v1z",
    fill: "#1e1f21"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14v-1h1v2h-1zM25 8v1h-1V8zm6 3h1v1h-1zm47 1v-1h1v1zm-33 3h-1v-1h1zm7 6v1h-1v-1zm38 4h1v1h-1z",
    fill: "#161618"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14h-1v-3h1zm1-5v1h-1V9zm61 7v1h-1v-1zm-32 8h1v1h-1zm40 1h-1v-1h1zm-16 3v1h-1v-1z",
    fill: "#363739"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19h-1v-3h1zm-15-5h1v1h-1zm-1 3h1v1h-1zm15 2v1h-1v-1zm-16 2v-1h1v1zm-6 2h-1v-1h1z",
    fill: "#111"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M42 19v-1h1v-1h1v2zm-1-4h1v1h-1zm4 1v1h-1v-1zm-12 3v-1h1v1zm12 3v-1h1v1zm-1 9v1h-1v-1z",
    fill: "#0e0e0e"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-2h1zm-12 1h-1v-1h1zm-1 2v1h-1v-1zm-52 3v-1h1v1zm49-1v1h-1v-1zm-40 3h-1v-1h1zm3 5v1h-1v-1z",
    fill: "#1a1b1d"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1zm1 0v-1h1v1zm-11 3h-1v-1h1zm2 0h-1v-1h1zm-15 0h1v1h-1zm-23 6h-1v-1h1zm7-1v1h-1v-1zm4 2v-1h1v1z",
    fill: "#0e0f11"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-2v-1h2zm-3 0h-1v-1h1zm5-1h1v1h-1zm-13 2h-1v-1h1zm-8 1v1h-1v-1zm3 0v1h-1v-1zm-9 71h-1v-1h1z",
    fill: "#e6e2de"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h2v2h-2zm-2-69h2v1h-2zm14-8h1v1h-1zm-6 8v-1h1v1z",
    fill: "#ebeae5"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M43 117h1v6h-1v-1zm10-80h-1v-1h1zm-2 1h-1v-1h1z",
    fill: "#dedacf"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h-2v-1h2zm-4 69v2h-1v-2zm16-78v1h-1v-1zm-16 9h-1v-1h1zm-1 59h1v1h-1zm-2 14h-1v-1h1z",
    fill: "#ece9e5"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M71 37v1h-3v-1h1zm-13 72v1h-2v-1h1zm9-69h-1v-1h1zm-5 66h1v1h-1zm-1 7h-1v-1h1z",
    fill: "#e9e5e1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M25 41v-1h3v1zm12-3h1v1h-2v-1zm1 77h-1v-2h1v1zM15 42h-1v-1h1z",
    fill: "#dbd4ca"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40h-1v-1h-1v-1h2zm-1 1h-1v-1h1zm-10 5h1v1h-1zm3 64v-1h1v1zm2 13h1v1h-1zm0 2h-1v-1h1z",
    fill: "#e6e3dc"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M82 40v1h-3v-1h1zm-9 64h1v1h-2v-2h1zm12-65v1h-1v-1zm-14 81v1h-1v-1z",
    fill: "#eeeae7"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M68 119v-1h-1v-1h2v2zm-1 1h-1v-1h2v1zm7-79v1h-1v-1zm-9 3v1h-1v-1zm1 62h1v1h-1z",
    fill: "#edeae4"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h2v1h-2zm1-25v1h-1v-1zm-2 1h1v1h-1zm0 3v-1h1v1zm-6 26h1v1h-1zm5 6v1h-1v-1zm-6 7v-1h1v1z",
    fill: "#b68157"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v-1h1v1zm-1 2h-1v-1h1zm1 22h1v1h-1zm-2 2v1h-1v-1zm-10 7h1v1h-1zm13 3h1v1h-1zm-4 4v-1h1v1zm-7 0h1v1h-1z",
    fill: "#bd885e"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1zm-3 0h1v1h-1zm0 1v1h-1v-1zm-1 5h1v1h-1zm2 3h-1v-1h1zm-1 1v1h-1v-1zm0 22v1h-1v-1zm0 11h1v1h-1z",
    fill: "#bb865a"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1zm-4 13v1h-1v-1zm-2 2h-1v-1h1zm-1 0v1h-1v-1zm2 7h-1v-1h1zm-1 5h-1v-1h1zm-2 2h1v1h-1zm0 10h1v1h-1z",
    fill: "#b17b57"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M68 64h2v1h-2zm7-10h1v1h-1zm-3 2h1v1h-1zm-3 7h-1v-1h1zm3 16v1h-1v-1zm3 5v1h-1v-1zm-1 3v1h-1v-1z",
    fill: "#bc875b"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1zm-1 2h-1v-1h1zm2-1v1h-1v-1zm-2 2v1h-1v-1zm1 5v-1h1v1zm-1 10v-1h1v1zm2 2v1h-1v-1zm-2 3h1v1h-1z",
    fill: "#c59064"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69v1h-3v-1zm-4-11v1h-1v-1zm4 8v1h-1v-1zm-3 13v-1h1v1zm12 5h-1v-1h1zM22 94h1v1h-1z",
    fill: "#895d3b"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M32 88h-1v-1h2v1zm2 4h-1v-2h1v1zm-6-29h-1v-1h1zm1 4h-1v-1h1zm6 6v1h-1v-1zm-3 20h1v1h-1z",
    fill: "#825633"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M44 77v1h-3v-1zm-1-11v-1h1v2h-1zm0 1v1h-1v-1zm0 2v1h-1v-1zm0 30v-1h1v1z",
    fill: "#966441"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h-1V2h1zm17 9h-1v-1h1zm-11 0v1h-1v-1zm0 2h1v1h-1zm0 1v1h-1v-1zm19 10h-1v-1h1zm-1 5h1v1h-1z",
    fill: "#232325"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13h1v1h-2v-1zM14 4V3h1v1zm42 15v1h-1v-1zm14 4v1h-1v-1zm3 2h-1v-1h1zm0 0h1v1h-1z",
    fill: "#2c2c2e"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-2v-1h1zM32 3h1v1h-1zM12 17h1v1h-1zm60 3h1v1h-1zm-20 4v-1h1v1zm27 5v-1h1v1z",
    fill: "#0f0f11"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-2v-1h1zM73 3v1h-1V3zm-4 11v1h-1v-1zm0 4v1h-1v-1zm-50 7h-1v-1h1zm8 2v-1h1v1z",
    fill: "#222325"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17v-1h1v2h-1zm1-12V4h1v1zm66 10v1h-1v-1zm-68 3h-1v-1h1zm-3 3h1v1h-1zm54 7h-1v-1h1z",
    fill: "#37383a"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5V4h1v1zm9 13v-1h1v1zm0 1h1v1h-1zM13 78v1h-1v-1zm3 17h-1v-1h1zm60 19h-1v-1h1zm-3 8v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v2h-1v-2zM37 6V5h1v1zm28 2V7h1v1zm-7 10v-1h1v1zm2 2h-1v-1h1zm-47 7h1v1h-1z",
    fill: "#444549"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M56 5v1h-2V5h1zM42 6V5h1v1zm25 8v-1h1v1zm-6 13h-1v-1h1zm3-1v1h-1v-1zm-7 2h-1v-1h1z",
    fill: "#25262a"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v2h-1v-1zM72 6V5h1v1zM28 9h-1V8h1zm23 3h1v1h-1zm26 10h-1v-1h1zm-28 3h-1v-1h1z",
    fill: "#1e1e20"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7h-1V6h1zm2 6v1h-1v-1zm42 1v-1h1v1zm-51 8v-1h1v1zm6 2h-1v-1h1zm55 2v-1h1v1zm-2 4v-1h1v1z",
    fill: "#303133"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M32 7V6h1v1zm-9 3V9h1v1zm-3 7v1h-1v-1zm-2 3v1h-1v-1zm-7 1v1h-1v-1zm42 4v1h-1v-1zm27 2h-1v-1h1z",
    fill: "#343537"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27v1h-2v-1h1zM42 7h-1V6h1zM17 8V7h1v1zm51 9v1h-1v-1zm-54 6v1h-1v-1zm68 0h1v1h-1z",
    fill: "#292a2e"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9h-1V7h1v1zm13 1h-1V9h1zM12 21h1v1h-1zm-2 2H9v-1h1zm5-1v1h-1v-1zm62 0v1h-1v-1z",
    fill: "#3d3e40"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26h-2v-1h2zm-3 1v-1h1v2h-1zm1-17V9h1v1zM13 21h-1v-1h1zm22 6h1v1h-1z",
    fill: "#212224"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10h1v1h-1zm43 3v1h-1v-1zm-48 2h1v1h-1zm-4 2v-1h1v1zm53 3h-1v-1h1zm-53 2h1v1h-1zm65 3h1v1h-1z",
    fill: "#353638"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M29 14v-2h1v1h1v1zm-1 5v1h-1v-2h1zm0-2h1v1h-1zm-1 4h-1v-1h1z",
    fill: "#1b1b1b"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M27 21v-1h1v-2h1v3zm4-8h1v1h-1zm-2 1h1v1h-1zm0 4v-1h1v1z",
    fill: "#1a1a1a"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v2h-1v-2zM31 28h-2v-1h2zM14 18h-1v-1h1zm2 4v-1h1v1zm11 2h1v1h-1z",
    fill: "#1c1d1f"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1zm2 0h-1v-1h1zm-9 1v1h-1v-1zm-39 7v1h-1v-1zm8 1v-1h1v1zm6 1h-1v-1h1zm-3 1v-1h1v1z",
    fill: "#0f1012"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44v-1h4v1h-1zm4-1v-2h1v2zm-2 81h-1v-1h1z",
    fill: "#eae7e0"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M25 80v-1h1v2h-1zm1 12v1h-1v-2h1zm-3-44v1h-1v-1zm-2 3v1h-1v-1zm5 39h1v1h-1z",
    fill: "#8e623e"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50h1v1h-1zm0 5h1v1h-1zm12 4h-1v-1h1zm-12 1h1v1h-1zm9 5v-1h1v1zm-3 11v-1h1v1zm1 11v1h-1v-1z",
    fill: "#946845"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M29 50v1h-1v-1zm-5 16h1v1h-1zm0 1v1h-1v-1zm0 11v-1h1v1zm5 9h-1v-1h1zm0 2h1v1h-1zm1 2v-1h1v1z",
    fill: "#895c3b"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v1h-1v-2zm-5-37h1v1h-1zm4 4h-1v-1h1zm-3 28v1h-1v-1zm6 5v1h-1v-1z",
    fill: "#ad7751"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58v-1h1v1zm1 2h-1v-1h1zM60 72v-1h1v1zm7 1v-1h1v1zm0 3v-1h1v1zm8 0v-1h1v1zm-14 2v1h-1v-1z",
    fill: "#be895f"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M22 59h1v2h-1v-1zm0 8v-2h1v2zm3 1h-1v-1h1zm-5 11h1v1h-1zm3 5h1v1h-1z",
    fill: "#8f6241"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h2v1zm10-29h1v1h-1zm-5 9h1v1h-1zm0 12h-1v-1h1zm2 0v1h-1v-1zm7 10v1h-1v-1z",
    fill: "#b8835b"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h2v1h-1zm9-23v-1h1v1zm-2 12v1h-1v-1zm-6 6h-1v-1h1zm1 12h1v1h-1zm1 4v1h-1v-1z",
    fill: "#b47f57"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-2h1v2zM57 65v1h-1v-1zm10 6h-1v-1h1zm-2 8h1v1h-1zm-1 3h-1v-1h1zm-2 1h1v1h-1z",
    fill: "#b7825a"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M32 78h-1v-1h1zm2-1v1h-1v-1zm3 7h-1v-1h1zm-1 4v-1h1v1zm1 2v1h-1v-1zm2 0h1v1h-1zm-3 6h1v1h-1z",
    fill: "#865836"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2v1h-1V2zm17 5h-1V6h1zM22 9h-1V8h1zm13 0v1h-1V9zm34 18v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#3b3c3e"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19v2h-1v-2zM65 2h1v1h-1zM25 5h-1V4h1zm1 15v1h-1v-1zm21 4v1h-1v-1z",
    fill: "#191919"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M18 4h-1V3h1zm1 7v-1h1v1zm-1 0h1v1h-1zm46 1v-1h1v1zm-13 1h1v1h-1zm21 12h1v1h-1z",
    fill: "#28282a"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M31 4h1v1h-1zm7 4v1h-1V8zm30 4v1h-1v-1zm-9 7h-1v-1h1zm2 0h1v1h-1zm-4 10v-1h1v1z",
    fill: "#45464a"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M54 5v1h-1V5zM16 25h-1v-1h1zm17 2h-1v-1h1zm6 0v-1h1v1zm27-1v1h-1v-1zm-39 3h1v1h-1z",
    fill: "#252629"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5v1h-1V5zM20 7v1h-1V7zm-4 10h1v1h-1zm1 6h1v1h-1zm59 0v1h-1v-1zm-2 4v-1h1v1z",
    fill: "#2a2b2d"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M81 12h2v2h-1v-1h-1zm-4-7v1h-1V5zm1 0h1v1h-1zM51 15h1v1h-1z",
    fill: "#18181a"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6h1v1h-1zm52 9v-1h1v1zm-53 9h-1v-1h1zm0 1v-1h1v1zm76 0h-1v-1h1zm-73 2v-1h1v1z",
    fill: "#2d2e32"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M55 19h-1v-3h1zM27 7h-1V6h1zm8 5h-1v-1h1zm13 16v-1h1v1z",
    fill: "#262628"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7h1v1h-1zm5 3h1v1h-1zm14 4v1h-1v-1zm1 0h1v1h-1zm9 7h1v1h-1zm27 7v1h-1v-1z",
    fill: "#151517"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8V7h2v1h-1zm22 10h1v1h-1zm-1 1h1v1h-1zm23 4h1v1h-1zm-72 5h-1v-1h1z",
    fill: "#424347"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M53 14v3h-1v-3zM27 9h-1V8h1zm51 14h1v1h-1zm-31 1h1v1h-1z",
    fill: "#1a1a1c"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v1h-1v-2h1zM24 9h1v1h-1zm60 1h-1V9h1zM23 23v1h-1v-1zm27 6v-1h1v1z",
    fill: "#2d2d2f"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12h-1v-1h1zm19 0v1h-1v-1zm2 8v1h-1v-1zm33 1h-1v-1h1zm-65 4v-1h1v1zm54-1v1h-1v-1z",
    fill: "#202022"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26h1v1h-2v-1zm43-12h1v1h-1zm5 4h-1v-1h1zm17 5v1h-1v-1zm-19 4v1h-1v-1z",
    fill: "#313236"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25v-1h2v1h-1zm-58-8v-1h1v1zm66 6v-1h1v1zm-54 4h1v1h-1zm3 0h1v1h-1z",
    fill: "#1d1e20"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M40 29h-1v-1h2v1zm46-11h-1v-1h1zm-31 5h-1v-1h1zm10 0v-1h1v1zm-20 6v1h-1v-1z",
    fill: "#101113"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43v-1h1v2h-1zm12-10h-1v-1h1zm-3 1v1h-1v-1zm-5 8h-1v-1h1zm-13 62v-1h1v1z",
    fill: "#eae9e5"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M32 120v-3h1v2h1v1zm-3-84h-1v-1h1zm5 86v-1h1v1z",
    fill: "#d1cfc3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37h-3v-1h3zm-7-1h1v1h-1zm10 80v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#d3cfc4"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v1h-2v-1h1zm-10 6v-1h2v1h-1zm10-6v-1h1v1zm-4 80v-1h1v1z",
    fill: "#e8e5e0"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-2v-1h1zm-8 1h-1v-1h1zm5 0h-1v-1h1zm-8 67h1v1h-1zm-2 18v-1h1v1z",
    fill: "#e9e6e2"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M61 123v1h-1v-2h2v1zm4-84h1v1h-1zm-2 2v-1h1v1zm-8 3v1h-1v-1z",
    fill: "#e9e6e0"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M63 121v1h-1v-2h1zm5-82h1v1h-1zm-10 4h1v1h-1zm2 0h1v1h-1zm5 75h-1v-1h1z",
    fill: "#eae6e2"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1zm6 62h-1v-1h1zm2 3h1v1h-1zm7 6v1h-1v-1zm-2 1h1v1h-1zm3 4v1h-1v-1z",
    fill: "#d9d3c9"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M67 116h-1v-2h1v1zm-3-71h-1v-1h1zm-5 0h1v1h-1zm4 60h1v1h-1zm0 17h1v1h-1z",
    fill: "#ebe8e3"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h1v1h-1zm5 5h1v1h-1zm-3 2v1h-1v-1zm1 8v-1h1v1zm1 9v-1h1v1zm5 11v-1h1v1z",
    fill: "#926643"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1zm9 0v1h-1v-1zm-4 20v-1h1v1zm0 2v-1h1v1zm5 3h1v1h-1zm0 14v-1h1v1z",
    fill: "#865936"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1zm0 2v-1h1v1zm6 21v1h-1v-1zm4 1v-1h1v1zm-15 5v1h-1v-1zm11 17h1v1h-1z",
    fill: "#8a5d3b"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1zm0 5v-1h1v1zm-4 9v1h-1v-1zm-1 13h1v1h-1zm0 3v-1h1v1zm10 6h1v1h-1z",
    fill: "#895c3a"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1zm-8 12h1v1h-1zm-1 8v1h-1v-1zm-3 7v-1h1v1zm0 3h1v1h-1zm4 16v1h-1v-1z",
    fill: "#b57f5b"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1zm-6 17v-1h1v1zm4 0v1h-1v-1zm1 1v-1h1v1zm-4 14v-1h1v1zm1 2h-1v-1h1z",
    fill: "#bc8859"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1zm-3 7v-1h1v1zm-5 1v-1h1v1zm1 1v-1h1v1zm-2 10v1h-1v-1zm5 29v-1h1v1z",
    fill: "#ab754f"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1zm-5 6v-1h1v1zm-3 0h1v1h-1zm1 3v-1h1v1zm-2 12v1h-1v-1zm6 27v-1h1v1z",
    fill: "#ae7852"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1zm1 11v-1h1v1zm0 3v1h-1v-1zm-3 1h1v1h-1zm6 9h1v1h-1zm0 10v1h-1v-1z",
    fill: "#8b5a39"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1zm-4 1v1h-1v-1zm4 3h1v1h-1zm-2 17v-1h1v1zm3 1v1h-1v-1zm15 18v-1h1v1z",
    fill: "#916542"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59v1h-1v1h-1v-2zm-3-5v-1h1v1zm2 2h-1v-1h1zm-1 2h-1v-1h1z",
    fill: "#92623e"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M58 63h-1v-2h1v1zm0-9h-1v-1h1zm2 0h1v1h-1zm-3 19v-1h1v1zm0 0v1h-1v-1z",
    fill: "#b6805c"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1zm-1 14h1v1h-1zm-1 4v-1h1v1zm0 9v1h-1v-1zm-8 5h-1v-1h1zm6 3v1h-1v-1z",
    fill: "#b9845a"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1zm-3 17v-1h1v1zm10-1h1v1h-1zm-15 3h-1v-1h1zm6 0h-1v-1h1zm6 16v-1h1v1z",
    fill: "#c08b61"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1zm-2 2h1v1h-1zm0 14v1h-1v-1zm-1 4h-1v-1h1zm8 15v1h-1v-1zm-3 3h1v1h-1z",
    fill: "#bf8a60"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1zm-1 7v-1h1v1zm-8 0v1h-1v-1zm3 4v-1h1v1zm10 11h1v1h-1zm-6 8v1h-1v-1z",
    fill: "#8b5e3c"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1zm-10 7h-1v-1h1zm8 14v1h-1v-1zm3 4h-1v-1h1zm0 1v1h-1v-1zm0 4v-1h1v1z",
    fill: "#885b39"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54h1v1h-1zm-1 16v-1h1v1zm6 10h-1v-1h1zm-4 10v-1h1v1zm-1 0v1h-1v-1zm0 6v-1h1v1z",
    fill: "#9e6844"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1zm-4 7h-1v-1h1zm-2 1h-1v-1h1zm3 6h-1v-1h1zm-1 2h1v1h-1zm0 22h1v1h-1z",
    fill: "#b37d59"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-2v-1h2zm-2-33h-1v-1h1zm-3 24h-1v-1h1zm0 7v1h-1v-1zm0 3v-1h1v1z",
    fill: "#bc875c"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M32 60h-1v-1h1zm7 14h1v1h-1zm-7 4v1h-1v-1zm6 2v1h-1v-1zm1 11h1v1h-1zm2 3h-1v-1h1z",
    fill: "#8f613f"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M34 82h-1v-2h1v1zm-7-21h1v1h-1zm4 15h-1v-1h1zm5 18v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#7e522f"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66v3h-1v-3zm0-2h-1v-1h1zm1 1h-1v-1h1zm0 14v1h-1v-1z",
    fill: "#8e6140"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M21 65v1h-1v1h-1v-2zm-1 4v-2h1v2zm1 20v-1h1v1z",
    fill: "#926544"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M39 66v-1h1v1zm-1 3v-1h1v1zm0 2v-1h1v1zm1 7h1v1h-1zm1 2v1h-1v-1zm-2 4h1v1h-1z",
    fill: "#91603f"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M45 101v-2h1v2zm0-34h-1v-1h1zm-3 2v-1h1v1zm1 9h1v1h-1zm-1 4h1v1h-1z",
    fill: "#976542"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M62 70h-1v-1h1zm1 4h-1v-1h1zm-1 4v-1h1v1zm3 3h-1v-1h1zm0 3h-1v-1h1zm6 7v1h-1v-1z",
    fill: "#b9845c"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M63 78h1v2h-2v-1h1zm1-9h1v1h-1zm0 1v1h-1v-1zm2 2v-1h1v1z",
    fill: "#bb865e"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M60 72h1v1h-1zm7 6v-1h1v1zm-5 2h-1v-1h1zm1 3v-1h1v1zm0 5h1v1h-1zm8 2v1h-1v-1z",
    fill: "#bd885f"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107h-2v-2h2zm-2-4v2h-1v-2z",
    fill: "#d1d1c9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M53 119h2v3h-2z",
    fill: "#e3e4df"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M17 3v1h-1V3zm9 11v-1h1v1zm53 7h1v1h-1zm-12 3v-1h1v1zm-18 3h-1v-1h1z",
    fill: "#252527"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M53 4h1v1h-1zm-27 6h-1V9h1zm30 12v1h-1v-1zm-28 1h1v1h-1zm15 8v-1h1v1z",
    fill: "#141416"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5v1h-1V5zm-4 6v1h-1v-1zm-1 5h-1v-1h1zM6 18h1v1H6zm3 4v-1h1v1z",
    fill: "#343436"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5v1h-1V5zm47 19v-1h1v1zm-70 2v-1h1v1zm51 0v-1h1v1zm-54 1v1h-1v-1z",
    fill: "#38393d"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v1h-2v-1h1zm30-8V5h1v1zm-44 8h-1v-1h1zm24 9h-1v-1h1z",
    fill: "#161617"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M69 15v2h-1v-2zM58 27h-2v-1h2zM39 7V6h1v1z",
    fill: "#222327"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M22 7v1h-1V7zm1 1h1v1h-1zm-7 9h-1v-1h1zm64 8v1h-1v-1zm-7 2h1v1h-1z",
    fill: "#323335"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h2v2h-1v-1h-1zM26 8v1h-1V8zm8 5h-1v-1h1z",
    fill: "#0e0e10"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v2h-1v-1zM32 10V9h1v1zm-11 3v1h-1v-1zm43 6v-1h1v1z",
    fill: "#3c3d3f"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M75 10v2h-1v-2zm-15 2h-1v-1h1zm-5 2v-1h1v1zm2 11v1h-1v-1z",
    fill: "#404042"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12v-1h1v1zm43 8h1v1h-1zm1 3h-1v-1h1zm-43 0h1v1h-1zm30 1h-1v-1h1z",
    fill: "#111113"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M74 11v1h-1v-1zm10 2h-1v-1h1zm-3 8v1h-1v-1zm4 0v1h-1v-1zm-13 4h-1v-1h1z",
    fill: "#39393b"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12v1h-1v-1zm4 0h1v1h-1zm-9 10v1h-1v-1zm67 2v1h-1v-1zm-5 3v1h-1v-1z",
    fill: "#313234"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13v-1h2v1h-1zm-3 8v1h-2v-1h1zm8 0h1v1h-1z",
    fill: "#080808"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-2h1v2zm-2-1h1v1h-1zm11 9v1h-1v-1zm-19 8v1h-1v-1z",
    fill: "#0d0d0f"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M31 20v1h-1v-2h1zm18-7h-1v-1h1zm-17 1v1h-1v-1zm16 1h-1v-1h1z",
    fill: "#161616"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M70 14v-1h2v1h-1zM26 25h-1v-2h1v1zm39-4h1v1h-1z",
    fill: "#202122"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v1zm3-1v1h-1v-1zm28 0h1v1h-1zm-29 6v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#19191b"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h1v1h-2v-1zm10-12h-1v-1h1zm-54 9h1v1h-1zm48 3h-1v-1h1z",
    fill: "#27282c"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v1h-3v-1zm0-2h-1v-1h1zm0 14h-1v-1h1z",
    fill: "#48494d"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M43 21h-1v-2h1v1zm-9-5h1v1h-1zm1 3h-1v-1h1zm-1 1v1h-1v-1z",
    fill: "#0b0b0b"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1zm-10 3h-1v-1h1zm-46 1h1v1h-1zm5 3h1v1h-1zm32 5h1v1h-1z",
    fill: "#303134"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1zm6 1v-1h1v1zm-11 2h-1v-1h1zm13 0v-1h1v1zm41 7v-1h1v1z",
    fill: "#0a0a0a"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h3v1zm0-10h-1v-1h1zm3 5v1h-1v-1z",
    fill: "#414246"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-2v-1h2zm-22-2h1v1h-1zm7 1h1v1h-1zm7 9v1h-1v-1z",
    fill: "#060606"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M27 22v-1h1v1zm14-1h1v1h-1zm-11 1h1v1h-1zm18 1v-1h1v1zm-7 9h-1v-1h1z",
    fill: "#070707"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22h1v1h-2v-1zm4 0h-1v-1h1zm4 0v-1h1v1zm5 0h1v1h-1z",
    fill: "#050505"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22h-2v-1h2zm-4-1h1v1h-1zm7 2v-1h1v1zm-5 8v1h-1v-1z",
    fill: "#040404"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M37 23h-2v-1h2zm-4 9v-1h2v1h-1zm4 0h-1v-1h1z",
    fill: "#030303"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35h-1v-1h2v1zm4-1v1h-1v-1zm-28 73v1h-1v-1zm2 3v1h-1v-1z",
    fill: "#e5e2dc"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1zm-6 4h-1v-1h1zm-4 2v-1h1v1zm-4 3v1h-1v-1zm2 80v-1h1v1z",
    fill: "#e3ded8"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1zm2-1h1v1h-1zm-12 70h1v1h-1zm-1 6v-1h1v1zm0 9v-1h1v1z",
    fill: "#eceae6"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M18 37v-1h1v1zm2 0v-1h1v1zm-1 1v1h-1v-1zm2 1h-1v-1h1zm7 66v1h-1v-1z",
    fill: "#d4d3c7"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v-1h2v1h-1zm6 0h1v1h-2v-1zm4 74h-1v-1h1z",
    fill: "#d4d2c6"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M33 115v1h-2v-1h1zm2 7v-1h1v2h-1zm3-86v1h-1v-1z",
    fill: "#d5cec4"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1zm-6 1h1v1h-1zm-12 1h1v1h-1zm8 68v1h-1v-1zm6 9v1h-1v-1z",
    fill: "#d6d1c6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M13 40v-1h2v1h-1zm4-2v-1h1v1zm2 3h-1v-1h1zm1-1h1v1h-1z",
    fill: "#d6d4c8"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M16 38v1h-1v-1zm1 2h1v1h-1zm6 1h-1v-1h1zm12 74v-1h1v1zm4 5h-1v-1h1z",
    fill: "#d8d3c8"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M39 120v2h-1v-2zM16 39v-1h1v1zm10-1v1h-1v-1zm12 85h1v1h-1z",
    fill: "#d8d2c8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h2v1h-1zm13-8v1h-1v-1zm-7 71v1h-1v-1zm1 3h1v1h-1z",
    fill: "#dfdbd0"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M45 113v-1h1v2h-1zm6-75h1v1h-1zm-3 2v1h-1v-1zm-5 3h1v1h-1z",
    fill: "#e1ddd1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39h1v1h-2v-1zm4 67h-1v-1h1zm3 4v-1h1v1zm4 2v1h-1v-1z",
    fill: "#dad4ca"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1zm-8 3h-1v-1h1zm10 66v-1h1v1zm2 1v-1h1v1zm6 12h1v1h-1z",
    fill: "#d9d4c9"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v1h-1v-4h1zm3-81h-1v-1h1z",
    fill: "#e0dcd2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v2h-1v-2zm0-69v-1h1v1zm-1 1h-1v-1h1zm1 0v1h-1v-1z",
    fill: "#dedcd0"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1zm-5 4v-1h1v1zm0 62v1h-1v-1zm-2 11h1v1h-1zm-14 8h1v1h-1z",
    fill: "#ece9e6"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43h-1v-1h2v1zm1 74v-2h1v2zm0 8v-1h1v1z",
    fill: "#e2ded4"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M19 44h-1v-1h1zm9 61v-1h1v1zm3-1v1h-1v-1zm0 3h1v1h-1zm4 4v-1h1v1z",
    fill: "#dad4c9"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M19 47h-1v-1h1zm1 17v-1h1v1zm1 5h1v1h-1zm1 4h-1v-1h1zm-2 3v1h-1v-1z",
    fill: "#926644"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1zm-4 2h-1v-1h1zm4 1v1h-1v-1zm0 14h-1v-1h1zm-3 18v1h-1v-1z",
    fill: "#8a5e3c"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h2v1h-1zm1-9v1h-1v-1zm0 5v-1h1v1zm8 19h1v1h-1z",
    fill: "#855735"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1zM56 69h-1v-1h1zm0 5v1h-1v-1zm5 22h1v1h-1zm2 2h-1v-1h1z",
    fill: "#b37d58"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M16 64h-1v-2h1v1zm3-12h-1v-1h1zm-1 11v1h-1v-1zm2 20v1h-1v-1z",
    fill: "#976b49"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1zm3 4h1v1h-1zm-2 2h1v1h-1zm3 4h1v1h-1zm5 30h-1v-1h1z",
    fill: "#8d5f3d"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1zm3 18h-1v-1h1zm1 5v-1h1v1zm-1 3v1h-1v-1zm4 16h1v1h-1z",
    fill: "#8e603e"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1zm-8 18v-1h1v1zm4 20v-1h1v1zm2 1v-1h1v1zm1 5h1v1h-1z",
    fill: "#b7815a"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v-1h2v1h-1zm0 38h1v1h-1zm-3 2h1v1h-1zm1 5v1h-1v-1z",
    fill: "#b9845b"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1zm-4 2v1h-1v-1zm-2 2v1h-1v-1zm4 21v1h-1v-1zm-1 3h-1v-1h1z",
    fill: "#b27c58"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1zm-3 13h1v1h-1zm1 14v-1h1v1zm-4 9v-1h1v1zm9 1h1v1h-1z",
    fill: "#bb865c"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-2h1zm-1-31v1h-1v-1zm-1 6h1v1h-1zm5 32h1v1h-1z",
    fill: "#9c6642"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v2h-1v-2zm2-26h1v1h-1zm-5 21v-1h1v1zm1 4h-1v-1h1z",
    fill: "#c69165"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M20 55h1v1h-1zm0 5v-1h1v1zm0 5v-1h1v1zm0 11h1v1h-1zm0 7h-1v-1h1z",
    fill: "#936644"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1zm3 11h1v1h-1zm2 15v1h-1v-1zm-2 14h1v1h-1zm5 1h-1v-1h1z",
    fill: "#815532"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1zm1 5h-1v-1h1zm-3 2h-1v-1h1zm4 26v-1h1v1zm2 3h-1v-1h1z",
    fill: "#845634"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M53 55h1v1h-1zm0 9h1v1h-1zm-2 10v-1h1v1zm3 8h1v1h-1zm2 19v-1h1v1z",
    fill: "#a7714b"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1zm-1 15v1h-1v-1zm-5 3v-1h1v1zm3 9v-1h1v1zm5 10v1h-1v-1z",
    fill: "#af7954"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1zm0 15v-1h1v1zm0 10h1v1h-1zm-7 6h-1v-1h1zm10 5v1h-1v-1z",
    fill: "#875a38"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1zm7 1v1h-1v-1zm0 9h-1v-1h1zm-6 3h1v1h-1zm-2 4h1v1h-1z",
    fill: "#ba845e"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59v1h-1v-1zm-3 2v-1h1v1zm2 3h-1v-1h1zm0 0h1v1h-1zm-3 13h1v1h-1z",
    fill: "#906342"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60v-1h1v1zm-2 9v1h-1v-1zm-2 11v-1h1v1zm1 0h1v1h-1zm1 3h-1v-1h1z",
    fill: "#ba855d"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M19 61v1h-2v-1h1zm5 1v1h-1v-1zm-5 2h-1v-1h1zm4 8v1h-1v-1z",
    fill: "#966a47"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61v1h-1v-1zm2 1v1h-1v-1zm1 5h-1v-1h1zm-6 2v1h-1v-1zm-2 8v-1h1v1z",
    fill: "#ba845f"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62v1h-1v-1zm-5 2v-1h1v1zm0 12v-1h1v1zm3 4h1v1h-1zm3 2h-1v-1h1z",
    fill: "#b88357"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M59 65v-2h1v2zm-3 6h-1v-1h1zm-2 1v-1h1v1zm5 6h-1v-1h1z",
    fill: "#b47e5a"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86v1h-3v-1zm-7-23h1v1h-1zm5 14v-1h1v1z",
    fill: "#c59065"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M27 86h1v2h-1v-1zm-2-21h-1v-1h1zm-4 26v-1h1v1zm3 3v1h-1v-1z",
    fill: "#875a39"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M63 64h1v2h-1v-1zm-3 1v1h-1v-1zm-2 13h-1v-1h1zm8 18h-1v-1h1z",
    fill: "#ba8460"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M28 86h-1v-2h1v1zm-4-21h1v1h-1zm2 19h-1v-1h1zm4 9h-1v-1h1z",
    fill: "#855837"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M46 84v-1h1v2h-1zm2-17v1h-1v-1zm0 22v1h-1v-1zm-3 2h1v1h-1z",
    fill: "#9b6541"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M59 70h1v1h-1zm3 8h-1v-1h1zm4 3v1h-1v-1zm-7 6h1v1h-1zm6 2v1h-1v-1z",
    fill: "#b68159"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M49 78h-1v-1h1zm1 0v-1h1v1zm-2 5h-1v-1h1zm4 7h-1v-1h1zm-7 0h1v1h-1z",
    fill: "#a06a47"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M25 108h2v2h-2zm2 3v-1h1v1z",
    fill: "#d2cfc6"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v-1h1v2h-1zm-2-4v-1h1v1zm3 6v-1h1v1zm-1 11v-1h1v1z",
    fill: "#e2ded3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v-1h1v5h-1z",
    fill: "#e5e4e0"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M58 118h1v5h-1v-2z",
    fill: "#e8e5e1"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2V1h1v1zm4 0v1h-1V2zm37 12v-1h1v1zm-45 4v1h-1v-1z",
    fill: "#4a4a4c"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2h1v1h-1zm-1 4h1v1h-1zm72 7v1h-1v-1zM7 19v-1h1v1z",
    fill: "#373739"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4h-1V3h1zm-14 6v1h-1v-1zm1 1v1h-1v-1zm8 17h1v1h-1z",
    fill: "#2c2e2d"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4h-1V3h1zm-1 3h-1V6h1zm-6 0v1h-1V7zm24 8h-1v-1h1z",
    fill: "#2f3034"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M48 3v1h-1V3zm-6 4V6h1v1zM13 25v1h-1v-1zm49 3h-1v-1h1z",
    fill: "#2b2c30"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M67 4V3h2v1h-1zm3 0V3h1v1zM22 27v1h-1v-1z",
    fill: "#232524"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h1v1h-1zM28 4h1v1h-1zm-5 23v-1h1v1zm0 1h-1v-1h1z",
    fill: "#222423"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M34 5h-1V4h1zm15 0h-1V4h1zM15 7v1h-1V7zm8 6v-1h1v1z",
    fill: "#2d2e30"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5h-1V4h1zM49 6V5h1v1zm27 0v1h-1V6zm-6 10h-1v-1h1z",
    fill: "#1f2023"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4h1v1h-1zM36 8h-1V7h1zm33 10h-1v-1h1zM8 19h1v1H8z",
    fill: "#222326"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M39 5h1v1h-1zm25 12v-1h1v1zm19 8h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#3c3d41"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h1v1h-1zm5 2h-1V6h1zM12 23v1h-1v-1zm74 2h-1v-1h1z",
    fill: "#323337"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6V5h1v1zm23 0h-1V5h1zM17 6h1v1h-1zm45 21h1v1h-1z",
    fill: "#2c2d31"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7h-1V6h1zm42 0h-1V6h1zM46 31h-1v-1h1zm29 0h-1v-1h1z",
    fill: "#1b1c1e"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6h1v1h-1zm13 16h-1v-1h1zm-50 5h-1v-1h1zm6 0v1h-1v-1z",
    fill: "#3e3f42"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h1v1h-1zM14 17v-1h1v1zm53 1h1v1h-1zm-56 7h1v1h-1z",
    fill: "#28292c"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8V7h1v1zm22-1v1h-1V7zm50 18h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#2a2b2f"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7h1v1h-1zM13 24v1h-1v-1zm3 2h-1v-1h1zm-2 1h-1v-1h1z",
    fill: "#35363a"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h-1V7h1zm-6 1h-1V8h1zm24 8v1h-1v-1zm2 12v-1h1v1z",
    fill: "#4a4b4f"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h1v1h-2V8zm19-1h1v1h-1zm-5 23v1h-1v-1z",
    fill: "#5a5b5f"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v-1h2v1h-1zm7-22h-1V7h1zm-9 21h1v1h-1z",
    fill: "#4f5052"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7v1h-1V7zM13 19v1h-1v-1zm62 9v-1h1v1zm-7 0h1v1h-1z",
    fill: "#404143"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M79 7v1h-1V7zm5 1v1h-1V8zm-26 3h1v1h-1zm0 14h-1v-1h1z",
    fill: "#454547"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1zm26 4h-1v-1h1zm-1 2v-1h1v1zM6 21v1H5v-1z",
    fill: "#6f6f71"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h-2v-1h2zm13-3v1h-1V9zm-72 8v-1h1v1z",
    fill: "#222224"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h1v1h-1zm49 5v-1h1v1zM7 19v1H6v-1zm71 6v-1h1v1z",
    fill: "#2e2f31"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M23 10h1v1h-1zm48 14h-1v-1h1zm3 0h-1v-1h1zm-7 1h1v1h-1z",
    fill: "#313133"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11h1v1h-1zm-4 10h1v1h-1zm-56 3h1v1h-1zm3 2v-1h1v1z",
    fill: "#212123"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14h-1v-1h-1v-1h2zm50 8h-1v-1h1z",
    fill: "#292b2a"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12h1v1h-1zm27 7h1v1h-1zm-33 3h-1v-1h1zm27 5h-1v-1h1z",
    fill: "#242426"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1zm45 7v1h-1v-1zm-31 3h-1v-1h1zm37 5h-1v-1h1z",
    fill: "#08080a"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v1h-1v-1zm-2 8h1v1h-1zm3 1h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#080809"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19h-1v-4h1v1z",
    fill: "#171717"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1zm-2 2v-1h1v1zm40 1h-1v-1h1zM33 31v-1h1v1z",
    fill: "#0a0b0d"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-2v-1h1zm-2 1v1h-1v-1zm42 0v1h-1v-1z",
    fill: "#090a0c"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-2v-1zm5 0h-1v-1h1zm8 7h-1v-1h1z",
    fill: "#09090b"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M37 23v-1h4v1h-1z",
    fill: "#020202"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26h-1v-1h2v1zm-2-1v1h-1v-1zm40 4h1v1h-1z",
    fill: "#131515"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h4v1h-2z",
    fill: "#dfdcd7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33h1v1h-1zm29 2v-1h1v1zm-20 1v-1h1v1zm6-1h1v1h-1z",
    fill: "#d1cdc1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M28 120h-1v-1h-1v-1h2zm17-85h-1v-1h1z",
    fill: "#ceccc0"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M41 112h-1v-2h1v1zm19-78h1v1h-1zM33 45v1h-1v-1z",
    fill: "#dcd9cd"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M30 120h-1v-2h1v1zm-1-84v-1h1v1zm3 84h1v1h-1z",
    fill: "#d0cec2"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1zm-13 2h-1v-1h1zm-11 74v1h-1v-1zm0 9v-1h1v1z",
    fill: "#e5e2dd"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1zm-19 4v1h-1v-1zm-5 68h-1v-1h1zm0 11h-1v-1h1z",
    fill: "#e6e3de"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36v1h-4v-1h1z",
    fill: "#d5d2c9"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v2h-1zm0-3h1v1h-1zm7 69h1v1h-1z",
    fill: "#d3d3c7"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1zm1 1v-1h1v1zm5 73h1v1h-1zm5 4v1h-1v-1z",
    fill: "#d4d1c6"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M12 38h-1v-1h4v1z",
    fill: "#d6d3ca"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M29 110v-2h1v2zm-5-73v1h-1v-1zm-2 2v-1h1v1z",
    fill: "#d5d1c6"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M31 115v-1h2v1h-1zm3-78v1h-1v-1zm-2 76h-1v-1h1z",
    fill: "#d6cfc5"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1zm3 0v1h-1v-1zm-5 77v-1h1v1zm6 8v1h-1v-1z",
    fill: "#d7cfc6"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1zm-11 70h-1v-1h1zm8 15h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#dad5ca"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M13 38h2v1h-2zm14 63v1h-1v-1zm5 1v1h-1v-1z",
    fill: "#d6d4c9"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M36 120v-1h2v1h-1zM24 38v1h-1v-1zm10 76v1h-1v-1z",
    fill: "#d6d0c6"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1zm-10 7h-1v-1h1zm6 80h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#e7e3e1"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1zm-11 6v-1h1v1zm7 56h1v1h-1zm-3 12h-1v-1h1z",
    fill: "#ece8e4"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1zm-5 0v1h-1v-1zm-3 60v-1h1v1zm-2 5h1v1h-1z",
    fill: "#ebe9e4"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45h-1v-2h1v1zm-3-1v-1h1v1zm11 73h1v1h-1z",
    fill: "#dad6cc"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1zm9 67v-1h1v1zm-2 9h1v1h-1zm-3 3v1h-1v-1z",
    fill: "#e7e4e0"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M16 47h1v1h-1zm0 2v1h-1v-1zm1 3h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#956a47"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1zm-4 40v1h-1v-1zm7 0v1h-1v-1zm5 7v1h-1v-1z",
    fill: "#855836"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1zm-7 23h-1v-1h1zm3 0h-1v-1h1zm-2 9v1h-1v-1z",
    fill: "#bd885b"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M27 50v2h-1v-2zm-1 5v1h-1v-1zm4 28h1v1h-1z",
    fill: "#895d39"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1zm-4 5h-1v-1h1zm5 26h-1v-1h1zm3 11v-1h1v1z",
    fill: "#8b5c3a"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1zm-1 0v1h-1v-1zm0 13h1v1h-1zm2 7h1v1h-1z",
    fill: "#835533"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1zm5 5v1h-1v-1zm-3 2h1v1h-1zm-3 25v-1h1v1z",
    fill: "#aa744e"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1zm-2 16h1v1h-1zm-3 5v1h-1v-1zm8 19v-1h1v1z",
    fill: "#b8825a"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M19 69v2h-1v-2zm-4-16v-1h1v1zm4 22h1v1h-1z",
    fill: "#996d4b"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1zm-5 5v1h-1v-1zm4 24h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#906442"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1zm-5 8h1v1h-1zm-2 30h1v1h-1zm3 3h-1v-1h1z",
    fill: "#845735"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M50 52h1v1h-1zm5 7h1v1h-1zm-2 30v-1h1v1zm2 0v1h-1v-1z",
    fill: "#ac7650"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1zm0 1v1h-1v-1zm2 14v-1h1v1zm3 14v1h-1v-1z",
    fill: "#ac7651"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M69 56h-1v-1h2v1zm-2-3v-1h1v1zm-9 32h1v1h-1z",
    fill: "#b78258"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54h-1v-1h1zm-3 1v1h-1v-1zm1 4v1h-1v-1zm-4 23v1h-1v-1z",
    fill: "#a8724d"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1zm-2 22v-1h1v1zm0 5h1v1h-1zm4 16h1v1h-1z",
    fill: "#b8835c"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54h1v1h-1zm4 8h-1v-1h1zm10 4v1h-1v-1zm-8 11v1h-1v-1z",
    fill: "#8d603e"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M55 54v2h-1v-2zm-2 19h-1v-1h1zm2 14v-1h1v1z",
    fill: "#ad7750"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1zm3 19h1v1h-1zm-5 12v1h-1v-1zm2 1v-1h1v1z",
    fill: "#865937"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v2h-1v-2zm-3-7h1v1h-1zm4 0v1h-1v-1z",
    fill: "#c69366"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M43 58h-1v-1h1zm1 7h1v1h-1zm-1 2h1v1h-1zm1 32v-1h1v1z",
    fill: "#94623f"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h-1v-1h1zm3 0h-1v-1h1zm-2 24h1v1h-1zm2 9h-1v-1h1z",
    fill: "#af7953"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1zm-1 11v-1h1v1zm-7 2h1v1h-1zm1 5v1h-1v-1z",
    fill: "#bc8660"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M69 58h-1v-1h1zm-9 13v1h-1v-1zm0 4v-1h1v1zm5 11h-1v-1h1z",
    fill: "#bd8860"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1zm-3 11v-1h1v1zm0 2h-1v-1h1zm-2 6h-1v-1h1z",
    fill: "#c28e5f"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59h1v1h-1zm2 4v1h-1v-1zm0 8h-1v-1h1zm-1 8h-1v-1h1z",
    fill: "#875a37"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M24 60h1v1h-2v-1zm-3 19h1v1h-1zm1 11v-1h1v1z",
    fill: "#8d603f"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1zm-4 15h-1v-1h1zm4 15h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#bd8761"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-1zm-1 2h1v1h-1zm8 1v1h-1v-1zm-7 12h1v1h-1z",
    fill: "#b57f5a"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h-1v-1h1zm2 0v1h-1v-1zm2 4v-1h1v1zm1 30h-1v-1h1z",
    fill: "#b9835f"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1zm-1 0v1h-1v-1zm4 2h-1v-1h1zm1 32v1h-1v-1z",
    fill: "#b7815d"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M69 61v1h-1v-1zm2 4h-1v-1h1zm-1 12h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#bd885d"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h-1v-1h1zm-3 1h1v1h-1zm1 1h1v1h-1zm2 19v-1h1v1z",
    fill: "#905f3e"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M64 62h1v1h-1zm3 15h-1v-1h1zm-5 7h-1v-1h1zm-1 3h1v1h-1z",
    fill: "#c08a63"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1zm1 2v1h-1v-1zm0 1h1v1h-1zm1 10v1h-1v-1z",
    fill: "#926140"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M18 74h1v2h-1v-1zm0-8h-1v-1h1zm-1 5h1v1h-1z",
    fill: "#946947"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M37 67v-1h1v1zm-1 0h1v1h-1zm-1 1h1v1h-1zm3 0v1h-1v-1z",
    fill: "#895837"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M60 67v-1h1v1zm-3 1v1h-1v-1zm5 27v1h-1v-1zm3 3h-1v-1h1z",
    fill: "#b47e59"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M45 68h-1v-1h1zm-1 0v1h-1v-1zm-1 2h1v1h-1zm0 10v-1h1v1z",
    fill: "#996744"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69v-1h1v1zm-6 2v-1h1v1zm6 0h-1v-1h1zm0 18v1h-1v-1z",
    fill: "#bc875e"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71v-1h1v1zm0 16v1h-1v-1zm3 5h-1v-1h1zm2 3h1v1h-1z",
    fill: "#b9855c"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71h1v1h-1zm1 10v1h-1v-1zm8 6h-1v-1h1zm-6 7v-1h1v1z",
    fill: "#b07a55"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M18 80v1h-1v-2h1zm0-7v1h-1v-1zm0 18v-1h1v1z",
    fill: "#936848"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M48 74h-1v-1h1zm-2 0h1v1h-1zm2 8h-1v-1h1zm-2 12h-1v-1h1z",
    fill: "#a06a48"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M56 76v1h-1v-1zm2 0v1h-1v-1zm3 0v1h-1v-1zm2 10v1h-1v-1z",
    fill: "#b7815c"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M61 79v-1h1v1zm3-1h1v1h-1zm-1 7v-1h1v1zm-1 3v-1h1v1z",
    fill: "#c18c64"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M62 79v-1h1v1zm0 1v1h-1v-1zm5 7v1h-1v-1zm0 8v-1h1v1z",
    fill: "#b58058"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1zm1 3h-1v-1h1zm-2 2v-1h1v1zm5 13h1v1h-1z",
    fill: "#8d5c3b"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1zm1 9h1v1h-1zm3 1h1v1h-1zm2 2v-1h1v1z",
    fill: "#bd8a5f"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M65 107v-1h1v2h-1zm3-4v1h-1v-1zm-4 2h-1v-1h1z",
    fill: "#ece9e3"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M31 116h1v3h-1zm-3-3v-1h1v1z",
    fill: "#d4cdc3"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117h1v1h1v1h-2zm-4 10v-1h1v1z",
    fill: "#e2ded5"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M27 120h2v1h-1v1h-1zm2 2v-1h1v1z",
    fill: "#cecbc2"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3v1h-1V3zm-1 1v1h-1V4zm19 7h-1v-1h1z",
    fill: "#3e3e40"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3v1h-1V3zm54 2V4h1v1zm-66 8h-1v-1h1z",
    fill: "#464646"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h-1V3h1zM38 14v-1h1v1zm3-1v1h-1v-1z",
    fill: "#0c0d0d"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3v1h-1V3zM25 13v-1h1v1zm57 13v-1h1v1z",
    fill: "#27272a"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4h1v1h-1zm71 11h-1v-1h1zm-63 1v1h-1v-1z",
    fill: "#38383a"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h-1V4h1zm29 2h-1V6h1zM11 22v1h-1v-1z",
    fill: "#353639"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5V4h1v1zm26 12h1v1h-1zM13 27h-1v-1h1z",
    fill: "#3b3c40"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-2h1v1zM43 5h-1V4h1z",
    fill: "#4d4e52"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10h-1V8h1v1zm-4-5h1v1h-1z",
    fill: "#323336"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5h1v1h-1zm-4 1v1h-1V6zM9 24H8v-1h1z",
    fill: "#2e2f32"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5v1h-1V5zm38 1V5h1v1zm-37 6v-1h1v1z",
    fill: "#2f2f31"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M46 5v1h-2V5h1zM36 7h-1V6h1z",
    fill: "#1c1d20"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6V5h1v1zm-30 7h1v1h-1zm13 12v1h-1v-1z",
    fill: "#1e2021"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6h-1V5h1zM10 21H9v-1h1zm-3 5v-1h1v1z",
    fill: "#232427"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5h1v1h-1zm-36 6h1v1h-1zm10 1v-1h1v1z",
    fill: "#2e2d31"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7V6h1v1zm10 4v1h-1v-1zm20 5v-1h1v1z",
    fill: "#1c1c1e"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6v1h-1V6zM36 8h1v1h-1zm26 13h-1v-1h1z",
    fill: "#404145"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M56 6h1v1h-2V6zm11 22v1h-1v-1z",
    fill: "#47484b"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-1V7h1zm45 5v1h-1v-1zm1 5v-1h1v1z",
    fill: "#393a3d"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M27 7v1h-1V7zm26 6v-1h1v1zm-33 9h1v1h-1z",
    fill: "#1f1f21"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7v1h-2V7h1zm-13 8v-1h1v1z",
    fill: "#1a1e1f"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7h1v1h-1zm20 13v1h-1v-1zm24 5h-1v-1h1z",
    fill: "#3e3f43"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7v1h-1V7zm-7 1v1h-1V8zm23 22v-1h1v1z",
    fill: "#4c4d51"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M59 8V7h1v1zm31 13v1h-1v-1zM57 31h-1v-1h1z",
    fill: "#5c5b60"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8v1h-1V8zm23 13h-1v-1h1zm5 4v1h-1v-1z",
    fill: "#3f4043"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M60 8h1v1h-1zm-13 2V9h1v1zm-37 7v1H9v-1z",
    fill: "#65666a"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M62 9V8h1v1zm2 0V8h1v1zm26 13v1h-1v-1z",
    fill: "#69686d"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10h-1V9h1zm0 3v1h-1v-1zm49 8v-1h1v1z",
    fill: "#2b2c2d"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9v1h-1V9zm17 4v-1h1v1zm14 10v1h-1v-1z",
    fill: "#101012"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9zm25 21v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#595a5e"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M46 9v1h-3V9z",
    fill: "#626367"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9v1h-1V9zm-26 6v1h-1v-1zm34 4v1h-1v-1z",
    fill: "#2b2b2d"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v-1h1v2h-1zm-50 0v-1h1v1z",
    fill: "#767678"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M71 10v1h-1v-1zm-22 2h-1v-1h1zm1 0v-1h1v1z",
    fill: "#5b5b5e"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-2v-1h2zm11-15v-1h1v1z",
    fill: "#272729"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11h1v1h-1zm50 13h-1v-1h1zm-22 4h-1v-1h1z",
    fill: "#29292b"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1zm-46 4h1v1h-1zm-2 8v-1h1v1z",
    fill: "#282828"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v1h-1v-1zm4 4v-1h1v1zm47 10h1v1h-1z",
    fill: "#292a2c"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1zm15 10h1v1h-1zm-2 2v-1h1v1z",
    fill: "#0b0b0d"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1zm-5 5v1h-1v-1zm3 4h-1v-1h1z",
    fill: "#3d3e42"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1zM10 26h1v1h-1zm63 4h-1v-1h1z",
    fill: "#3e3f41"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15v-2h1v2zm10 11v1h-1v-1z",
    fill: "#272928"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15h1v2h-1v-1zm1-2v1h-1v-1z",
    fill: "#1f1f1f"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h2v1h-1zm18 7v1h-1v-1z",
    fill: "#141415"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h1v1h-1zm0 10v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#0f1010"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1zm17 10h1v1h-1zm-20 3h-1v-1h1z",
    fill: "#323234"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1zm2 3v-1h1v1zm-3 10v-1h1v1z",
    fill: "#3f4044"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15v-1h1v1zm0 2v1h-1v-1zm-2 2h1v1h-1z",
    fill: "#1e1e1e"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23h1v1h-2v-1zm1-7v-1h1v1z",
    fill: "#303032"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M28 17h-1v-2h1v1zm-2 1v-1h1v1z",
    fill: "#222"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18v-1h1v1zm-1 1v-1h1v1zm-2 3v-1h1v1z",
    fill: "#292929"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M26 20h-1v-2h1v1zm-2 3h1v1h-1z",
    fill: "#242424"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1zm-43 5v1h-1v-1zm51 2h1v1h-1z",
    fill: "#333438"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1zm-19 4v-1h1v1zm-18 1h1v1h-1z",
    fill: "#171819"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21h1v1h-1zm3 4h-1v-1h1zm61 3v1h-1v-1z",
    fill: "#202020"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h2v1zm20-4v1h-1v-1z",
    fill: "#555658"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M5 23v-1h1v1zm54 2h-1v-1h1zm10-1h1v1h-1z",
    fill: "#48484a"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-2v-1h2zm-10-1h1v1h-1z",
    fill: "#0e100f"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M20 25v1h-1v-1zm6 0h1v1h-1zm49 4v1h-1v-1z",
    fill: "#212225"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29v-1h1v1zm-3 0v1h-1v-1zm3 1h-1v-1h1z",
    fill: "#373938"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29h2v1h-2zm8 1v-1h1v1z",
    fill: "#303231"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M23 106v-1h1v2h-1zm-6-74h-1v-1h1z",
    fill: "#d0d0c6"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32v1h-1v-1zm8 82h1v1h-1zm6 6v1h-1v-1z",
    fill: "#cfccc3"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M27 120v2h-1v-2zM16 32h1v1h-1z",
    fill: "#cdcac1"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M23 35h-1v-1h2v1zm-4-2h1v1h-1z",
    fill: "#cfcbbf"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M24 34h-1v-1h1zm9 0h1v1h-1zm3 1h-1v-1h1z",
    fill: "#c9c6b9"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h2v1h-2zm20-3v1h-1v-1z",
    fill: "#e3e0db"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34h1v1h-1zm3 2h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#d1cec2"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1zm-19 85v-1h1v1zm2 1h-1v-1h1z",
    fill: "#cdcbbf"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1zm-13 5v-1h1v1zm-4 1h1v1h-1z",
    fill: "#e1ddd3"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1zm-28 78h-1v-1h1zm0 4h1v1h-1z",
    fill: "#e5e1dc"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M16 35h1v1h-1zm3 2v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#d3d2c6"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M18 35h2v1h-2zm9 2h-1v-1h1z",
    fill: "#d2d1c5"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M30 119h2v1h-2zm-8-84h1v1h-1z",
    fill: "#d1cdc2"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h2v1h-2zm-1 0v1h-1v-1z",
    fill: "#d4d0c4"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1zm-22 68h-1v-1h1zm4 4v1h-1v-1z",
    fill: "#d8d2c7"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1zm-4 1v1h-1v-1zm-22 6h-1v-1h1z",
    fill: "#d9d3c8"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1zm-8 4v1h-1v-1zm-2 1h1v1h-1z",
    fill: "#e2ddd5"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1zm-9 3v1h-1v-1zm-4 78v1h-1v-1z",
    fill: "#e3ded6"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M33 118v-1h1v2h-1zm-8-82h1v1h-1z",
    fill: "#d2d0c4"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-2v-1h2zm-1 88v-1h1v1z",
    fill: "#d6ccc5"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1zm-5 75v-1h1v1zm6 8h-1v-1h1z",
    fill: "#d7d0c6"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1zm-3 1v1h-1v-1zm-11 4h-1v-1h1z",
    fill: "#d9d4c8"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M13 39h-2v-1h2zm18-1h1v1h-1z",
    fill: "#d6d3c8"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1zm-2 61h1v1h-1zm9 6v1h-1v-1z",
    fill: "#d5d2c6"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1zm1 65v-1h1v1zm10 12h-1v-1h1z",
    fill: "#d7d1c7"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1zm1 1v1h-1v-1zm-9 5h-1v-1h1z",
    fill: "#d9d7ca"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40h-1v-1h2v1zm-2 0h1v1h-1z",
    fill: "#d8d6c9"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M42 40h-1v-1h2v1zm-3 1h-1v-1h1z",
    fill: "#dddacd"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1zm-2 65h-1v-1h1zm2 19v-1h1v1z",
    fill: "#dfdcd0"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1zm-6 6h-1v-1h1zm2 80h1v1h-1z",
    fill: "#e3dfd5"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1zm-1 1v-1h1v1zm-1 76v1h-1v-1z",
    fill: "#e4dfdb"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h2v1h-2zm2-1v-1h1v1z",
    fill: "#e5e1de"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-2v-1h1zm-3 64h1v1h-1z",
    fill: "#dddbce"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1zm-18 84h-1v-1h1zm-6 1h1v1h-1z",
    fill: "#efece7"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h2v1h-1zm-1 82h1v1h-1z",
    fill: "#e2ded2"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1zm-1 1v1h-1v-1zm-1 71h1v1h-1z",
    fill: "#e3dfd4"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v2h-1v-2zm1 82h-1v-1h1z",
    fill: "#eae7e1"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-2v-1h2zm-8 67h1v1h-1z",
    fill: "#ecebe7"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M48 114v-2h1v2zm0-71v-1h1v1z",
    fill: "#e4e0d6"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h-2v-1h2zm-12 3v-1h1v1z",
    fill: "#ecebe6"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h2v1zm-4 55v-1h1v1z",
    fill: "#d7d5cb"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1zm7 57v1h-1v-1zm-10 23h1v1h-1z",
    fill: "#ebe8e1"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1zm-10 2h1v1h-1zm3 77h1v1h-1z",
    fill: "#ede9e5"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1zm5 1h-1v-1h1zm7 57v-1h1v1z",
    fill: "#dcd7c7"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1zm6 1h-1v-1h1zm-9 52v-1h1v1z",
    fill: "#d2c6b6"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h-1v-2h1v1zm-3-63h-1v-1h1z",
    fill: "#e2ddd3"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46v1h-1v-1zm4 11h1v1h-1zm0 12h1v1h-1z",
    fill: "#956947"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M17 47h-1v-1h1zm-1 7h1v1h-1zm3 31v-1h1v1z",
    fill: "#946946"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M18 46v1h-1v-1zm0 11v-1h1v1zm7 34v1h-1v-1z",
    fill: "#8f6341"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M16 49v-1h1v1zm2 10h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#966b48"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1zm-1 13v1h-1v-1zm15 10h1v1h-1z",
    fill: "#906340"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1zm0 10v-1h1v1zm12 42h-1v-1h1z",
    fill: "#895c39"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1zm4 9h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#8d5d39"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1zm6 45h-1v-1h1zm-6 2h-1v-1h1z",
    fill: "#b17c54"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1zm2 10h-1v-1h1zm-8 10h1v1h-1z",
    fill: "#c38f60"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1zm5 0v1h-1v-1zm3 31h1v1h-1z",
    fill: "#8b5b39"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1zm3 36h1v1h-1zm4 11v-1h1v1z",
    fill: "#8a5a39"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1zm1 7h-1v-1h1zm2 21v-1h1v1z",
    fill: "#91603e"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1zm-6 37v-1h1v1zm2 2v-1h1v1z",
    fill: "#b07b54"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1zm2 1v-1h1v1zm-3 32h-1v-1h1z",
    fill: "#be895c"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1zm-4 8v-1h1v1zm1 12h1v1h-1z",
    fill: "#c69065"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M20 75v-1h1v2h-1zm-2-24v1h-1v-1z",
    fill: "#976b48"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1zm1 11v1h-1v-1zm1 26h-1v-1h1z",
    fill: "#906341"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1zm-1 17v1h-1v-1zm4 20v1h-1v-1z",
    fill: "#8f5f3e"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1zm0 2v1h-1v-1zm-1 5v-1h1v1z",
    fill: "#90603c"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M49 53h-2v-2h1v1h1z",
    fill: "#9d6741"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1zm-6 22v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#a46e4b"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1zm-2 15v1h-1v-1zm-1 24h1v1h-1z",
    fill: "#ad7752"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1zm-1 0h1v1h-1zm-4 22v-1h1v1z",
    fill: "#c89266"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-2h1v1zm2 7h-1v-1h1z",
    fill: "#976540"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-2h1v1zm0-34h1v1h-1z",
    fill: "#9a6544"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h1v1h-1zm6 30h1v1h-1zm-5 18v-1h1v1z",
    fill: "#a36d47"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1zm-9 14h1v1h-1zm-2 17h1v1h-1z",
    fill: "#ab7550"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v2h-1v-1zm1 30h-1v-1h1z",
    fill: "#b78259"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1zm2 2v1h-1v-1zm-6 19h1v1h-1z",
    fill: "#b98458"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52h1v1h-1zm-2 11h1v1h-1zm-5 9v-1h1v1z",
    fill: "#c79266"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v-1h1v2h-1zm-1 6h-1v-1h1z",
    fill: "#946440"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1zm-1 4h-1v-1h1zm2 23v1h-1v-1z",
    fill: "#936745"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1zm0 4v-1h1v1zm0 8v-1h1v1z",
    fill: "#895a38"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1zm-3 8v-1h1v1zm3 1h-1v-1h1z",
    fill: "#c08a64"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M67 55h-1v-1h1zm1 1h1v1h-1zm0 10v1h-1v-1z",
    fill: "#ba855c"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M68 54v1h-1v-1zm-8 28v1h-1v-1zm5 5v-1h1v1z",
    fill: "#b58056"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1zm-1 22h-1v-1h1zm-2 3h-1v-1h1z",
    fill: "#ba855b"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55v-1h1v1zm-2 14v-1h1v1zm-9 14v1h-1v-1z",
    fill: "#b88359"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v2h-1v-2zm0-3v1h-1v-1z",
    fill: "#976c49"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1zm-8 19h1v1h-1zm4 1h-1v-1h1z",
    fill: "#b27c57"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1zm0 6h1v1h-1zm-2 28h-1v-1h1z",
    fill: "#b9845d"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57v-1h1v1zm2 12v-1h1v1zm1 6v1h-1v-1z",
    fill: "#997054"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1zm1 6v1h-1v-1zm4 31v-1h1v1z",
    fill: "#875635"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1zm-5 9h-1v-1h1zm-5 2v-1h1v1z",
    fill: "#c08c5e"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M42 59h-1v-1h1zm1 22v-1h1v1zm3 21h-1v-1h1z",
    fill: "#93633f"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58v1h-1v-1zm-3 13v1h-1v-1zm-2 4v1h-1v-1z",
    fill: "#a9734d"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M57 59h-1v-1h1zm-1 1h1v1h-1zm-2 5v-1h1v1z",
    fill: "#a8724c"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M21 61h-1v-1h1zm3 26h-1v-1h1zm-1 1v1h-1v-1z",
    fill: "#946746"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M26 60v1h-1v-1zm1 28v1h-1v-1zm-5 6v-1h1v1z",
    fill: "#875b39"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M67 61v-1h1v1zm-5 7v1h-1v-1zm0 17v-1h1v1z",
    fill: "#bf8a63"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1zm2 30v-1h1v1zm3 1v1h-1v-1z",
    fill: "#bc875d"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M35 61v1h-1v-1zm0 18v-1h1v1zm3 12v-1h1v1z",
    fill: "#8c5e3c"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1zm4 7v-1h1v1zm1 1v1h-1v-1z",
    fill: "#8f5e3c"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61h1v1h-1zm2 6h-1v-1h1zm1 12h1v1h-1z",
    fill: "#956443"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v1h-1v-1zm-1 2h1v1h-1zm4 34v1h-1v-1z",
    fill: "#915f3c"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M20 63h-1v-1h1zm0 10h-1v-1h1zm4 6h1v1h-1z",
    fill: "#8f633f"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1zm1 3v-1h1v1zm4 31h-1v-1h1z",
    fill: "#8f5e3d"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62h1v1h-1zm0 5h1v1h-1zm1 15v1h-1v-1z",
    fill: "#8f5d3a"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v2h-1v-2zm-3 0v-1h1v1z",
    fill: "#95603e"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M43 63v-1h1v1zm4 8v1h-1v-1zm1 27v1h-1v-1z",
    fill: "#9b6543"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M52 65v1h-1v-2h1zm4-3h1v1h-1z",
    fill: "#ac7653"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M60 62h1v1h-1zm2 5h-1v-1h1zm5 32h-1v-1h1z",
    fill: "#b8825e"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M32 64v-1h1v1zm8 11v1h-1v-1zm-3 6h-1v-1h1z",
    fill: "#916341"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M44 64h-1v-1h1zm1 0h1v1h-1zm1 34h-1v-1h1z",
    fill: "#976240"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M54 64v-1h1v1zm-1 25h-1v-1h1zm0 0h1v1h-1z",
    fill: "#ae7853"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M56 64h-1v-1h1zm3 3v-1h1v1zm6 30v-1h1v1z",
    fill: "#b6805b"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1zm0 3v-1h1v1zm-11 6v1h-1v-1z",
    fill: "#b9835e"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M71 64v-1h1v1zm-2 8h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#bf8a5f"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M43 64h1v1h-1zm1 20h-1v-1h1zm1 14h1v1h-1z",
    fill: "#9b6745"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M68 65h-1v-1h1zm-12 1h-1v-1h1zm0 23v-1h1v1z",
    fill: "#b17c53"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M71 65v-1h1v2h-1zm6 16v1h-1v-1z",
    fill: "#c48f64"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M30 66v-1h1v1zm4 3v1h-1v-1zm2 24v-1h1v1z",
    fill: "#855a37"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M58 66h-1v-1h1zm6 7v1h-1v-1zm-5 13v-1h1v1z",
    fill: "#b68059"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v-1h1v1zm6 3h-1v-1h1zm1 3v1h-1v-1z",
    fill: "#8c5a39"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68h-1v-1h1zm2 1h1v1h-1zm-3 13v-1h1v1z",
    fill: "#bd895a"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M73 67h1v1h-1zm-1 2v1h-1v-1zm-2 16h1v1h-1z",
    fill: "#ba8657"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 70v1h-2v-1h1zm1-1v-1h1v1z",
    fill: "#93613e"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M63 69v1h-1v-1zm-1 1v1h-1v-1zm6 26h-1v-1h1z",
    fill: "#bc875f"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M19 77v1h-1v-2h1zm-2-7h1v1h-1z",
    fill: "#946948"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71v-1h1v1zm-3 12h1v1h-1zm6 16v1h-1v-1z",
    fill: "#976441"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v1h-2v-1h1zm-6 15h1v1h-1z",
    fill: "#bb8758"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h-1v-1h1zm2 4h1v1h-1zm-3 10v1h-1v-1z",
    fill: "#a6704d"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72h1v1h-1zm1 3h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#b8825b"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1zm-7 15v1h-1v-1zm2 4h-1v-1h1z",
    fill: "#b57f58"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1zm2 6h-1v-1h1zm-3 14h1v1h-1z",
    fill: "#9a6442"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1zm2 12v1h-1v-1zm5 4v-1h1v1z",
    fill: "#b17b56"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76v1h-1v-1zm3 0h1v1h-1zm-3 3v-1h1v1z",
    fill: "#a36d4a"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78v1h-1v-1zm2 9h-1v-1h1zm0 0h1v1h-1z",
    fill: "#936645"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v1h-1v-1zm-2 11h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#986240"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v1h-1v-1zm7 18v-1h1v1zm-5 1h-1v-1h1z",
    fill: "#b37c58"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-2h1v1zm1 2v-1h1v1z",
    fill: "#bc875a"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M59 94v-1h1v2h-1zm4-12h-1v-1h1z",
    fill: "#b27d54"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M26 83h-1v-1h1zm-1 2h1v1h-1zm14 14h-1v-1h1z",
    fill: "#875a3a"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M64 83v-1h1v1zm2 2h-1v-1h1zm-7 4v-1h1v1z",
    fill: "#b8835a"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M28 83v1h-1v-1zm0 8v-1h1v1zm3 3v1h-1v-1z",
    fill: "#845836"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M30 86v-1h1v1zm0 5h1v1h-1zm-2 3v-1h1v1z",
    fill: "#855937"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-2v-1h1zm-1 5v-1h1v1z",
    fill: "#955f3d"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1zm3 4h-1v-1h1zm2 8v-1h1v1z",
    fill: "#a66f4c"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M47 98v1h-1v-2h1zm-2-8h-1v-1h1z",
    fill: "#996341"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M29 92v-1h1v1zm-5 3v-1h1v1zm7 2h1v1h-1z",
    fill: "#825534"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1zm1 5v-1h1v1zm3-1h1v1h-1z",
    fill: "#ab7651"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M71 114h2v1h-2zm2-13v-1h1v1z",
    fill: "#eceae5"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M75 101v1h-1v-1zm-9 17v-1h1v1zm-5 6h1v1h-1z",
    fill: "#edeae3"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1zm7 17h1v1h-1zm0 2h1v1h-1z",
    fill: "#dcd7cb"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M58 105v-1h1v1zm-5 1h-1v-1h1zm7 0v1h-1v-1z",
    fill: "#e7e5e2"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-2h1v2zm0-3h-1v-1h1z",
    fill: "#e2dbd1"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1zm6 3h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#e8e5e2"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107v-1h2v1h-1zm-3-2v1h-1v-1z",
    fill: "#e7e4e2"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M25 114v-2h1v2zm-2-6v-1h1v1z",
    fill: "#d1cfc5"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M46 107v2h-1v-2zm2 6h-1v-1h1z",
    fill: "#e2dfd3"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M27 110v-2h1v2zm6 15v-1h1v1z",
    fill: "#d3d0c7"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v2h-1v-2zm1 3h1v1h-1z",
    fill: "#e3e1d5"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M52 113h-1v-1h2v1zm3 3h1v1h-1z",
    fill: "#e4e3e0"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M37 124v-1h1v2h-1zm-6-10v-1h1v1z",
    fill: "#d7cec5"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M20 116v-2h1v2zm8 7h1v1h-1z",
    fill: "#d0d0c8"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M23 117v-2h1v2zm-1-2v-1h1v1z",
    fill: "#cdc8c3"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M48 126v-2h1v2zm0-12h1v1h-1z",
    fill: "#e3dfd6"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121h1v2h-1v-1zm2-5h-1v-1h1z",
    fill: "#e2ddd9"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115h1v1h-1zm2 1v1h-1v-1zm-2 4h1v1h-1z",
    fill: "#e4e3de"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M28 120v-2h1v2zm4 2h-1v-1h1z",
    fill: "#cfcdc1"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v2h-1v-2zm1 2v1h-1v-1z",
    fill: "#e1dcd6"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M59 1V0h1v1zM8 14H7v-1h1z",
    fill: "#858585",
    fillOpacity: 0.09
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M61 0h1v1h-1zm10 1h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2V1h1v1zm-9 10v-1h1v1z",
    fill: "#333236"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2v1h-1V2zm59 4v1h-1V6z",
    fill: "#333336"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2v1h-1V2zM5 24H4v-1h1z",
    fill: "#535355"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M18 2h1v1h-1zm50 30h-1v-1h1z",
    fill: "#565658"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3V2h1v1zm3 1V3h1v1z",
    fill: "#3f3f3f"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M31 3h-1V2h1zm55 16h1v1h-1z",
    fill: "#575859"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2v1h-1V2zm51 16v1h-1v-1z",
    fill: "#191b1b"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h-1V2h1zM13 8h1v1h-1z",
    fill: "#2e302f"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M44 3V2h1v1zm9 26v-1h1v1z",
    fill: "#3a393f"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2v1h-1V2zm-1 13v-1h1v1z",
    fill: "#181816"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2h1v1h-1zM41 19v-1h1v1z",
    fill: "#0c0b0b"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M55 3V2h1v1zM34 23v-1h1v1z",
    fill: "#060505"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3V2h2v1h-1z",
    fill: "#060604"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M68 3h-1V2h1zM50 14h-1v-1h1z",
    fill: "#21211f"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3h1v1h-1zM6 18v1H5v-1z",
    fill: "#494949"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M34 3v1h-1V3zm42 11v-1h1v1z",
    fill: "#141617"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M35 4h-1V3h1zm-3 21h1v1h-1z",
    fill: "#1b1d1d"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h1v1h-1zM10 19h1v1h-1z",
    fill: "#36373a"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4V3h1v1zm-20 8h1v1h-1z",
    fill: "#131315"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M53 3h1v1h-1zm-23 9h-1v-1h1z",
    fill: "#101011"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4V3h1v1zM36 15v1h-1v-1z",
    fill: "#0c0c0d"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h2v1h-2z",
    fill: "#0d0d0e"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4h-1V3h1zM47 31v1h-1v-1z",
    fill: "#181919"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5V4h1v1zm75 19h-1v-1h1z",
    fill: "#313136"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5V4h1v1zm51 6h1v1h-1z",
    fill: "#2d2d2e"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5h-1V4h1zm7 13h1v1h-1z",
    fill: "#181818"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5V4h1v1zm-3 24v-1h1v1z",
    fill: "#242524"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M36 5h-1V4h1zM25 25v1h-1v-1z",
    fill: "#1f2120"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M47 4v1h-1V4zM14 29h1v1h-1z",
    fill: "#3d3f3f"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4v1h-1V4zm19 10v-1h1v1z",
    fill: "#202124"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4h1v1h-1zM27 29h-1v-1h1z",
    fill: "#18191c"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M69 4v1h-1V4zm12 20v-1h1v1z",
    fill: "#1b1c1f"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M77 5V4h1v1zM21 18h1v1h-1z",
    fill: "#2c2c2c"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5v1h-1V5zm67 5V9h1v1z",
    fill: "#3c3c3e"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6V5h1v1zm49 21h1v1h-1z",
    fill: "#2e2f33"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M22 5h1v1h-1zm14 8v1h-1v-1z",
    fill: "#121213"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5h1v1h-1zm-7 14v-1h1v1z",
    fill: "#323334"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5h1v1h-1zm25 10h1v1h-1z",
    fill: "#434448"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6V5h1v1zm11 21h-1v-1h1z",
    fill: "#202125"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6V5h1v1zm-9 24v-1h1v1z",
    fill: "#2e2e32"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h1v1h-1zm-6 10v-1h1v1z",
    fill: "#2a2d30"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M69 5v1h-2V5h1z",
    fill: "#242328"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M75 6h-1V5h2v1z",
    fill: "#1d1e22"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6V5h1v1zM53 32v1h-1v-1z",
    fill: "#3f3e40"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6v1h-1V6zm51 10v-1h1v1z",
    fill: "#292a30"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7V6h1v1zm31 9h1v1h-1z",
    fill: "#2f2e31"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6v1h-2V6h1z",
    fill: "#191a1e"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M41 7h-1V6h1zm19 20h-1v-1h1z",
    fill: "#242529"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6h2v1h-2z",
    fill: "#4c4b4f"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6v1h-1V6zm-1 18v1h-1v-1z",
    fill: "#4c4b50"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6v1h-1V6zm-4 22h1v1h-1z",
    fill: "#4d4d51"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6v1h-1V6zm-3 22h1v1h-1z",
    fill: "#505155"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M73 7h-1V6h1zM52 29v-1h1v1z",
    fill: "#37363a"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7h-1V6h1zm-70 9h1v1h-1z",
    fill: "#18171a"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7v1h-1V7zM15 27h1v1h-1z",
    fill: "#46474b"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h1v1h-1zm13 21h1v1h-1z",
    fill: "#4b4c50"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M48 7v1h-1V7zm20 23v-1h1v1z",
    fill: "#515254"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8V7h1v1zm-8 0h1v1h-1z",
    fill: "#535458"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M56 7v1h-2V7h1z",
    fill: "#57585d"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7h1v1h-1zm17 1v1h-1V8z",
    fill: "#57565b"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8V7h1v1zM9 15h1v1H9z",
    fill: "#5b5a5f"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M62 7h1v1h-1zm26 15h1v1h-1z",
    fill: "#5f5e63"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M69 8h-1V7h2v1z",
    fill: "#605f64"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M73 8V7h1v1zm-4 22h1v1h-1z",
    fill: "#4f4f53"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7h1v1h-1zM57 9v1h-1V9z",
    fill: "#6e6e70"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8h1v1h-1zm1 4v1h-1v-1z",
    fill: "#292a2b"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8v1h-1V8zm22 16v1h-1v-1z",
    fill: "#515256"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M46 8h1v1h-1zm18 23v-1h1v1z",
    fill: "#5b5c60"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8v1h-2V8h1z",
    fill: "#5f6063"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8v1h-2V8h1z",
    fill: "#69686e"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M73 9h-1V8h1zm-4 22v1h-1v-1z",
    fill: "#59585d"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9V8h1v1zm9 10h-1v-1h1z",
    fill: "#88888a"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M80 8h1v1h-1zm5 4v1h-1v-1z",
    fill: "#747476"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M83 8v1h-1V8zm-28 4h-1v-1h1z",
    fill: "#545456"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M84 9V8h1v1zm-31 2h1v1h-1z",
    fill: "#58585a"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9h1v1h-1zm8 18v-1h1v1z",
    fill: "#2d2f2d"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10h-1V9h1zm5 0h-1V9h1z",
    fill: "#5f6064"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-2V9z",
    fill: "#5d5e62"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9h2v1h-2z",
    fill: "#696a6e"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9h1v1h-1zm27 6v-1h1v1z",
    fill: "#707072"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h2v1h-1z",
    fill: "#716f74"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10h-1V9h1zm-25 1v-1h1v1z",
    fill: "#8a898f"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h-1V9h1zm2 11h1v1h-1z",
    fill: "#505153"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10h-1V9h1zm-22 3h1v1h-1z",
    fill: "#494a4c"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10v1h-1v-1zm-2 1h1v1h-1z",
    fill: "#2b2d2c"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10h1v2h-1v-1z",
    fill: "#3f4042"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M57 11h-1v-1h1zm6 0h-1v-1h1z",
    fill: "#8f8e93"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M72 11h-1v-1h1zm-17 1v-1h1v1z",
    fill: "#525255"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M78 10v1h-2v-1h1z",
    fill: "#5a5b5d"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M79 11h-1v-1h1zM57 26v-1h1v1z",
    fill: "#424245"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M81 10h1v1h-1zM47 26h-1v-1h1z",
    fill: "#19181a"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M83 10h1v1h-1zM72 30v1h-1v-1z",
    fill: "#474749"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11h1v1h-1zm0 3h1v1h-1z",
    fill: "#2e2f2e"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11v1h-1v-1zm-6 13v1h-1v-1z",
    fill: "#1f1f22"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12v-1h1v1zm17 4h-1v-1h1z",
    fill: "#111112"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1zM4 25v-1h1v1z",
    fill: "#4b4b4d"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M44 11h1v1h-1zm36 11v1h-1v-1z",
    fill: "#555557"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12h-1v-1h1zm21 19h-1v-1h1z",
    fill: "#59595b"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1zm5 0v-1h1v1z",
    fill: "#5a5a5c"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1zm41 11v-1h1v1z",
    fill: "#5c5b5f"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1zm17 14h-1v-1h1z",
    fill: "#5b5b5d"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1zm31 11h1v1h-1z",
    fill: "#4d4c51"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1zM54 26h1v1h-1z",
    fill: "#212125"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M84 11v1h-1v-1zm4 9h-1v-1h1z",
    fill: "#414143"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12v1h-1v-1zm43 7v1h-1v-1z",
    fill: "#3e3e41"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12h1v1h-1zm-8 11h-1v-1h1z",
    fill: "#19191a"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1zm-34 6h-1v-1h1z",
    fill: "#121214"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1zm14 12v-1h1v1z",
    fill: "#333335"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1zm28 3v-1h1v1z",
    fill: "#353537"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1zm-4 14h-1v-1h1z",
    fill: "#444548"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1zm12 10v-1h1v1z",
    fill: "#464749"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1zm25 12v-1h1v1z",
    fill: "#47474a"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1zm21 10h-1v-1h1z",
    fill: "#48484c"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1zM51 30h-1v-1h1z",
    fill: "#232425"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1zm4 18v-1h1v1z",
    fill: "#1d1e1f"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1zm2 10h1v1h-1z",
    fill: "#0c0d0c"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1zm-23 7v1h-1v-1z",
    fill: "#191918"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1zM29 32h-1v-1h1z",
    fill: "#252524"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1zm33 7v-1h1v1z",
    fill: "#49494b"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14v1H9v-1zm61 10v1h-1v-1z",
    fill: "#424244"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15v-1h1v1zm45 10h1v1h-1z",
    fill: "#353538"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15v-1h1v1zm-9 4v1h-1v-1z",
    fill: "#262b2c"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15v-1h1v1zm55 13v-1h1v1z",
    fill: "#232323"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15v-1h1v1zm20 0h1v1h-1z",
    fill: "#171716"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M37 15v-1h1v1zm36 0v-1h1v1z",
    fill: "#131517"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-2v-1h1z",
    fill: "#161614"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1zm21 11v1h-1v-1z",
    fill: "#2b2c2f"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1zm-51 5h1v1h-1z",
    fill: "#181819"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1zM45 30v-1h1v1z",
    fill: "#121416"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15v1h-1v-1zM6 26H5v-1h1z",
    fill: "#313032"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16h-1v-1h1zm6 11h1v1h-1z",
    fill: "#252627"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v1h-1v-1zm61 14h-1v-1h1z",
    fill: "#2d2f30"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M19 15v1h-1v-1zm28 13v1h-1v-1z",
    fill: "#181a1c"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17v-2h1v2z",
    fill: "#1c1c1c"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M37 16v-1h1v1zm3-1v1h-1v-1z",
    fill: "#0b0c0f"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16h1v1H7zm73 12h-1v-1h1z",
    fill: "#7b7b7d"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17H9v-1h1zm52 14v1h-1v-1z",
    fill: "#505055"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17v-1h1v1zm77 3h-1v-1h1z",
    fill: "#363638"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h-1v-1h1zm29 12v-1h1v1z",
    fill: "#343335"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1zm41 2v-1h1v1z",
    fill: "#0b0c0d"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18h-1v-2h1v1z",
    fill: "#3e3d42"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v1h-1v-1zm44 4h-1v-1h1z",
    fill: "#343535"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#2a2a2a"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1zm-5 14h-1v-1h1z",
    fill: "#36353a"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v2h-1v-1z",
    fill: "#47484c"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1zm-67 8h1v1h-1z",
    fill: "#313233"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M88 17h1v1h-1zm-5 10v-1h1v1z",
    fill: "#6c6c6e"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19H8v-1h1zm51 12h1v1h-1z",
    fill: "#505154"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18h1v1h-1zm67 10v-1h1v1z",
    fill: "#6e6e71"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-2h1v2z",
    fill: "#0a0a0b"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1zm31 2h1v1h-1z",
    fill: "#0a0a0c"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1zm-48 2h1v1h-1z",
    fill: "#08090a"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M89 18h1v1h-1zm-10 5h-1v-1h1z",
    fill: "#4f4f51"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1zm-10 8v1h-1v-1z",
    fill: "#515153"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M93 18v1h-1v-1zm-6 18v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M11 20v-1h1v1zm56 9v-1h1v1z",
    fill: "#434446"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M39 19v1h-1v-1zm40 1h1v1h-1z",
    fill: "#07080a"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1zm-46 4v1h-1v-1z",
    fill: "#0b0d0c"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20h1v1h-1zm30 6v1h-1v-1z",
    fill: "#242628"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h2v1h-2z",
    fill: "#10100f"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1zm-46 3h-1v-1h1z",
    fill: "#38393c"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1zm6 8h-1v-1h1z",
    fill: "#070709"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1zm-41 7h1v1h-1z",
    fill: "#313332"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1zm-20 2h-1v-1h1z",
    fill: "#101211"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1zm-21 2v1h-1v-1z",
    fill: "#111312"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1zm-4 4v1h-1v-1z",
    fill: "#545557"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M31 24v-1h2v1h-1z",
    fill: "#0e0f0f"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23h2v1h-2z",
    fill: "#0d0e0d"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M5 25v-1h1v1zm46-1h1v1h-1z",
    fill: "#333235"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M31 25h-1v-1h1zm9 0h1v1h-1z",
    fill: "#111213"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M33 24v1h-1v-1zm5 1v-1h1v1z",
    fill: "#0d0f0e"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24v1h-2v-1h1z",
    fill: "#0a0c0b"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24h1v1h-2v-1z",
    fill: "#090b0a"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h2v1h-1z",
    fill: "#111313"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1zm0 6v1h-1v-1z",
    fill: "#202023"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1zm25-1h1v1h-1z",
    fill: "#424246"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1zm-57 5h-1v-1h1z",
    fill: "#101013"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1zm3 0h-1v-1h1z",
    fill: "#26272b"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28v-1h1v1zm0 2v1h-1v-1z",
    fill: "#212322"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1zM37 127h1v1h-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.031
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M12 29h-1v-1h1zm38 2v1h-1v-1z",
    fill: "#2a292c"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#464847"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M26 29h-1v-1h1zm22 3h-1v-1h1z",
    fill: "#1c1d1e"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1zm5 0v1h-1v-1z",
    fill: "#4f5054"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M64 29h-2v-1h2z",
    fill: "#525357"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#363837"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M14 31h1v1h-1zm14 85v1h-1v-1z",
    fill: "#cfcdc6"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1zm-55 86v-1h1v1z",
    fill: "#cbc8c5"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v2h-1v-1z",
    fill: "#dedcd8"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M84 32h-1v-1h2v1z",
    fill: "#dad9d5"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1zm-3 0h1v1h-1z",
    fill: "#dfdeda"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32h1v1H8zm69 66h1v1h-1z",
    fill: "#e9e9e9",
    fillOpacity: 0.047
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M14 33h-2v-1h2z",
    fill: "#d5cec8"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32h1v1h-1zm5 90h1v1h-1z",
    fill: "#cccac0"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M26 32v1h-1v-1zm16 2h-1v-1h1z",
    fill: "#c6c6bc"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1zm2-1h1v1h-1z",
    fill: "#292925"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1zm8 1v-1h1v1z",
    fill: "#deddd9"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M12 34v-1h1v1zm12 70h-1v-1h1z",
    fill: "#d4cfc9"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33v1h-1v-1zm10 80v-1h1v1z",
    fill: "#d2cdc3"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v1h-1v-1zm3 2h-1v-1h1z",
    fill: "#d0ccc0"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34h-1v-1h1zm11 1v-1h1v1z",
    fill: "#c9c5b9"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34h-2v-1h2z",
    fill: "#cac8bd"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M41 34h-2v-1h2z",
    fill: "#c7c7bc"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h-1v-1h2v1z",
    fill: "#dedbd4"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1zm-22 4h1v1h-1z",
    fill: "#e2dfd8"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1zM54 47v-1h1v1z",
    fill: "#e7e6e2"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M14 34h1v1h-1zm8 70v-1h1v1z",
    fill: "#d2d0c7"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M17 35h-1v-1h1zm17 81h1v1h-1z",
    fill: "#d3d0c5"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M19 35h-2v-1h2z",
    fill: "#d2cfc3"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M21 34v1h-1v-1zm5 1v1h-1v-1z",
    fill: "#d2cec2"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1zm13-1v1h-1v-1z",
    fill: "#cbc9bd"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-2v-1h2z",
    fill: "#c7c8ba"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h2v1h-1z",
    fill: "#c9cabc"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1zm-8 2h-1v-1h1z",
    fill: "#cfcdc0"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1zm-17 2h1v1h-1z",
    fill: "#d4cfc5"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1zm-14 84v1h-1v-1z",
    fill: "#d5cfc5"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1zm1 1v-1h1v1z",
    fill: "#d6d2c5"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1zm-34 7v1h-1v-1z",
    fill: "#d8d4c7"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1zm-22 68v-1h1v1z",
    fill: "#dad6c9"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1zm-22 6v-1h1v1z",
    fill: "#d8d8c8"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1zm-21 6v1h-1v-1z",
    fill: "#d9d7c9"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1zm-20 7h-1v-1h1z",
    fill: "#dfdbd2"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1zm-23 9v1h-1v-1z",
    fill: "#e0dcd3"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h2v1z",
    fill: "#e1ded5"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1zm-23 74h-1v-1h1z",
    fill: "#e4e1d7"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1zm-22 71h-1v-1h1z",
    fill: "#e4e1da"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1zm-16 2h1v1h-1z",
    fill: "#e4e1dc"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1zm-15 3v1h-1v-1z",
    fill: "#e5e1dd"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1zm-27 7v1h-1v-1z",
    fill: "#e5e1df"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1zm-30 77h1v1h-1z",
    fill: "#e5e1e0"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1zm-32 72h1v1h-1z",
    fill: "#e5e3e0"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36v-1h1v1zm11 70v-1h1v1z",
    fill: "#d1d2c7"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M17 36v-1h1v1zm11 0v1h-1v-1z",
    fill: "#d3d1c5"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h2v1h-2z",
    fill: "#d0cec1"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1zm3 0h-1v-1h1z",
    fill: "#d1cfc2"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1zm-28 7v-1h1v1z",
    fill: "#d3cfc3"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1zm3 0h-1v-1h1z",
    fill: "#d5d0c4"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1zm-26 65v-1h1v1z",
    fill: "#d5d1c5"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1zm-13 79h-1v-1h1z",
    fill: "#d7d2c7"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1zm-15 4h1v1h-1z",
    fill: "#dbd5cb"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-2v-1h1z",
    fill: "#ddd7cc"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1zm-17 68v1h-1v-1z",
    fill: "#dedcd1"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1zm-16 8h-1v-1h1z",
    fill: "#dfdcd2"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M66 35v1h-2v-1h1z",
    fill: "#e4dfd8"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1zm-17 87h-1v-1h1z",
    fill: "#e4e0d9"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1zm-17 6h-1v-1h1z",
    fill: "#e4e0d8"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M69 36v-1h2v1h-1z",
    fill: "#e6e2db"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1zm-21 4v-1h1v1z",
    fill: "#e8e4e2"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1zm-20 88h1v1h-1z",
    fill: "#f2f0eb"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1zm-1 87v-1h1v1z",
    fill: "#d6cdc4"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M47 37h-1v-1h2v1z",
    fill: "#d7d3c7"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1zm-13 69v1h-1v-1z",
    fill: "#e2dbd3"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1zm-11 5v1h-1v-1z",
    fill: "#e3dfd9"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1zm-6 2v1h-1v-1z",
    fill: "#e7e3df"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1zM10 49v1H9v-1z",
    fill: "#0ff",
    fillOpacity: 0.004
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38h-1v-1h1zm16 64v1h-1v-1z",
    fill: "#d7d4c8"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1zm-12 6v1h-1v-1z",
    fill: "#e1dcd2"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1zm-9 68h-1v-1h1z",
    fill: "#dfdbd1"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1zm-2 82h-1v-1h1z",
    fill: "#e5e0dc"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1zm-14 4v-1h1v1z",
    fill: "#eae5e3"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1zm-2 1v1h-1v-1z",
    fill: "#ede9e7"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40h-1v-1h1zm2 0v1h-1v-1z",
    fill: "#d6d5c8"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1zm-1 2v1h-1v-1z",
    fill: "#dad3ca"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1zm5-1v1h-1v-1z",
    fill: "#d9d6ca"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M31 39h1v2h-1v-1z",
    fill: "#d8d6ca"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39h2v1h-2z",
    fill: "#dbd9cc"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1zm-1 85v-1h1v1z",
    fill: "#e0ddd0"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1zm-3 78v1h-1v-1z",
    fill: "#e1ddd4"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1zm-5 68v-1h1v1z",
    fill: "#e7e3de"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1zm-3 64v1h-1v-1z",
    fill: "#e6e3db"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1zm0 0v1h-1v-1z",
    fill: "#e9e5e4"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v-1h1v1zm4 1v-1h1v1z",
    fill: "#d8d4c8"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1zm-13 85h-1v-1h1z",
    fill: "#eae6e4"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M14 41v1h-1v-1zm9 2v1h-1v-1z",
    fill: "#d6d6c9"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M15 42v-1h2v1h-1z",
    fill: "#dbd3c8"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M18 41v1h-1v-1zm0 1h1v1h-1z",
    fill: "#dad3c8"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1zm-15 6h-1v-1h1z",
    fill: "#e8e7e1"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1zm-8 65v-1h1v1z",
    fill: "#e9e7e3"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-2v-1h2z",
    fill: "#ebe7e6"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1zm-6 2v1h-1v-1z",
    fill: "#ebe8e4"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1zm-3 61v1h-1v-1z",
    fill: "#eeeae6"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1zm-4 2v-1h1v1z",
    fill: "#edebe5"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1zm0 64v1h-1v-1z",
    fill: "#e1ded3"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1zm1 80v1h-1v-1z",
    fill: "#e4dfda"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1zm-9 5h-1v-1h1z",
    fill: "#e9e8e3"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h-1v-2h1v1z",
    fill: "#ede8e5"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1zm-3 2h-1v-1h1z",
    fill: "#ebebe6"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1zm7 64h1v1h-1z",
    fill: "#d8d5ca"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v1h-1v-2h1z",
    fill: "#dad6cd"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1zm1 63v1h-1v-1z",
    fill: "#e2dfd5"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1zm1 71v-1h1v1z",
    fill: "#e4e0d7"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1zm1 65v-1h1v1z",
    fill: "#e7e2e0"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1zm1 60h-1v-1h1z",
    fill: "#ebe8e5"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45v-1h1v1zm4 22v-1h1v1z",
    fill: "#986f52"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1zm11 58h1v1h-1z",
    fill: "#dbd8c9"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1zm1 58v1h-1v-1z",
    fill: "#e0dccf"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1zm-12 2h1v1h-1z",
    fill: "#f1ece3"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1zm5 60v1h-1v-1z",
    fill: "#dddace"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1zm3 75v-1h1v1z",
    fill: "#e4dfd9"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-2v-1z",
    fill: "#ebeae3"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1zm6 56v-1h1v1z",
    fill: "#eceae4"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1zm-3 7v-1h1v1z",
    fill: "#c08f64"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M12 46h1v1h-1zm3 35h1v1h-1z",
    fill: "#946b4d"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M15 47h-1v-1h1zm0 7v-1h1v1z",
    fill: "#976c4a"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46h1v1h-1zm0 27h1v1h-1z",
    fill: "#906542"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1zm3 63h1v1h-1z",
    fill: "#e2e0d3"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1zm4 56v1h-1v-1z",
    fill: "#e2e1d5"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1zm1 80v-1h1v1z",
    fill: "#e2e1d8"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1zm3 62v1h-1v-1z",
    fill: "#e5e2db"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1zm5 57v1h-1v-1z",
    fill: "#e7e6e1"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1zm0 62v-1h1v1z",
    fill: "#e8e6e2"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1zm-1 80v-1h1v1z",
    fill: "#e8e5e3"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm3 58h1v1h-1z",
    fill: "#e9e7e4"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-2v-1z",
    fill: "#f1ebe6"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M15 48v-1h1v1zm3 15h-1v-1h1z",
    fill: "#9b6f4c"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M19 48v-1h1v1zm0 22h1v1h-1z",
    fill: "#946844"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1zm24 55h-1v-1h1z",
    fill: "#91623e"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1zm-3 19v-1h1v1z",
    fill: "#916342"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1zm-3 48h-1v-1h1z",
    fill: "#8b5f3f"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h2v1z",
    fill: "#eae3d7"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M12 49h-1v-1h1zm2 24h1v1h-1z",
    fill: "#9a7255"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h-1v-1h1zm3 26h1v1h-1z",
    fill: "#976d51"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49h-1v-1h1zm2 33v-1h1v1z",
    fill: "#976b4c"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M15 49v-1h1v1zm0 6h1v1h-1z",
    fill: "#916643"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M17 48h1v1h-1zm1 11v1h-1v-1z",
    fill: "#986c49"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1zm0 49h1v1h-1z",
    fill: "#7f5432"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1zm-6 46h-1v-1h1z",
    fill: "#be8a5f"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h1v1h-1zm3 21v-1h1v1z",
    fill: "#997255"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49h1v1h-1zm0 5v-1h1v1z",
    fill: "#986f53"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1zm-2 45v1h-1v-1z",
    fill: "#8b6240"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1zm1 34v-1h1v1z",
    fill: "#8c603c"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1zm1 7v-1h1v1z",
    fill: "#8b5b37"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1zm1 5h1v1h-1z",
    fill: "#915f3b"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1zm6-1v1h-1v-1z",
    fill: "#925f3a"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1zm1 46v1h-1v-1z",
    fill: "#935f3d"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1zm2 49h1v1h-1z",
    fill: "#ad7c53"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1zm3 10v1h-1v-1z",
    fill: "#be8b5e"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M12 51v-1h1v1zm1 8v-1h1v1z",
    fill: "#986d52"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M18 50h1v1h-1zm3 38v-1h1v1z",
    fill: "#966948"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M21 51h-1v-1h1zm-1 30h1v1h-1z",
    fill: "#8e6241"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1zm0 23v1h-1v-1z",
    fill: "#8b5f3d"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1zm2 28v1h-1v-1z",
    fill: "#95613f"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1zm4 49v1h-1v-1z",
    fill: "#a06b44"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1zm2 48v1h-1v-1z",
    fill: "#9b6640"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1zm-2 36v1h-1v-1z",
    fill: "#ac764f"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1zm-4 15v-1h1v1z",
    fill: "#b37e57"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1zm1 40h-1v-1h1z",
    fill: "#b47f58"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51v-1h1v1zm-1 9h-1v-1h1z",
    fill: "#bc865f"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1zm1 14h1v1h-1z",
    fill: "#885d3a"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1zm2 0h1v1h-1z",
    fill: "#885937"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1zm6 46h-1v-1h1z",
    fill: "#8f5e3a"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1zm4 2h-1v-1h1z",
    fill: "#96623d"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1zm0 10v-1h1v1z",
    fill: "#986341"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1zm-2 12h1v1h-1z",
    fill: "#996543"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1zm-3 25v-1h1v1z",
    fill: "#ad7755"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1zm-5 34h-1v-1h1z",
    fill: "#af7956"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1zm-8 40h1v1h-1z",
    fill: "#ab7450"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M71 52v-1h1v1zm3 20v1h-1v-1z",
    fill: "#c18b60"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1zm-2 32h1v1h-1z",
    fill: "#ba8558"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1zm-4 23h-1v-1h1z",
    fill: "#c69064"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#be8d62"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M19 52v1h-1v-1zm-3 8h-1v-1h1z",
    fill: "#986d49"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M20 52h1v1h-1zm-1 19h1v1h-1z",
    fill: "#916541"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1zm0 42h-1v-1h1z",
    fill: "#845736"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1zm-2 7h1v1h-1z",
    fill: "#885834"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1zm2 2v-1h1v1z",
    fill: "#9a6541"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1zm-1 0h1v1h-1z",
    fill: "#976140"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M55 52v1h-1v-1zm1 10v-1h1v1z",
    fill: "#ae7855"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h-1v-1h1zm4 8h1v1h-1z",
    fill: "#c28e62"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M72 52h1v1h-1zm-1 24h1v1h-1z",
    fill: "#c38e61"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M15 54h-1v-1h1zm1 27h1v1h-1z",
    fill: "#9b7052"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53h1v1h-1zm3 4v-1h1v1z",
    fill: "#926744"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M19 54h-1v-1h1zm0 6v1h-1v-1z",
    fill: "#956946"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1zm-1 10v-1h1v1z",
    fill: "#8c5d3b"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M45 53v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#945f3c"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1zm-1 12h-1v-1h1z",
    fill: "#be895e"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M72 53h1v1h-1zm1 8v1h-1v-1z",
    fill: "#b68155"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1zm-5 40h1v1h-1z",
    fill: "#c39064"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1zm0 3h-1v-1h1z",
    fill: "#8d5c3a"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54v1h-1v-1zm-2 8h-1v-1h1z",
    fill: "#ba855a"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M19 55h1v1h-1zm16 28h-1v-1h1z",
    fill: "#8f6440"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M21 55h1v1h-1zm-2 13v-1h1v1z",
    fill: "#946747"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1zm-2 36h1v1h-1z",
    fill: "#8c603e"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1zm-1 40v1h-1v-1z",
    fill: "#805331"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55v1h-1v-1zm0 38h-1v-1h1z",
    fill: "#9d6743"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1zm2 25v-1h1v1z",
    fill: "#8b5b3a"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1zm8 44v-1h1v1z",
    fill: "#94643f"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1zm-2 6h-1v-1h1z",
    fill: "#936241"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M54 56v1h-1v-1zm-6 30v1h-1v-1z",
    fill: "#a56f4a"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1zm-2 18v1h-1v-1z",
    fill: "#c89367"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1zm-3 20v1h-1v-1z",
    fill: "#c39468"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M10 57h1v1h-1zm18 68h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.024
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v-1h1v1zm-2 2v-1h1v1z",
    fill: "#9a6440"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1zm-8 19v-1h1v1z",
    fill: "#bb8560"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v-1h1v1zm-6 27h-1v-1h1z",
    fill: "#b6815a"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1zm2 8v-1h1v1z",
    fill: "#c79467"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v2h-1z",
    fill: "#c19066"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M19 58v1h-1v-1zm4 6v-1h1v1z",
    fill: "#966a48"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M21 58v1h-1v-1zm1 11h1v1h-1z",
    fill: "#8e6240"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1zm-1 6v-1h1v1z",
    fill: "#bd8861"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1zm2 2v1h-1v-1z",
    fill: "#c08b60"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1zm-2 10h-1v-1h1z",
    fill: "#c49061"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M19 60h-1v-1h1zm1 8v1h-1v-1z",
    fill: "#966947"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1zm-3 22h1v1h-1z",
    fill: "#c99468"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1zm-5 7v1h-1v-1z",
    fill: "#be8a5c"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1zm1 24h1v1h-1z",
    fill: "#af7952"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62v-1h1v1zm3 10v-1h1v1z",
    fill: "#986c4a"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M41 61v1h-1v-1zm2 36v-1h1v1z",
    fill: "#905f3c"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1zm0 4h1v1h-1z",
    fill: "#b8825d"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1zm-1 0h1v1h-1z",
    fill: "#c38e66"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M68 62h-1v-1h1zm-2 17v-1h1v1z",
    fill: "#bf8a61"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h1v2h-1v-1z",
    fill: "#c59164"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M16 62h1v1h-1zm3 6v1h-1v-1z",
    fill: "#976a49"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1zm-6 6h1v1h-1z",
    fill: "#ba855e"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1zm-3 23h1v1h-1z",
    fill: "#c29364"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M15 64h-1v-1h1zm2 14v-1h1v1z",
    fill: "#996e4e"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M17 64h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#956948"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1zm3 20v1h-1v-1z",
    fill: "#845534"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1zm0 2v-1h1v1z",
    fill: "#946342"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M61 64h-1v-1h1zm1 0v-1h1v1z",
    fill: "#bd8763"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M68 63v1h-1v-1zm-6 19h-1v-1h1z",
    fill: "#b58057"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1zm-4 26v-1h1v1z",
    fill: "#c19163"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M15 65v-1h1v1zm4 24v1h-1v-1z",
    fill: "#956949"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M43 65v1h-1v-2h1z",
    fill: "#9c6a47"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M57 65h-1v-1h1zm3 33h-1v-1h1z",
    fill: "#ae7851"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M66 64v1h-1v-1zm-5 3v1h-1v-1z",
    fill: "#be8862"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65h-1v-1h1zm-3 12h1v1h-1z",
    fill: "#c29063"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M22 66h-1v-1h1zm6 22h1v1h-1z",
    fill: "#885b3a"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h-1v-1h1zm-3 30h-1v-1h1z",
    fill: "#815533"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66v-1h1v1zm0 13v-1h1v1z",
    fill: "#905f3d"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66h-1v-1h1zm2 21h-1v-1h1z",
    fill: "#ac774f"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M42 67v-1h1v1zm2 16h-1v-1h1z",
    fill: "#9a6845"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M51 66h1v1h-1zm0 29v1h-1v-1z",
    fill: "#a26c49"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66h1v1h-1zm7 19v1h-1v-1z",
    fill: "#b9835c"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67v-1h1v1zm-6 22v-1h1v1z",
    fill: "#b07b53"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M69 66h1v1h-1zm8 1v1h-1v-1z",
    fill: "#c48f62"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1zm-1 7v-1h1v1z",
    fill: "#c59165"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M53 67h1v1h-1zm-4 14h-1v-1h1z",
    fill: "#aa7451"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M68 67v1h-1v-1zm7 24h-1v-1h1z",
    fill: "#c18c62"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1zm3 3v-1h1v1z",
    fill: "#c59162"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-2h1z",
    fill: "#c59569"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M17 69h-1v-1h1zm-1 15h1v1h-1z",
    fill: "#956c4e"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M35 68v1h-1v-1zm6 6v1h-1v-1z",
    fill: "#8a5b3a"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69v-1h1v1zm1 12v-1h1v1z",
    fill: "#956544"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1zm-2 7h-1v-1h1z",
    fill: "#bf8962"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68h1v1h-1zm-3 6h-1v-1h1z",
    fill: "#bf8a62"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M66 69h-1v-1h1zm-3 8h-1v-1h1z",
    fill: "#bb865f"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1zm6 21v-1h1v1z",
    fill: "#c28d63"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M71 68v1h-1v-1zm5 2v1h-1v-1z",
    fill: "#bf8b5c"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M30 69h1v1h-1zm5 12v-1h1v1z",
    fill: "#8b5e3b"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70v-1h1v1zm0 12h1v1h-1z",
    fill: "#8a5938"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M39 69h1v1h-1zm-2 2v1h-1v-1z",
    fill: "#8d5d3c"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1zm0 12v1h-1v-1z",
    fill: "#956340"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1zm0 27v-1h1v1z",
    fill: "#b27d55"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M69 69h1v1h-1zm7 13h1v1h-1z",
    fill: "#c38f61"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M80 69v2h-1v-2z",
    fill: "#c19167"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70h1v2h-1v-1z",
    fill: "#946e50"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1zm-2 1h1v1h-1z",
    fill: "#865b38"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M37 70h1v1h-1zm3 20h1v1h-1z",
    fill: "#885736"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71v1h-1v-1zm2 10v-1h1v1z",
    fill: "#946443"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h2v1h-2z",
    fill: "#90603f"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1zm-3 4h-1v-1h1z",
    fill: "#9a6441"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#bc8661"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M72 71h1v1h-1zm-1 16h1v1h-1z",
    fill: "#b98457"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M74 71h1v1h-1zm-5 14v-1h1v1z",
    fill: "#c18c5e"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73v-1h1v1zm1 4v1h-1v-1z",
    fill: "#956b4d"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M19 72v1h-1v-1zm0 13h-1v-1h1z",
    fill: "#916644"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1zm0 0v1h-1v-1z",
    fill: "#a16b49"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1zm8 18h1v1h-1z",
    fill: "#aa754e"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h-1v-1h1zm-1 23v-1h1v1z",
    fill: "#8f5c3b"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1zm5 9v1h-1v-1z",
    fill: "#c58f63"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-2h1v1z",
    fill: "#935d3d"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1zm-1 16v-1h1v1z",
    fill: "#c39366"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M18 76h-1v-1h1zm-1 6h1v1h-1z",
    fill: "#966a4d"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1zm0 20h1v1h-1z",
    fill: "#905c3c"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75v1h-1v-1zm1 17v-1h1v1z",
    fill: "#99633e"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M46 75h1v2h-1v-1z",
    fill: "#a16b48"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M62 76v-1h1v1zm9 19v1h-1v-1z",
    fill: "#b7835c"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1zm-3 7h1v1h-1z",
    fill: "#bb8658"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1zm0 11h-1v-1h1z",
    fill: "#c39365"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76v1h-1v-1zm1 8v-1h1v1z",
    fill: "#986e51"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M32 76v1h-1v-1zm4 6v1h-1v-1z",
    fill: "#885b38"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1zm-2 13v-1h1v1z",
    fill: "#8d5e3c"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1zm3 0v1h-1v-1z",
    fill: "#945f3e"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1zm4 7h1v1h-1z",
    fill: "#a7714c"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M62 77h-1v-1h1zm-4 1h1v1h-1z",
    fill: "#b58059"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M68 76v1h-1v-1zm8 12h1v1h-1z",
    fill: "#c48f66"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78h-1v-1h1zm1 8v1h-1v-1z",
    fill: "#916543"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v-1h1v1zm0 5h1v1h-1z",
    fill: "#92694b"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1zm0 4h-1v-1h1z",
    fill: "#906140"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79h1v1h-1zm1 7v1h-1v-1z",
    fill: "#946c4d"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79v1h-1v-1zm-1 10v-1h1v1z",
    fill: "#926747"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M31 79v1h-1v-1zm5 10v1h-1v-1z",
    fill: "#855835"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M32 79h1v1h-1zm8 21v1h-1v-1z",
    fill: "#7f5230"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1zm11 18v1h-1v-1z",
    fill: "#b47c58"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M24 80h1v1h-1zm3 11h1v1h-1z",
    fill: "#8a5e39"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1zm-3 11h-1v-1h1z",
    fill: "#915b39"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h1v1zm-2 11h1v1h-1z",
    fill: "#9d6745"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1zm-2 7v-1h1v1z",
    fill: "#b68156"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1zm0 7v1h-1v-1z",
    fill: "#c89369"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1zm0 2h1v1h-1z",
    fill: "#895736"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M78 81v1h-1v-1zm-1 3v1h-1v-1z",
    fill: "#c49263"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M19 82v1h-1v-1zm1 5h1v1h-1z",
    fill: "#926645"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M24 82h1v1h-1zm-2 4h1v1h-1z",
    fill: "#8e613f"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M66 82h1v1h-1zm4 10h-1v-1h1z",
    fill: "#bc885f"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M40 84v-1h1v2h-1z",
    fill: "#885635"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M58 83v1h-1v-1zm1 4v-1h1v1z",
    fill: "#b37e56"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1zm4 1v-1h1v1z",
    fill: "#c08b63"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1zm-1 3v-1h1v1z",
    fill: "#b9855a"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M25 84v1h-1v-1zm5 4h-1v-1h1z",
    fill: "#865938"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1zm13 9v1h-1v-1z",
    fill: "#b07a53"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M60 85h-1v-1h1zm8 9h-1v-1h1z",
    fill: "#b68158"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84h1v1h-1zm3 6v1h-1v-1z",
    fill: "#b58158"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1zm1 6h-1v-1h1z",
    fill: "#b68257"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1zm-6 11v-1h1v1z",
    fill: "#815432"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1zm-2 3h1v1h-1z",
    fill: "#90603e"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v2h-1z",
    fill: "#8e5b3b"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1zm11 14h1v1h-1z",
    fill: "#a36e49"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1zm3 13h-1v-1h1z",
    fill: "#a06a44"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1zm3 11v1h-1v-1z",
    fill: "#ad7850"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M66 86h-1v-1h1zm-8 0v1h-1v-1z",
    fill: "#b37e54"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M68 86v1h-1v-2h1z",
    fill: "#b8855a"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87h-1v-1h1zm-7 6h1v1h-1z",
    fill: "#885c3a"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1zm0 2h-1v-1h1z",
    fill: "#825533"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1zm-1 3h-1v-1h1z",
    fill: "#8f603e"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#bc885a"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M31 88h-1v-1h1zm-1 4h1v1h-1z",
    fill: "#865a38"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1zm3 8v1h-1v-1z",
    fill: "#8e5c3b"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1zm0 5v-1h1v1z",
    fill: "#8f5a3a"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1zm2 0h1v1h-1z",
    fill: "#9c6541"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-2h1z",
    fill: "#a36a47"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v2h-1v-2z",
    fill: "#a36f4a"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1zm4 4h1v1h-1z",
    fill: "#ae7950"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#ad7851"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1zm6 4h1v1h-1z",
    fill: "#b9855b"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1zm-2 1h1v1h-1z",
    fill: "#c59066"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M21 88v2h-1v-2z",
    fill: "#936747"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89v-1h1v2h-1z",
    fill: "#905b3b"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1zm3 3h1v1h-1z",
    fill: "#af7a52"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1zm1 3v1h-1v-1z",
    fill: "#935d3b"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1zm-2 3h-1v-1h1z",
    fill: "#b47e57"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1zm4 3v1h-1v-1z",
    fill: "#bb875e"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M68 91h-2v-1h2z",
    fill: "#ba865d"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1zm1 1h1v1h-1z",
    fill: "#bf8c61"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v1h-2v-1h1z",
    fill: "#8c5f3d"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1zm11 3v1h-1v-1z",
    fill: "#b17d55"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h2v1h-1z",
    fill: "#ba875c"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M29 94h1v1h-1zm2 4h-1v-1h1z",
    fill: "#815433"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96h-1v-2h1v1z",
    fill: "#95603d"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M32 96v-1h1v1zm2 0v1h-1v-1z",
    fill: "#7d512e"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1zm-6 5h1v1h-1z",
    fill: "#9f6d47"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97h-1v-1h1zm-3 0v1h-1v-1z",
    fill: "#b17c55"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M41 97v2h-1v-2z",
    fill: "#8b5d3c"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M30 98v1h-1v-1zm4 1v1h-1v-1z",
    fill: "#7f502e"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v1h-1v-1zm15 23v1h-1v-1z",
    fill: "#ddd5ca"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101h1v2h-1v-1z",
    fill: "#eae7e6"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M23 103h-1v-1h1zm2 3h-1v-1h1z",
    fill: "#d2d1c7"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M22 103v1h-1v-1zm2 4v-1h1v1z",
    fill: "#d1d1c7"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M30 104h-1v-1h1zm4 8v-1h1v1z",
    fill: "#dbd2c9"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103h2v1h-2z",
    fill: "#e0dbd2"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M56 104v-1h1v1zm-3 0h1v1h-1z",
    fill: "#e7e5db"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M22 104h1v1h-2v-1z",
    fill: "#d1d1c8"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M39 106v-2h1v2z",
    fill: "#dddcd0"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1zm1 7h-1v-1h1z",
    fill: "#e1dfd3"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v1h-2v-1h1z",
    fill: "#e2e0d5"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105h1v1h-2v-1z",
    fill: "#e9e5e0"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1zm-59 7v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M20 107v-1h1v1zm11 18h-1v-1h1z",
    fill: "#d1d0c9"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v-1h2v1h-1z",
    fill: "#d0d2c5"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1zm4 19v-1h1v1z",
    fill: "#e0dbd0"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106h2v1h-2z",
    fill: "#e1dcd4"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M23 107v1h-2v-1h1z",
    fill: "#d1cfc6"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M25 107v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#d2d0c6"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M26 108h-1v-1h2v1z",
    fill: "#d1d0c6"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M29 107v2h-1v-2z",
    fill: "#d4d1c7"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-2h1z",
    fill: "#e0dbcf"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-2h1v2z",
    fill: "#e1dad0"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1zm2 4h-1v-1h1z",
    fill: "#e3e1d4"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1zm4 14h-1v-1h1z",
    fill: "#e5e1d7"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1zm2-1h1v1h-1z",
    fill: "#e8e6e1"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108v2h-1v-2z",
    fill: "#d1cfc7"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M36 110h-1v-1h1zm5 13v1h-1v-1z",
    fill: "#dbd5ca"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h2v1z",
    fill: "#e6e3e0"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M21 110v1h-1v-1zm-1 2h1v1h-1z",
    fill: "#d1d0c8"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M42 110v2h-1v-2z",
    fill: "#dddbcf"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v2h-1v-1z",
    fill: "#dfdcd1"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M45 111v1h-1v-2h1z",
    fill: "#e1dcd1"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-2h1v2z",
    fill: "#e1ded2"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h2v1h-2z",
    fill: "#e1dfd2"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M25 112v1h-1v-1zm9 11h-1v-1h1z",
    fill: "#d0cfc4"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1zm0 0h1v1h-1z",
    fill: "#dcd8cd"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v1h-1v-1zm3 4h-1v-1h1z",
    fill: "#ccc9c2"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M25 114h-1v-1h1zm8 6h1v1h-1z",
    fill: "#d0cfc3"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M38 113h1v1h-1zm2 12h-1v-1h1z",
    fill: "#dbd6cb"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#f1f0eb"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114h1v1h-1zm0 3h-1v-1h1z",
    fill: "#e3ded7"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M23 115v2h-1v-2z",
    fill: "#ccc7c3"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M25 116v-1h1v1zm7 7h1v1h-1z",
    fill: "#cecdc3"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M31 116h-1v-1h1zm3 8h1v1h-1z",
    fill: "#d4cec6"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115h1v1h-1zm2 8h-1v-1h1z",
    fill: "#e4e3dd"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M21 116h1v1h-1zm3 1v1h-1v-1z",
    fill: "#ccc9c4"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M26 117h1v1h-1zm6 7h-1v-1h1z",
    fill: "#cdccc2"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M50 117v1h-1v-1zm0 3v-1h1v1z",
    fill: "#e3ded9"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-2h1z",
    fill: "#e2ddd8"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M66 118h2v1h-2z",
    fill: "#edeae2"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M72 119v-1h1v1zm0 2h-1v-1h1z",
    fill: "#f0efeb"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M35 119v2h-1v-2z",
    fill: "#d2cfc4"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M35 119h1v2h-1v-1z",
    fill: "#d5cfc4"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h2v1h-1z",
    fill: "#e2ddd6"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M37 120v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#d8cfc6"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v-1h1v2h-1z",
    fill: "#e0dbd5"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M33 123h-2v-1h2z",
    fill: "#cecdc2"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123h1v1h-1zm-1 2h1v1h-1z",
    fill: "#e4e1d9"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v-1h1v1zm-1 1v-1h1v1z",
    fill: "#e7e4de"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M13 0h1v1h-1z",
    fill: "#717171",
    fillOpacity: 0.106
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M14 0h1v1h-1z",
    fill: "#6a6e6a",
    fillOpacity: 0.235
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0h1v1h-1z",
    fill: "#6c696f",
    fillOpacity: 0.322
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M17 0v1h-1V0z",
    fill: "#313134",
    fillOpacity: 0.384
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1V0h1v1z",
    fill: "#313131",
    fillOpacity: 0.424
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M18 0h1v1h-1z",
    fill: "#303030",
    fillOpacity: 0.435
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1h-1V0h1z",
    fill: "#454842",
    fillOpacity: 0.329
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M20 1V0h1v1z",
    fill: "#a5a5a5",
    fillOpacity: 0.078
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M29 0h1v1h-1z",
    fill: "#c8c8c8",
    fillOpacity: 0.055
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0h1v1h-1z",
    fill: "#adadad",
    fillOpacity: 0.098
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1V0h1v1z",
    fill: "#a7a7a7",
    fillOpacity: 0.114
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M33 1h-1V0h1z",
    fill: "#9b9b9b",
    fillOpacity: 0.141
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M33 0h1v1h-1z",
    fill: "#9c9c98",
    fillOpacity: 0.204
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M35 1h-1V0h1z",
    fill: "#939393",
    fillOpacity: 0.251
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M35 0h1v1h-1z",
    fill: "#8d8d89",
    fillOpacity: 0.29
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M36 0h1v1h-1z",
    fill: "#878787",
    fillOpacity: 0.318
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1V0h1v1z",
    fill: "#7c7f7f",
    fillOpacity: 0.337
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M39 1h-1V0h1z",
    fill: "#797c79",
    fillOpacity: 0.353
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M39 0h1v1h-1z",
    fill: "#767876",
    fillOpacity: 0.373
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M41 1h-1V0h1z",
    fill: "#717171",
    fillOpacity: 0.38
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M42 0v1h-1V0z",
    fill: "#686666",
    fillOpacity: 0.392
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1V0h1v1z",
    fill: "#696969",
    fillOpacity: 0.4
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M43 1V0h1v1z",
    fill: "#646461",
    fillOpacity: 0.388
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M44 1V0h1v1z",
    fill: "#5a5a5a",
    fillOpacity: 0.388
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M46 0v1h-1V0z",
    fill: "#545454",
    fillOpacity: 0.38
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M47 0v1h-1V0z",
    fill: "#4d4d4d",
    fillOpacity: 0.376
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M48 1h-1V0h1z",
    fill: "#4e4e4b",
    fillOpacity: 0.369
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M49 0v1h-1V0z",
    fill: "#4c4c49",
    fillOpacity: 0.353
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M49 1V0h1v1z",
    fill: "#4b4e45",
    fillOpacity: 0.345
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M51 1h-1V0h1z",
    fill: "#4b4b48",
    fillOpacity: 0.329
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M52 0v1h-1V0z",
    fill: "#4e4e4e",
    fillOpacity: 0.318
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M53 0v1h-1V0z",
    fill: "#575353",
    fillOpacity: 0.31
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M53 0h1v1h-1z",
    fill: "#565652",
    fillOpacity: 0.302
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M54 1V0h1v1z",
    fill: "#5a5a57",
    fillOpacity: 0.286
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1V0h1v1z",
    fill: "#625e5e",
    fillOpacity: 0.255
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1h-1V0h1z",
    fill: "#606060",
    fillOpacity: 0.196
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M58 0v1h-1V0z",
    fill: "#676760",
    fillOpacity: 0.145
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1V0h1v1z",
    fill: "#76766d",
    fillOpacity: 0.11
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M60 1V0h1v1z",
    fill: "#b4b4a5",
    fillOpacity: 0.067
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1v1h-1V1z",
    fill: "#7f7f7f",
    fillOpacity: 0.008
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2h-1V1h1z",
    fill: "#383838",
    fillOpacity: 0.459
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M14 1v1h-1V1z",
    fill: "#414141",
    fillOpacity: 0.871
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h-1V1h1z",
    fill: "#545455",
    fillOpacity: 0.957
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2h-1V1h1z",
    fill: "#616163",
    fillOpacity: 0.984
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M17 1h1v1h-1z",
    fill: "#29292a"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2h-1V1h1z",
    fill: "#0b0b0a",
    fillOpacity: 0.984
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M21 2h-1V1h1z",
    fill: "#0e0e0e",
    fillOpacity: 0.835
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M21 1h1v1h-1z",
    fill: "#161616",
    fillOpacity: 0.541
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2h-1V1h1z",
    fill: "#313131",
    fillOpacity: 0.263
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2V1h1v1z",
    fill: "#777",
    fillOpacity: 0.184
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1v1h-1V1z",
    fill: "#888",
    fillOpacity: 0.322
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1v1h-1V1z",
    fill: "#737373",
    fillOpacity: 0.408
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1h1v1h-1z",
    fill: "#747474",
    fillOpacity: 0.522
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h-1V1h1z",
    fill: "#737373",
    fillOpacity: 0.639
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M28 1h1v1h-1z",
    fill: "#717373",
    fillOpacity: 0.702
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M29 1h1v1h-1z",
    fill: "#6c6c6c",
    fillOpacity: 0.796
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M30 1h1v1h-1z",
    fill: "#666868",
    fillOpacity: 0.855
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1h1v1h-1z",
    fill: "#646465",
    fillOpacity: 0.878
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M33 2h-1V1h1z",
    fill: "#5c5c5c",
    fillOpacity: 0.906
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M33 2V1h1v1z",
    fill: "#545554",
    fillOpacity: 0.937
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2h-1V1h1z",
    fill: "#4f4f4e",
    fillOpacity: 0.961
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2V1h1v1z",
    fill: "#414240",
    fillOpacity: 0.973
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1v1h-1V1z",
    fill: "#3e403e",
    fillOpacity: 0.98
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M37 1h1v1h-1z",
    fill: "#393b3a",
    fillOpacity: 0.984
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M38 2V1h1v1z",
    fill: "#393a3b",
    fillOpacity: 0.988
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M40 1v1h-1V1z",
    fill: "#393b3c",
    fillOpacity: 0.992
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M41 1v1h-1V1z",
    fill: "#37373a",
    fillOpacity: 0.996
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M42 2h-1V1h1z",
    fill: "#363539"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1h1v1h-1z",
    fill: "#38373a"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M44 1v1h-1V1z",
    fill: "#39383b"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1v1h-1V1z",
    fill: "#343337"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M47 1v1h-1V1z",
    fill: "#2e2d31",
    fillOpacity: 0.996
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M47 2V1h1v1z",
    fill: "#2c2c2d",
    fillOpacity: 0.996
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M48 2V1h1v1z",
    fill: "#282827",
    fillOpacity: 0.992
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M50 1v1h-1V1z",
    fill: "#242521",
    fillOpacity: 0.988
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M50 2V1h1v1z",
    fill: "#22231e",
    fillOpacity: 0.984
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M52 1v1h-1V1z",
    fill: "#1d1d1b",
    fillOpacity: 0.98
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2V1h1v1z",
    fill: "#1a1a18",
    fillOpacity: 0.976
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M54 2h-1V1h1z",
    fill: "#1a1917",
    fillOpacity: 0.976
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M55 2h-1V1h1z",
    fill: "#191716",
    fillOpacity: 0.969
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1h1v1h-1z",
    fill: "#1a1916",
    fillOpacity: 0.957
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1v1h-1V1z",
    fill: "#171715",
    fillOpacity: 0.937
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2V1h1v1z",
    fill: "#181815",
    fillOpacity: 0.914
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1h1v1h-1z",
    fill: "#1c1c19",
    fillOpacity: 0.886
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M60 2h-1V1h1z",
    fill: "#1f1e1d",
    fillOpacity: 0.855
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1v1h-1V1z",
    fill: "#232221",
    fillOpacity: 0.816
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1h1v1h-1z",
    fill: "#242424",
    fillOpacity: 0.749
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1v1h-1V1z",
    fill: "#252525",
    fillOpacity: 0.702
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M63 2V1h1v1z",
    fill: "#2e2e2d",
    fillOpacity: 0.663
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M64 2V1h1v1z",
    fill: "#373737",
    fillOpacity: 0.616
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2V1h1v1z",
    fill: "#3a3a3a",
    fillOpacity: 0.525
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1v1h-1V1z",
    fill: "#3f3f3c",
    fillOpacity: 0.412
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1h1v1h-1z",
    fill: "#4b4b4b",
    fillOpacity: 0.357
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1v1h-1V1z",
    fill: "#606060",
    fillOpacity: 0.259
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1v1h-1V1z",
    fill: "#646464",
    fillOpacity: 0.149
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1h1v1h-1z",
    fill: "#84847a",
    fillOpacity: 0.106
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3V2h1v1z",
    fill: "#737373",
    fillOpacity: 0.122
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V2h1v1z",
    fill: "#414141",
    fillOpacity: 0.918
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2h1v1h-1z",
    fill: "#363636"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2h1v1h-1z",
    fill: "#474747"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M20 3V2h1v1z",
    fill: "#3f3f40"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M22 3V2h1v1z",
    fill: "#4d4d4d",
    fillOpacity: 0.996
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M24 3h-1V2h1z",
    fill: "#6e6e6e",
    fillOpacity: 0.957
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M25 2v1h-1V2z",
    fill: "#828282"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M25 3V2h1v1z",
    fill: "#848484"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2h1v1h-1z",
    fill: "#7f7f7f"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M27 3V2h1v1z",
    fill: "#696969"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2h1v1h-1z",
    fill: "#646665"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M30 2v1h-1V2z",
    fill: "#616362"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M32 3V2h1v1z",
    fill: "#262829"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M34 2v1h-1V2z",
    fill: "#1c1e1d"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M35 2h1v1h-1z",
    fill: "#212321"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M39 3h-1V2h1z",
    fill: "#3c3c41"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M39 2h1v1h-1z",
    fill: "#42424a"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3h-1V2h1z",
    fill: "#43424b"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3h-1V2h1z",
    fill: "#3f3e47"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3V2h1v1z",
    fill: "#414048"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M43 2h1v1h-1z",
    fill: "#3e3d44"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3h-1V2h1z",
    fill: "#38373d"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M47 3h-1V2h1z",
    fill: "#2e2d34"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M47 2h1v1h-1z",
    fill: "#27262b"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3V2h1v1z",
    fill: "#1f1f1e"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2h1v1h-1z",
    fill: "#121211"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M54 3V2h1v1z",
    fill: "#0b0909"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3h-1V2h1z",
    fill: "#060605"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3V2h1v1z",
    fill: "#090908"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3V2h1v1z",
    fill: "#0a0a09"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3V2h1v1z",
    fill: "#1d1d1b"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h-1V2h1z",
    fill: "#252523",
    fillOpacity: 0.98
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M69 2h1v1h-1z",
    fill: "#272725",
    fillOpacity: 0.941
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M71 2v1h-1V2z",
    fill: "#2b2b29",
    fillOpacity: 0.894
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M72 2v1h-1V2z",
    fill: "#343434",
    fillOpacity: 0.776
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M73 2v1h-1V2z",
    fill: "#3b3b3d",
    fillOpacity: 0.671
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3h-1V2h1z",
    fill: "#4b4b4d",
    fillOpacity: 0.502
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2h1v1h-1z",
    fill: "#5b5b5d",
    fillOpacity: 0.384
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M75 2h1v1h-1z",
    fill: "#767676",
    fillOpacity: 0.227
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M76 2h1v1h-1z",
    fill: "#9c9c9c",
    fillOpacity: 0.102
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v1h-1V3z",
    fill: "#6b6b6b",
    fillOpacity: 0.251
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4h-1V3h1z",
    fill: "#474749",
    fillOpacity: 0.984
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4V3h1v1z",
    fill: "#2d2d30"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4h-1V3h1z",
    fill: "#3a3a3b"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3h1v1h-1z",
    fill: "#444"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M26 3v1h-1V3z",
    fill: "#343333"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M27 4h-1V3h1z",
    fill: "#2e2e2e"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M28 4V3h1v1z",
    fill: "#484a49"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4h-1V3h1z",
    fill: "#4f5251"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4V3h1v1z",
    fill: "#1d2020"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M32 4h-1V3h1z",
    fill: "#0d0d10"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3v1h-1V3z",
    fill: "#262826"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M36 4V3h1v1z",
    fill: "#323433"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4V3h1v1z",
    fill: "#37383d"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M40 3v1h-1V3z",
    fill: "#36363e"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3v1h-1V3z",
    fill: "#33323c"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3v1h-1V3z",
    fill: "#303039"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3v1h-1V3z",
    fill: "#34343c"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3h1v1h-1z",
    fill: "#323238"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3v1h-1V3z",
    fill: "#313135"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3h1v1h-1z",
    fill: "#2e2e33"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h1v1h-1z",
    fill: "#222223"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4V3h1v1z",
    fill: "#1a1b1a"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4h-1V3h1z",
    fill: "#151617"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h-1V3h1z",
    fill: "#0f0e10"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3v1h-1V3z",
    fill: "#0c0b0d"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3v1h-1V3z",
    fill: "#0e1010"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3h1v1h-1z",
    fill: "#141515"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4V3h1v1z",
    fill: "#1b1c1c"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3h1v1h-1z",
    fill: "#202120"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M71 3h1v1h-1z",
    fill: "#212223"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4h-1V3h1z",
    fill: "#343537",
    fillOpacity: 0.973
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M77 3v1h-1V3z",
    fill: "#444",
    fillOpacity: 0.875
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3v1h-1V3z",
    fill: "#595959",
    fillOpacity: 0.714
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M79 3v1h-1V3z",
    fill: "#6a6a6a",
    fillOpacity: 0.506
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M79 4V3h1v1z",
    fill: "#7f7f7f",
    fillOpacity: 0.275
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M81 4h-1V3h1z",
    fill: "#969696",
    fillOpacity: 0.086
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5V4h1v1z",
    fill: "#636366",
    fillOpacity: 0.451
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4h1v1h-1z",
    fill: "#38373c"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5V4h1v1z",
    fill: "#34363a"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M26 4v1h-1V4z",
    fill: "#211f20"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M27 5h-1V4h1z",
    fill: "#212121"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4v1h-1V4z",
    fill: "#2b302e"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M30 4h1v1h-1z",
    fill: "#4e5152"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M34 4h1v1h-1z",
    fill: "#222424"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M37 4v1h-1V4z",
    fill: "#272929"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4v1h-1V4z",
    fill: "#2f3033"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h-1V4h1z",
    fill: "#434449"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5h-1V4h1z",
    fill: "#48494f"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4h1v1h-1z",
    fill: "#4d4e54"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5V4h1v1z",
    fill: "#4d4e51"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4v1h-1V4z",
    fill: "#4b4c4e"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5V4h1v1z",
    fill: "#444646"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5V4h1v1z",
    fill: "#363738"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5V4h1v1z",
    fill: "#141518"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M68 4v1h-1V4z",
    fill: "#17181b"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M76 5V4h1v1z",
    fill: "#1a1b1b"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M80 5h-1V4h1z",
    fill: "#5c5c5c",
    fillOpacity: 0.988
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M80 4h1v1h-1z",
    fill: "#6a6a6a",
    fillOpacity: 0.855
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4v1h-1V4z",
    fill: "#737373",
    fillOpacity: 0.58
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4h1v1h-1z",
    fill: "#7d7d7d",
    fillOpacity: 0.247
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h-1V5h1z",
    fill: "#616161",
    fillOpacity: 0.643
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5h1v1h-1z",
    fill: "#2e2f35"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6h-1V5h1z",
    fill: "#35363b"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5v1h-1V5z",
    fill: "#2a2c30"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6h-1V5h1z",
    fill: "#373738"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5h1v1h-1z",
    fill: "#242325"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M25 5v1h-1V5z",
    fill: "#3f3d40"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M25 6V5h1v1z",
    fill: "#383739"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M28 5h1v1h-1z",
    fill: "#363839"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6h-1V5h1z",
    fill: "#303535"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5h1v1h-1z",
    fill: "#333637"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6V5h1v1z",
    fill: "#5d5e60"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M34 6V5h1v1z",
    fill: "#17191a"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M47 6h-1V5h1z",
    fill: "#1a1c1d"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5h1v1h-1z",
    fill: "#1e2020"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M50 5h1v1h-1z",
    fill: "#212227"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6V5h1v1z",
    fill: "#2b2d30"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h-1V5h1z",
    fill: "#25252a"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5v1h-1V5z",
    fill: "#1e1e21"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5v1h-1V5z",
    fill: "#1d1d1e"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h-1V5h1z",
    fill: "#1c1c1f"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6h-1V5h1z",
    fill: "#6e6c6f"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h-1V5h1z",
    fill: "#787779"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6V5h1v1z",
    fill: "#777778",
    fillOpacity: 0.969
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5h1v1h-1z",
    fill: "#7b7b7c",
    fillOpacity: 0.675
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M84 6V5h1v1z",
    fill: "#8c8c8c",
    fillOpacity: 0.157
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7V6h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6v1h-1V6z",
    fill: "#5e5e5e",
    fillOpacity: 0.765
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7h-1V6h1z",
    fill: "#343439"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M26 7h-1V6h1z",
    fill: "#242326"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7V6h1v1z",
    fill: "#27292b"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6v1h-1V6z",
    fill: "#232728"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M31 6v1h-1V6z",
    fill: "#212425"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6v1h-1V6z",
    fill: "#1b1c20"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M46 7h-1V6h1z",
    fill: "#343539"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M50 7V6h1v1z",
    fill: "#3f4045"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7V6h1v1z",
    fill: "#404246"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M53 6h1v1h-1z",
    fill: "#44454a"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7h-1V6h1z",
    fill: "#46474c"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7V6h1v1z",
    fill: "#48494c"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M58 6h1v1h-1z",
    fill: "#4a4a4e"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7h-1V6h1z",
    fill: "#4c4e51"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M66 7h-1V6h1z",
    fill: "#484a4e"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M67 7h-1V6h1z",
    fill: "#4e4e53"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h1v1h-1z",
    fill: "#4c4b51"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6v1h-1V6z",
    fill: "#434247"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M70 7h-1V6h1z",
    fill: "#414045"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6v1h-1V6z",
    fill: "#414044"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M71 7V6h1v1z",
    fill: "#3d3d40"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6v1h-1V6z",
    fill: "#7c7a7d"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M81 7V6h1v1z",
    fill: "#878689"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h1v1h-1z",
    fill: "#7d7d7f"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M84 7h-1V6h1z",
    fill: "#7e7e80"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7h-1V6h1z",
    fill: "#7a7a7b",
    fillOpacity: 0.827
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M86 7h-1V6h1z",
    fill: "#87878e",
    fillOpacity: 0.133
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7v1h-1V7z",
    fill: "#c4c4c4",
    fillOpacity: 0.051
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8h-1V7h1z",
    fill: "#595959",
    fillOpacity: 0.827
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M13 7v1h-1V7z",
    fill: "#373838"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8V7h1v1z",
    fill: "#2f3132"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7h1v1h-1z",
    fill: "#323338"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M25 8V7h1v1z",
    fill: "#1a191b"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M28 7h1v1h-1z",
    fill: "#1c1f20"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8h-1V7h1z",
    fill: "#393a3e"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8V7h1v1z",
    fill: "#525355"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7v1h-1V7z",
    fill: "#525259"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7h1v1h-1z",
    fill: "#53535b"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7h1v1h-1z",
    fill: "#54555b"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8V7h1v1z",
    fill: "#56575c"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8V7h1v1z",
    fill: "#58585c"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M59 7v1h-1V7z",
    fill: "#5a595e"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M61 7v1h-1V7z",
    fill: "#5b5b60"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M63 7h1v1h-1z",
    fill: "#616165"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M67 8h-1V7h1z",
    fill: "#55555a"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h-1V7h1z",
    fill: "#5f5e64"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h-1V7h1z",
    fill: "#59585e"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M72 7v1h-1V7z",
    fill: "#515055"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8V7h1v1z",
    fill: "#4f4e53"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8V7h1v1z",
    fill: "#4d4e50"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7v1h-1V7z",
    fill: "#717173"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M81 8h-1V7h1z",
    fill: "#8d8c8f"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M82 8h-1V7h1z",
    fill: "#848486"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7v1h-1V7z",
    fill: "#79797b"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7v1h-1V7z",
    fill: "#6b6b6d"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8h-1V7h1z",
    fill: "#767678",
    fillOpacity: 0.431
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9h-1V8h1z",
    fill: "#9f9f9f",
    fillOpacity: 0.125
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8h1v1h-1z",
    fill: "#555",
    fillOpacity: 0.898
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9V8h1v1z",
    fill: "#363737"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9V8h1v1z",
    fill: "#2c2e2e"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9V8h1v1z",
    fill: "#1c1e20"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M29 8h1v1h-1z",
    fill: "#1b1f20"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8v1h-1V8z",
    fill: "#1c2021"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8v1h-1V8z",
    fill: "#55565a"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M43 8h1v1h-1z",
    fill: "#58595d"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8v1h-1V8z",
    fill: "#606165"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9V8h1v1z",
    fill: "#606068"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M51 8h1v1h-1z",
    fill: "#616168"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8v1h-1V8z",
    fill: "#616167"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8h1v1h-1z",
    fill: "#606166"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M55 9h-1V8h1z",
    fill: "#616267"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M56 9h-1V8h1z",
    fill: "#626366"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8h1v1h-1z",
    fill: "#656469"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9V8h1v1z",
    fill: "#67666a"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#666569"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1z",
    fill: "#656569"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8v1h-1V8z",
    fill: "#68666b"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8v1h-1V8z",
    fill: "#6a696e"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8h1v1h-1z",
    fill: "#66666b"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1z",
    fill: "#6a696f"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1z",
    fill: "#69686f"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9h-1V8h1z",
    fill: "#6d6c73"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h1v1h-1z",
    fill: "#626167"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9h-1V8h1z",
    fill: "#616264"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M75 9V8h1v1z",
    fill: "#78797a"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M76 8h1v1h-1z",
    fill: "#818284"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M78 9h-1V8h1z",
    fill: "#8a8c8e"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9h-1V8h1z",
    fill: "#909193"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9h-1V8h1z",
    fill: "#636365"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8v1h-1V8z",
    fill: "#868688",
    fillOpacity: 0.522
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9h1v1h-1z",
    fill: "#9d9d9d",
    fillOpacity: 0.184
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10h-1V9h1z",
    fill: "#525252",
    fillOpacity: 0.949
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9h1v1h-1z",
    fill: "#333434"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9h1v1h-1z",
    fill: "#2b2e2b"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9v1h-1V9z",
    fill: "#3b3e3f"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10V9h1v1z",
    fill: "#383b3c"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9h1v1h-1z",
    fill: "#2d2f31"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10h-1V9h1z",
    fill: "#2f3435"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10V9h1v1z",
    fill: "#323536"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V9h1v1z",
    fill: "#4b4c4f"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M39 9v1h-1V9z",
    fill: "#636468"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10h-1V9h1z",
    fill: "#5e5f63"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#636469"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#67686c"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#67686d"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#68686f"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9v1h-1V9z",
    fill: "#68696e"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#6b6c6d"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#6c6d6d"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#6f7072"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V9z",
    fill: "#707173"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#737277"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#747378"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V9z",
    fill: "#757479"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10V9h1v1z",
    fill: "#78777c"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M67 9h1v1h-1z",
    fill: "#7c7b81"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10h-1V9h1z",
    fill: "#828188"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M69 10V9h1v1z",
    fill: "#84838b"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9z",
    fill: "#898890"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1z",
    fill: "#8b8a91"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9v1h-1V9z",
    fill: "#8c8b8f"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10V9h1v1z",
    fill: "#868789"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M76 10h-1V9h1z",
    fill: "#787a79"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10h-1V9h1z",
    fill: "#686b6c"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M77 10V9h1v1z",
    fill: "#56595b"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M85 10h-1V9h1z",
    fill: "#6d6d70"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M85 9h1v1h-1z",
    fill: "#959596",
    fillOpacity: 0.557
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10v1h-1v-1z",
    fill: "#8f8f8f",
    fillOpacity: 0.278
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10v1h-1v-1z",
    fill: "#4e4d4d",
    fillOpacity: 0.992
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11h-1v-1h1z",
    fill: "#323232"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10v1h-1v-1z",
    fill: "#2b2d2e"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10h1v1h-1z",
    fill: "#2e2e30"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10v1h-1v-1z",
    fill: "#37393a"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11v-1h1v1z",
    fill: "#302e31"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11v-1h1v1z",
    fill: "#2d2c30"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11v-1h1v1z",
    fill: "#18171b"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10h1v1h-1z",
    fill: "#0a0a0e"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10h1v1h-1z",
    fill: "#4d4d4f"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10v1h-1v-1z",
    fill: "#646466"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10v1h-1v-1z",
    fill: "#838387"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11v-1h1v1z",
    fill: "#8d8d92"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M37 11v-1h1v1z",
    fill: "#949398"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v-1h1v1z",
    fill: "#99999c"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M39 10h1v1h-1z",
    fill: "#969698"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10v1h-1v-1z",
    fill: "#949496"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M41 10h1v1h-1z",
    fill: "#919294"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#8e8e91"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#8c8c8f"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#8c8d8f"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#8d8e90"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#8c8b90"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#8c8c91"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1z",
    fill: "#88888e"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#89888f"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#8a8a8e"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#8a8a8d"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1z",
    fill: "#898a8c"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#8a8a8c"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#8b8c8d"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#8e8d92"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#8d8d8f"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1z",
    fill: "#8f8f91"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1z",
    fill: "#908f90"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11h-1v-1h1z",
    fill: "#908f93"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M63 10h1v1h-1z",
    fill: "#8e8e92"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1z",
    fill: "#8c8c8e"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-1z",
    fill: "#87878a"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#828186"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1z",
    fill: "#7a797e"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1z",
    fill: "#737377"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#67676b"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M73 10v1h-1v-1z",
    fill: "#48484b"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M74 10v1h-1v-1z",
    fill: "#414043"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11v-1h1v1z",
    fill: "#4f5051"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10v1h-1v-1z",
    fill: "#282729"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11h-1v-1h1z",
    fill: "#1b181b"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11h-1v-1h1z",
    fill: "#959596",
    fillOpacity: 0.604
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12h-1v-1h1z",
    fill: "#8d8d8d",
    fillOpacity: 0.361
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11h1v1h-1z",
    fill: "#4b4b4b"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11h1v1h-1z",
    fill: "#2a2b2c"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12v-1h1v1z",
    fill: "#2d2c2f"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M26 11h1v1h-1z",
    fill: "#29282e"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M38 11v1h-1v-1z",
    fill: "#363639"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M39 12h-1v-1h1z",
    fill: "#39393a"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h-1v-1h1z",
    fill: "#3e3e3d"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#454544"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1z",
    fill: "#4c4c4e"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1z",
    fill: "#505051"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#5a5a5b"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#4a494d"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#3c3c3d"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11v1h-1v-1z",
    fill: "#3a393d"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#313035"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1z",
    fill: "#2b2b2f"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#222126"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M73 12h-1v-1h1z",
    fill: "#323233"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11h1v1h-1z",
    fill: "#353437"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M79 12v-1h1v1z",
    fill: "#1b191c"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M81 11v1h-1v-1z",
    fill: "#211d21"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M81 12v-1h1v1z",
    fill: "#232124"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M86 11v1h-1v-1z",
    fill: "#949497",
    fillOpacity: 0.675
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13v-1h1v1z",
    fill: "#a5a5a5",
    fillOpacity: 0.067
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13v-1h1v1z",
    fill: "#8a8a8a",
    fillOpacity: 0.569
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12v1h-1v-1z",
    fill: "#2c2d2d"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12v1h-1v-1z",
    fill: "#28272a"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#090907"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#0b0b0a"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h1v1h-1z",
    fill: "#181817"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#1a1a1b"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1z",
    fill: "#2f2f32"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#39393e"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M80 13v-1h1v1z",
    fill: "#161517"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M86 13h-1v-1h1z",
    fill: "#929294",
    fillOpacity: 0.745
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H8v-1h1z",
    fill: "#5c5c5e",
    fillOpacity: 0.467
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14v-1h1v1z",
    fill: "#49494c",
    fillOpacity: 0.827
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14h-1v-1h1z",
    fill: "#7a7a7a",
    fillOpacity: 0.988
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13v1h-1v-1z",
    fill: "#404040"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M13 14h-1v-1h1z",
    fill: "#2d2e2e"
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14v-1h1v1z",
    fill: "#313235"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13h1v1h-1z",
    fill: "#2b2e2f"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13h1v1h-1z",
    fill: "#282b2c"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13h1v1h-1z",
    fill: "#232324"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M37 13h1v1h-1z",
    fill: "#0c0e0d"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13h1v1h-1z",
    fill: "#131312"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#1c1c1a"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#4a4b4e"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#45484b"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#434549"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#2c2d30"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#222426"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#1f1e21"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M75 13v1h-1v-1z",
    fill: "#16181a"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14v-1h1v1z",
    fill: "#131718"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M85 13h1v1h-1z",
    fill: "#98989a",
    fillOpacity: 0.945
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14v-1h1v1z",
    fill: "#656568",
    fillOpacity: 0.592
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h1v1h-1z",
    fill: "#616161",
    fillOpacity: 0.267
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14h-1v-1h1z",
    fill: "#e2e2e2",
    fillOpacity: 0.035
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14v1H6v-1z",
    fill: "#747777",
    fillOpacity: 0.318
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v1H7v-1z",
    fill: "#676768",
    fillOpacity: 0.831
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15v-1h1v1z",
    fill: "#5a5a5d"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14v1h-1v-1z",
    fill: "#5c5c5d"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15v-1h1v1z",
    fill: "#414141"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14v1h-1v-1z",
    fill: "#252726"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15h-1v-1h1z",
    fill: "#2e3031"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14v1h-1v-1z",
    fill: "#323436"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M19 14h1v1h-1z",
    fill: "#2a2f30"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M21 15h-1v-1h1z",
    fill: "#393b3d"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M23 15v-1h1v1z",
    fill: "#292d2e"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15v-1h1v1z",
    fill: "#27292a"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M27 15h-1v-1h1z",
    fill: "#262627"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#121313"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#151518"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#282728"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#282829"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#2b2f33"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1z",
    fill: "#1a1c1c"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#101515"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M75 14h1v1h-1z",
    fill: "#0f1515"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M86 15h-1v-1h1z",
    fill: "#919193"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M86 14h1v1h-1z",
    fill: "#414144"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14v1h-1v-1z",
    fill: "#464547",
    fillOpacity: 0.98
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M88 14h1v1h-1z",
    fill: "#606060",
    fillOpacity: 0.757
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v1h-1v-1z",
    fill: "#7a7a7a",
    fillOpacity: 0.302
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16v-1h1v1z",
    fill: "#737173",
    fillOpacity: 0.424
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15h1v1H6z",
    fill: "#7b7a7c",
    fillOpacity: 0.965
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H7v-1h1z",
    fill: "#7a7a7c"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15h1v1H8z",
    fill: "#636266"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16v-1h1v1z",
    fill: "#403f41"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16v-1h1v1z",
    fill: "#333334"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16h-1v-1h1z",
    fill: "#262728"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v-1h1v1z",
    fill: "#2d3031"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h-1v-1h1z",
    fill: "#272829"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16v-1h1v1z",
    fill: "#252526"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#0a0b0e"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#343236"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#39383c"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#404144"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#44484b"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#45494c"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#47484d"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#3d3e41"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#35353b"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#1a1b1c"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#141618"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#131516"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1z",
    fill: "#111416"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#57585a"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#454545"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1z",
    fill: "#5f5f5e"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M90 16h-1v-1h1z",
    fill: "#6f6f6e",
    fillOpacity: 0.973
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h1v1h-1z",
    fill: "gray",
    fillOpacity: 0.529
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M91 16v-1h1v1z",
    fill: "#d4d4d4",
    fillOpacity: 0.024
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M4 17v-1h1v1z",
    fill: "#797973",
    fillOpacity: 0.165
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16v1H5v-1z",
    fill: "#626061",
    fillOpacity: 0.929
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16h1v1H6z",
    fill: "#807e81"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v1H8v-1z",
    fill: "#77767a"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16v1h-1v-1z",
    fill: "#2f2f30"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M23 17v-1h1v1z",
    fill: "#2c2c2d"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M26 16h1v1h-1z",
    fill: "#252525"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17v-1h1v1z",
    fill: "#0b0c0c"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#37353a"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#444449"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#474a4d"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#484c4f"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#494a50"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#494a4f"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#3b3c41"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#333339"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#292a2f"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#424345"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#191a1d"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#3b3b3c"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#5b5b5b"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#4d4d4d"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#888"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#767676"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1z",
    fill: "gray",
    fillOpacity: 0.396
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18v-1h1v1z",
    fill: "#686866",
    fillOpacity: 0.373
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17h1v1H5z",
    fill: "#515051"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17h1v1H6z",
    fill: "#4e4f51"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17v1H7v-1z",
    fill: "#727274"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17v1H8v-1z",
    fill: "#8a8b8e"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18h-1v-1h1z",
    fill: "#2f3031"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17v1h-1v-1z",
    fill: "#2f2f2f"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M22 17h1v1h-1z",
    fill: "#2b2b2b"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h-1v-1h1z",
    fill: "#262626"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M35 17h1v1h-1z",
    fill: "#0a0b0b"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#494c4f"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#4a4c50"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#111215"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1z",
    fill: "#7c7c7d"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#7b7b7c"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1z",
    fill: "#646465"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-1v-1h1z",
    fill: "#717173",
    fillOpacity: 0.729
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18h1v1H4z",
    fill: "#70706d",
    fillOpacity: 0.357
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19v-1h1v1z",
    fill: "#727377"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18h1v1h-1z",
    fill: "#0d0f11"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19h-1v-1h1z",
    fill: "#0d1112"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19h-1v-1h1z",
    fill: "#292928"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M26 18h1v1h-1z",
    fill: "#1d1d1d"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#35353a"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#0a0c0c"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1z",
    fill: "#0c0d0e"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#636465"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M88 18h1v1h-1z",
    fill: "#666668"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1z",
    fill: "#6f6f71",
    fillOpacity: 0.8
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20v-1h1v1z",
    fill: "#8f8f8f",
    fillOpacity: 0.188
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M5 19h1v1H5z",
    fill: "#545454",
    fillOpacity: 0.957
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H9v-1h1z",
    fill: "#25282c"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20v-1h1v1z",
    fill: "#2c3031"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19v1h-1v-1z",
    fill: "#252729"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M21 20h-1v-1h1z",
    fill: "#252626"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19v1h-1v-1z",
    fill: "#262625"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19h1v1h-1z",
    fill: "#292927"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20h-1v-1h1z",
    fill: "#2a2a29"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20v-1h1v1z",
    fill: "#282826"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#07090b"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19h1v1h-1z",
    fill: "#090a0b"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#3a3b3f"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#46464a"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#060709"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#050707"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#050705"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1z",
    fill: "#212422"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20h-1v-1h1z",
    fill: "#474a48"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19h1v1h-1z",
    fill: "#818182",
    fillOpacity: 0.773
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20v1H4v-1z",
    fill: "#9e9ea1",
    fillOpacity: 0.31
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21H5v-1h1z",
    fill: "#78787a",
    fillOpacity: 0.973
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20v1H6v-1z",
    fill: "#4c4d50"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20v1H7v-1z",
    fill: "#313134"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20h1v1H8z",
    fill: "#26262a"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20h1v1h-1z",
    fill: "#202324"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21v-1h1v1z",
    fill: "#1e2022"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20h1v1h-1z",
    fill: "#151513"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21v-1h1v1z",
    fill: "#191917"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M38 20h1v1h-1z",
    fill: "#060708"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v1h-1v-1z",
    fill: "#070708"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1z",
    fill: "#11110f"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#29282a"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#404044"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#3d3f40"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#383a3a"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#242627"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#0a0b0c"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#2d2e2f"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#424344"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#404142"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1z",
    fill: "#343536"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1z",
    fill: "#151418"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-1v-1h1z",
    fill: "#28282b"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#6a696d"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h-1v-1h1z",
    fill: "#9c9b9e",
    fillOpacity: 0.871
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21v-1h1v1z",
    fill: "#c8c8d0",
    fillOpacity: 0.129
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21v1H3v-1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v-1h1v1z",
    fill: "#6f6f70",
    fillOpacity: 0.773
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22H6v-1h1z",
    fill: "#646367"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22H7v-1h1z",
    fill: "#4f4d53"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M9 22H8v-1h1z",
    fill: "#3d3c41"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21h1v1h-1z",
    fill: "#121210"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M25 21h1v1h-1z",
    fill: "#080807"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1z",
    fill: "#040403"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#10100e"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#111110"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#232224"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#2b2d2d"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#323235"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#3d3f42"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#606163"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#1a1a1d"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#353539"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#818086"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#908e93"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#878789",
    fillOpacity: 0.525
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M4 22v1H3v-1z",
    fill: "#88888b",
    fillOpacity: 0.337
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23v-1h1v1z",
    fill: "#5f5f61",
    fillOpacity: 0.992
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22v1H6v-1z",
    fill: "#434246"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23v-1h1v1z",
    fill: "#48474c"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22h1v1H8z",
    fill: "#47474b"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23v-1h1v1z",
    fill: "#3c3d40"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23v-1h1v1z",
    fill: "#0e0e0d"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#010101"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#020101"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#050405"
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#1c1c20"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#1b1b20"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#16161b"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#39393c"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#212324"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#343538"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#616066"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1z",
    fill: "#737374",
    fillOpacity: 0.796
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#e7e7e7",
    fillOpacity: 0.043
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24v-1h1v1z",
    fill: "#8b8b8b",
    fillOpacity: 0.086
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M3 23h1v1H3z",
    fill: "#7a7a7b",
    fillOpacity: 0.824
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23v1H5v-1z",
    fill: "#3b3b3d"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24v-1h1v1z",
    fill: "#2f2e32"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23h1v1H7z",
    fill: "#29282d"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M9 24v-1h1v1z",
    fill: "#353739"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M15 24h-1v-1h1z",
    fill: "#28292d"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24h-1v-1h1z",
    fill: "#27282b"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M31 23v1h-1v-1z",
    fill: "#101112"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#101110"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#0d0e0e"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#0f1112"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#111115"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#15151a"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#131419"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#151619"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#151719"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#4b4b4f"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#414145"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#3a3a3f"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1z",
    fill: "#707070",
    fillOpacity: 0.929
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#aaaaa2",
    fillOpacity: 0.141
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M3 24v1H2v-1z",
    fill: "#6d6d6d",
    fillOpacity: 0.137
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25v-1h1v1z",
    fill: "#626265",
    fillOpacity: 0.929
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24h1v1H6z",
    fill: "#242327"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24v1H7v-1z",
    fill: "#212226"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25v-1h1v1z",
    fill: "#202326"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M9 25v-1h1v1z",
    fill: "#1e2223"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25v-1h1v1z",
    fill: "#2c2e31"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M11 25v-1h1v1z",
    fill: "#36373b"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25h-1v-1h1z",
    fill: "#202024"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#0f1110"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#131514"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#171817"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#232326"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#2b2a2e"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#393c3e"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#3d4142"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#434344"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#49484d"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#4c4d52"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#56575a"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#5c5c5e"
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#525254"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#37383b"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#26272c"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#1d1f21"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#646464",
    fillOpacity: 0.867
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#aaa",
    fillOpacity: 0.094
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M3 25v1H2v-1z",
    fill: "#555",
    fillOpacity: 0.012
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H3v-1h1z",
    fill: "#4a4a4c",
    fillOpacity: 0.459
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M4 25h1v1H4z",
    fill: "#414042",
    fillOpacity: 0.961
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26H6v-1h1z",
    fill: "#222225"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M8 25h1v1H8z",
    fill: "#292c2e"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25v1H9v-1z",
    fill: "#2c3131"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26v-1h1v1z",
    fill: "#292b2d"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M17 26v-1h1v1z",
    fill: "#2a2b2e"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M19 25v1h-1v-1z",
    fill: "#242528"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26v-1h1v1z",
    fill: "#1f2020"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25v1h-1v-1z",
    fill: "#1e1f20"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M31 26v-1h1v1z",
    fill: "#1c1e1e"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M33 26v-1h1v1z",
    fill: "#171919"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#161718"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#141516"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#121314"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#121414"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#131415"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#29292c"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#3b3e40"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#3d4041"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#454549"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#3b3c3f"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#333536"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#353738"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#39393d"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#3b3b40"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#28282d"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#18181d"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#3c3d3e",
    fillOpacity: 0.925
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#717171",
    fillOpacity: 0.325
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M5 27H4v-1h1z",
    fill: "#3b3b3b",
    fillOpacity: 0.286
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26v1H5v-1z",
    fill: "#323133",
    fillOpacity: 0.714
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M6 26h1v1H6z",
    fill: "#262728",
    fillOpacity: 0.976
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M9 26v1H8v-1z",
    fill: "#303234"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27v-1h1v1z",
    fill: "#35393b"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27h-1v-1h1z",
    fill: "#2d2e33"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26v1h-1v-1z",
    fill: "#2e2f34"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M18 26v1h-1v-1z",
    fill: "#313237"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26h1v1h-1z",
    fill: "#202220"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M26 26v1h-1v-1z",
    fill: "#202222"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#252326"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#232527"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#222226"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#24252a"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#202325"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#202224"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#656565"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#6f6f6f"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#505052"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#252428"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#0d0d12"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#0b0a0f"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#0e0e11"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1z",
    fill: "#181719",
    fillOpacity: 0.996
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#2e2e2e",
    fillOpacity: 0.729
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#5f5f5f",
    fillOpacity: 0.231
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M5 28v-1h1v1z",
    fill: "#555",
    fillOpacity: 0.024
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28H6v-1h1z",
    fill: "#333",
    fillOpacity: 0.271
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M7 28v-1h1v1z",
    fill: "#262627",
    fillOpacity: 0.655
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27v1H8v-1z",
    fill: "#282929",
    fillOpacity: 0.949
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M9 27h1v1H9z",
    fill: "#2c2f2f"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M11 28v-1h1v1z",
    fill: "#3f3f44"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M15 27v1h-1v-1z",
    fill: "#45464b"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M17 27v1h-1v-1z",
    fill: "#414245"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M18 27h1v1h-1z",
    fill: "#333437"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28v-1h1v1z",
    fill: "#2b2d2f"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27h1v1h-1z",
    fill: "#242625"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M25 28v-1h1v1z",
    fill: "#212323"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#252528"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#242429"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#23232a"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#24242a"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#7d7e80"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#646467"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#3e3e3f"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#0f0f10"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#0f0e11",
    fillOpacity: 0.988
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1z",
    fill: "#1f1f20",
    fillOpacity: 0.773
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#434340",
    fillOpacity: 0.341
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M9 29H8v-1h1z",
    fill: "#70726d",
    fillOpacity: 0.357
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M10 29H9v-1h1z",
    fill: "#676967",
    fillOpacity: 0.984
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M11 29h-1v-1h1z",
    fill: "#3e3d3f"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h-1v-1h1z",
    fill: "#2f2f33"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28v1h-1v-1z",
    fill: "#3a3b3e"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M14 28h1v1h-1z",
    fill: "#424346"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M16 29h-1v-1h1z",
    fill: "#454647"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M17 28h1v1h-1z",
    fill: "#474948"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M19 28h1v1h-1z",
    fill: "#414343"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29h-1v-1h1z",
    fill: "#3b3d3c"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#3d3c44"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#3f3e46"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#414247"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#0e0d0f"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#0e0e0f"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#5e5e5e"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#939393",
    fillOpacity: 0.773
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30v-1h1v1z",
    fill: "#ebebeb",
    fillOpacity: 0.2
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30v-1h1v1z",
    fill: "#d7d7d5",
    fillOpacity: 0.965
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30v-1h1v1z",
    fill: "#cdcac9"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30h-1v-1h1z",
    fill: "#a7a5a4"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29v1h-1v-1z",
    fill: "#797879"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M13 29h1v1h-1z",
    fill: "#505152"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M19 29h1v1h-1z",
    fill: "#383a39"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30v-1h1v1z",
    fill: "#333534"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M24 30v-1h1v1z",
    fill: "#2f3130"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M26 30h-1v-1h1z",
    fill: "#2e2f2f"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#111516"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#16191a"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#1b1c1d"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#2e2d30"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#323136"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#37363b"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#3a3c3f"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#3d3f43"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#404245"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#4e4f52"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#4a4b4d"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#0f0e0e"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#171516"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#262528"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#383838"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#666"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#9c9c9b"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#c7c7c5"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#e0e0de"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#e3e3e0",
    fillOpacity: 0.616
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M9 31H8v-1h1z",
    fill: "#d2d2d2",
    fillOpacity: 0.157
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M9 30h1v1H9z",
    fill: "#cfcfcc",
    fillOpacity: 0.941
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M11 31h-1v-1h1z",
    fill: "#d4d2cd"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M12 30v1h-1v-1z",
    fill: "#d5d2ce"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M12 31v-1h1v1z",
    fill: "#d3d0cd"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M14 30v1h-1v-1z",
    fill: "#d0cfcc"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M14 31v-1h1v1z",
    fill: "#c3c4c0"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M15 31v-1h1v1z",
    fill: "#a7a9a3"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M16 30h1v1h-1z",
    fill: "#80817c"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M17 31v-1h1v1z",
    fill: "#60625d"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30v1h-1v-1z",
    fill: "#484946"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31v-1h1v1z",
    fill: "#3e403d"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M21 31h-1v-1h1z",
    fill: "#313231"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M22 31h-1v-1h1z",
    fill: "#2a2b2a"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M22 30h1v1h-1z",
    fill: "#232424"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31v-1h1v1z",
    fill: "#222523"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31v-1h1v1z",
    fill: "#202323"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M27 31h-1v-1h1z",
    fill: "#1f2122"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30h1v1h-1z",
    fill: "#1c1e1f"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30v1h-1v-1z",
    fill: "#131316"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#222526"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#272a2c"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#38383b"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#434346"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#4f4f52"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#58585b"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#57585b"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#57575a"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#5f5f62"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#5a5a5f"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#5a5b5e"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#57585c"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#5a5b60"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#5b5c5f"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#59595c"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#535358"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#48494b"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#353637"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#302f2f"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#4a4848"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#666565"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#878584"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#a9a6a6"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#c4c3c3"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#d5d5d4"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#dfdfdd"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#ddddda"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#d8d8d6"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#e2e2df"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#e3e5e1",
    fillOpacity: 0.471
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M8 32v-1h1v1z",
    fill: "#d9d9d9",
    fillOpacity: 0.106
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M10 31v1H9v-1z",
    fill: "#cfd0cb",
    fillOpacity: 0.89
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M10 31h1v1h-1z",
    fill: "#d3d4cb"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32v-1h1v1z",
    fill: "#d1cec7"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M12 31h1v1h-1z",
    fill: "#d1cac4"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M13 31h1v1h-1z",
    fill: "#d1ccc6"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M15 32v-1h1v1z",
    fill: "#cecec5"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32h-1v-1h1z",
    fill: "#cdcdc5"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32v-1h1v1z",
    fill: "#c5c5be"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M19 31h1v1h-1z",
    fill: "#bfbeba"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32v-1h1v1z",
    fill: "#b2b1ad"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M21 32v-1h1v1z",
    fill: "#a2a19e"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M22 32v-1h1v1z",
    fill: "#8d8e8a"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32v-1h1v1z",
    fill: "#787a76"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M24 31h1v1h-1z",
    fill: "#5b5f5b"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M25 31h1v1h-1z",
    fill: "#4d504c"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31h1v1h-1z",
    fill: "#3e403e"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M28 31v1h-1v-1z",
    fill: "#323330"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M30 31v1h-1v-1z",
    fill: "#1b1a1a"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32h-1v-1h1z",
    fill: "#121111"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31v1h-1v-1z",
    fill: "#0b090a"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31h1v1h-1z",
    fill: "#060506"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#030403"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#040405"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#131413"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#3d3c42"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#45444a"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#48484d"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#49494e"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#4a494f"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#4b484f"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#504e54"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#504f54"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#4f5053"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#505054"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#4e4e51"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#4a4b4c"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#4d4e4d"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#535452"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#616064"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#676766"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#6c6b69"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#7c7b7a"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#8e8d8b"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#a2a1a0"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#b5b4b2"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#d9d5d3"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#dfdbd8"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#e2dedb"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#e0dcd9"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#dcdbd7"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#e8e7e4"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#e8e8e5",
    fillOpacity: 0.353
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M9 32h1v1H9z",
    fill: "#cfd1cc",
    fillOpacity: 0.808
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M11 33h-1v-1h1z",
    fill: "#d4d5ce"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33h-1v-1h1z",
    fill: "#d2cfc9"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33h-1v-1h1z",
    fill: "#d2ccc6"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M17 33v-1h1v1z",
    fill: "#cdc9c0"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33h-1v-1h1z",
    fill: "#ccc9bf"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M19 33v-1h1v1z",
    fill: "#c9c6bc"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M21 33h-1v-1h1z",
    fill: "#cac6bd"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33h-1v-1h1z",
    fill: "#cac7be"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M23 32h1v1h-1z",
    fill: "#cbcac1"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33v-1h1v1z",
    fill: "#c9c9c0"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33v-1h1v1z",
    fill: "#c4c3ba"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M27 32h1v1h-1z",
    fill: "#bdbbb3"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M28 32h1v1h-1z",
    fill: "#b3b1aa"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M30 33h-1v-1h1z",
    fill: "#aeaba5"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M31 32v1h-1v-1z",
    fill: "#a09e98"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32v1h-1v-1z",
    fill: "#8f8f89"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32v1h-1v-1z",
    fill: "#878681"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M33 32h1v1h-1z",
    fill: "#7e7d78"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#72726d"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#64645f"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#5b5b55"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33v-1h1v1z",
    fill: "#53544e"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-1z",
    fill: "#4d4d48"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#454541"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#42423d"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#3c3c38"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#363631"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#30302b"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#292a25"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#292926"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#2a2926"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#2b2a28"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#302e2e"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#343234"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#4b4a4c"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#575657"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#5c5b5d"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#646265"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#6b6a6c"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#706f6f"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#777776"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#828181"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#8b8a8a"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#939391"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#9c9b99"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#a0a09c"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#a8a9a4"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#babab5"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#c4c4c1"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#cacac8"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#d0d0ce"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#d4d4cf"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#dbdbd4"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#deddd7"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#deddda"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#dedddb"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#dedcd7"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#e2e1dd"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#e7e6e3",
    fillOpacity: 0.973
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#e9e9e9",
    fillOpacity: 0.227
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34H9v-1h1z",
    fill: "#d0d1cc",
    fillOpacity: 0.729
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M10 34v-1h1v1z",
    fill: "#d5d6d0"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M12 33v1h-1v-1z",
    fill: "#d1cfca"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34v-1h1v1z",
    fill: "#d6d0ca"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M15 34h-1v-1h1z",
    fill: "#d5cec7"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M16 34h-1v-1h1z",
    fill: "#d3cec5"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33h1v1h-1z",
    fill: "#cfcabd"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M22 33v1h-1v-1z",
    fill: "#cdc8bc"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M24 33h1v1h-1z",
    fill: "#c7c4b8"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#c6c3b6"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#c7c3b6"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#c8c4b8"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#c6c3b7"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#c7c5b9"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#c6c4b9"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#c7c5ba"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#c9c7bc"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#c9c8bd"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#c8c8bd"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#c7c8bc"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#c7c7bb"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#c7c7bd"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#c4c4ba"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#c0c0b6"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#c1c1b7"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#c2c2b8"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#c4c2b9"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#c3c0b8"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#c3c0ba"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#c6c2bb"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#c8c5bc"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#cbc9c0"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#cdcbc2"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#d3d1c7"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#d2d2c9"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#d5d4cb"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#d8d7ce"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#d9d8ce"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#dbd9d1"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#dbd8d2"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#dbd8d3"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#dddad3"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#dcdad2"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#dcdbd4"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#dddcd5"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#dbdbd3"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#deddd5"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#dddcd2"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#dcdcd3"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#dddcd6"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#e0dfdb"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#e1e0dc"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#e2e0da"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#e2dfda"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#e2deda"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#e2dfdc"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#e3e2de"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#edece8"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#e8e7e5",
    fillOpacity: 0.925
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#e9e9e9",
    fillOpacity: 0.141
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M9 34h1v1H9z",
    fill: "#d2d3cd",
    fillOpacity: 0.627
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35v-1h1v1z",
    fill: "#d7d7d2"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35h-1v-1h1z",
    fill: "#d1d0cc"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34v1h-1v-1z",
    fill: "#d2d1cb"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M13 34h1v1h-1z",
    fill: "#d3d1c9"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35v-1h1v1z",
    fill: "#d4d0c6"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#cecabe"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#cdc9bc"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#cbc8ba"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#cbc7bb"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#cbc8bc"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#cbc9bc"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#cac8ba"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#c9c7ba"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#c8c9bb"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#cdcbbe"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#d3d0c4"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#d5cfc6"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#d7d3c5"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#dad8cb"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#dcd9cc"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#ddd9d1"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#ded9d2"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#e0ddd4"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#e1ded4"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#e5e2de"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1z",
    fill: "#efeeea"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#e8e8e5",
    fillOpacity: 0.859
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#e8e8e8",
    fillOpacity: 0.09
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M10 36H9v-1h1z",
    fill: "#d1d1cc",
    fillOpacity: 0.529
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M11 36h-1v-1h1z",
    fill: "#d8d7d1"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M12 35v1h-1v-1z",
    fill: "#d3d2cc"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M13 36h-1v-1h1z",
    fill: "#d2d2cb"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M14 36h-1v-1h1z",
    fill: "#d2d2c8"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M15 35h1v1h-1z",
    fill: "#d4d2c7"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#d2d0c5"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#d2cec3"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#d0cdc1"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#d0cbc0"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#d1cac0"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#d0cabf"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#cfcec1"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#d0cfc2"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#dcd6cb"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#dfd9cf"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#dedbd0"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#e4dfd7"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#e4ded7"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#e3dfd8"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#e7e2df"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#ebe6e6"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#ebe8e6"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#ebeae7",
    fillOpacity: 0.776
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37H9v-1h1z",
    fill: "#d7d5d1",
    fillOpacity: 0.459
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M11 37h-1v-1h1z",
    fill: "#dbd8d0"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M16 36v1h-1v-1z",
    fill: "#d5d3c8"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#d4cfc4"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#d5cdc4"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#d7d0c5"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#d6d1c5"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#dcd8d0"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#dfdace"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#e1dacf"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#dfdcd5"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#e0ddd6"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#e2dfd9"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#e4e1db"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#f4f0ed"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#ebe8e5",
    fillOpacity: 0.714
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37v1H9v-1z",
    fill: "#ddddd6",
    fillOpacity: 0.424
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M10 37h1v1h-1z",
    fill: "#dddad2"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M16 37v1h-1v-1z",
    fill: "#d7d3c9"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#d2d2c6"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#d6d3c7"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#d7cec6"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#e0ddd2"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#e3dcd5"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#e4ded9"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#e3e0d9"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#e4e1dd"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#ede9e8"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#f3efee"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#ebe8e7",
    fillOpacity: 0.627
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38h1v1H9z",
    fill: "#bdb9b4",
    fillOpacity: 0.459
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39h-1v-1h1z",
    fill: "#dcd9cf"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#d6d2c6"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#ddd9ce"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#ede9e9"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#f3efef"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39v-1h1v1z",
    fill: "#ebe9e7",
    fillOpacity: 0.518
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M10 40H9v-1h1z",
    fill: "#686360",
    fillOpacity: 0.573
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M11 39v1h-1v-1z",
    fill: "#d5d2c8"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#d8d0c7"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#dedbce"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#e9e5e3"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#eee9e8"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#eee9e7"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#f2efeb"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#c9c7c3",
    fillOpacity: 0.467
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M9 40h1v1H9z",
    fill: "#4a413b",
    fillOpacity: 0.522
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M11 40v1h-1v-1z",
    fill: "#aea89d"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M12 40v1h-1v-1z",
    fill: "#dbdacd"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M12 41v-1h1v1z",
    fill: "#d4d4c8"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M15 40h1v1h-1z",
    fill: "#dad2c8"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M17 40v1h-1v-1z",
    fill: "#dad1c8"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#d4d5c8"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#dddccf"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#dedccf"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#dfded1"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#e0ded2"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#e5e0dd"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#e6e4de"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#e8e4e0"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#e9e5e5"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#edeae9"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#ecebe9"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#ebe6dd"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#938c86",
    fillOpacity: 0.447
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M9 42v-1h1v1z",
    fill: "#8e776a",
    fillOpacity: 0.443
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M11 41v1h-1v-1z",
    fill: "#7b6659"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M12 42h-1v-1h1z",
    fill: "#aaa092"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M13 41v1h-1v-1z",
    fill: "#d1d1c2"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#d7d5c6"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#dddbd0"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#e6e3df"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#e8e8e0"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#efebe6"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#eae8e5"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#ebebeb"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#ebedef"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#f4efe4"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#c9bba9",
    fillOpacity: 0.996
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#8a7b6c",
    fillOpacity: 0.333
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43H9v-1h1z",
    fill: "#957d6e",
    fillOpacity: 0.408
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M10 43v-1h1v1z",
    fill: "#957163"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42h1v1h-1z",
    fill: "#7f5e51"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M13 42v1h-1v-1z",
    fill: "#8d776a"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M14 43h-1v-1h1z",
    fill: "#b8ada1"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M15 43v-1h1v1z",
    fill: "#d9d7c7"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42v1h-1v-1z",
    fill: "#d9d5c7"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M17 42h1v1h-1z",
    fill: "#dad4c8"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#dbd3c7"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#d9d4ca"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#d9d5cb"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#e6e1de"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#e9e8e2"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#eae8e3"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#eae9e7"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#eeecea"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#f5eae2"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#ceb7a1"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#b29881",
    fillOpacity: 0.965
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#b4a08c",
    fillOpacity: 0.2
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44v-1h1v1z",
    fill: "#92786c",
    fillOpacity: 0.341
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M11 43v1h-1v-1z",
    fill: "#97705a"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M12 44h-1v-1h1z",
    fill: "#9f735d"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44h-1v-1h1z",
    fill: "#8c6552"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M13 43h1v1h-1z",
    fill: "#7b5e4b"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44h-1v-1h1z",
    fill: "#8b7a65"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M16 43v1h-1v-1z",
    fill: "#ada18f"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v-1h1v1z",
    fill: "#cabfb1"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M18 43v1h-1v-1z",
    fill: "#d9cfc4"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h-1v-1h1z",
    fill: "#d8d7cb"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#d5d6c8"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#d6d6c8"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#e3ded5"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#e4ddd5"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#e6e1dc"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#e6e2e2"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#ebeae7"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#ebebe7"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#f0ece4"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#f3ede5"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#efe8de"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#e1d3c8"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#c3a48e"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#b58d6b"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#b59376",
    fillOpacity: 0.914
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#c3a596",
    fillOpacity: 0.133
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M10 44v1H9v-1z",
    fill: "#907566",
    fillOpacity: 0.263
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M11 44v1h-1v-1z",
    fill: "#916d53",
    fillOpacity: 0.992
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M13 44v1h-1v-1z",
    fill: "#94694f"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M14 45h-1v-1h1z",
    fill: "#916a4f"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M15 44v1h-1v-1z",
    fill: "#8a694c"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M16 44v1h-1v-1z",
    fill: "#7e6248"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-1v-1h1z",
    fill: "#826653"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44v1h-1v-1z",
    fill: "#9f8677"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M18 44h1v1h-1z",
    fill: "#b6a698"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v-1h1v1z",
    fill: "#c6c1b1"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#d3cfbe"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#dbd4c4"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#d8d6c7"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#dad7c8"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#dad7ca"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#e2dcd4"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#e3dcd2"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#e3ded2"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#e5ded8"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#e7e1da"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#e7e2de"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#e7e3e2"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#efece4"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#f5ede3"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#f6eadc"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#ebdac7"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#d9c5af"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#c2a98e"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#ad8d70"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#b68c68"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#bf9268"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#b49274",
    fillOpacity: 0.824
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#dab6b6",
    fillOpacity: 0.055
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M9 45h1v1H9z",
    fill: "#8c6e64",
    fillOpacity: 0.2
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46v-1h1v1z",
    fill: "#936c57",
    fillOpacity: 0.969
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M12 45v1h-1v-1z",
    fill: "#966a52"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M13 46h-1v-1h1z",
    fill: "#966e52"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M14 46h-1v-1h1z",
    fill: "#936d4e"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M15 45v1h-1v-1z",
    fill: "#8e6947"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M16 46h-1v-1h1z",
    fill: "#916b48"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M16 45h1v1h-1z",
    fill: "#8d6545"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M17 45h1v1h-1z",
    fill: "#885f45"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M19 45v1h-1v-1z",
    fill: "#85614a"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M19 46v-1h1v1z",
    fill: "#866a53"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#8c735e"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#a28b79"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#bba896"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#c5b6a5"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#d7cfbd"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#dbd6c5"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#dcd7ca"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#dcd7cc"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#e0ddd1"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#e3dcd4"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#e2dcd2"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#e2dfd2"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#e3e0d6"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#e8dfdc"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#e9e2dc"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#e8e3dd"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#e8e3de"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#ede8e4"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#eeece8"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1z",
    fill: "#efebe7"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1z",
    fill: "#f1ebe7"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#f2ebe7"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#f2e8e1"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#e8ddd0"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#e3d1bf"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#d4bda5"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#c1a487"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#ae8a68"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#ae855f"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#b2875b"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#b88b5f"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#c09468"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#b59879",
    fillOpacity: 0.71
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47H9v-1h1z",
    fill: "#857266",
    fillOpacity: 0.157
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M11 46v1h-1v-1z",
    fill: "#916d56",
    fillOpacity: 0.937
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47h-1v-1h1z",
    fill: "#9b6f56"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M13 47v-1h1v1z",
    fill: "#946d4c"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#8a5e3f"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#8f6448"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#845c43"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#845f4a"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#916f5c"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#977a66"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#a58c76"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#b7a18d"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#bfae9d"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#cabcad"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#dacfbe"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#e1d7c7"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#e2dacb"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#e0d9cb"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#e2dbce"
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#e5ddd1"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#e5ded3"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#e5ded4"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#e4ded4"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#e5ded5"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#e4ded6"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#e3ded3"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#e7e4dd"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#e8e5de"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#e7e5de"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#e8e7e2"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#ecebe4"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#edebe4"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#f0ebe6"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#f1ece1"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#f0ede2"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#efebdf"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#eee7d8"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#ebe0cf"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#e8dac7"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M71 47v-1h1v1z",
    fill: "#e1cdbc"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#c9b2a2"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#c6ab98"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#bfa189"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#ad8e6f"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#b18861"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#b6865d"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#b07e56"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#b9865e"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#bc8b62"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#ba895c"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#ba8b60"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#be8e63"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#c4976d"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#b7977b",
    fillOpacity: 0.561
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M10 48H9v-1h1z",
    fill: "#917664",
    fillOpacity: 0.11
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M10 47h1v1h-1z",
    fill: "#906e55",
    fillOpacity: 0.886
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M12 47v1h-1v-1z",
    fill: "#9b7155"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M12 48v-1h1v1z",
    fill: "#966b4f"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M14 47v1h-1v-1z",
    fill: "#966f4e"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48v-1h1v1z",
    fill: "#986c4b"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#946541"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#85593b"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#7f5637"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#7e5838"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#7c5839"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#846144"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#88684b"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#8b6c50"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#927659"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#a18568"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#a78c72"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#b59b81"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#b9a088"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#bca590"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#ccb5a0"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#d4bda9"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#dcc4b1"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#dbc5b3"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#e0cebe"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#e2d1c0"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#e5d6c6"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#e5d7c8"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#e8dccf"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#e6dfd3"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#e4dcd0"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#e8e0d4"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#ebe4d7"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#ebe3d8"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#ece4d9"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#ede5db"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#eae2d9"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#ebe0d7"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#ede1d7"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#eaddd1"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#e7dacb"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#e8dac9"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#e3d8c4"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#dbceba"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#d9c6b1"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#dbc2ac"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#cfb39b"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#c1a48b"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#c0a287"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#b59477"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#b18c6d"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48v-1h1v1z",
    fill: "#ab8462"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47v1h-1v-1z",
    fill: "#ac805e"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M72 47h1v1h-1z",
    fill: "#b0825f"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#b1825c"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#b7875d"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#b88759"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#bd8c5d"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#ba885b"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#ba875b"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#bc895f"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M81 48h-1v-1h1z",
    fill: "#be8d63"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#bf8e62"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#bc8d64"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#c09167"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#c49972"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#ba9d7f",
    fillOpacity: 0.439
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M10 49H9v-1h1z",
    fill: "#7f7f66",
    fillOpacity: 0.039
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M11 49h-1v-1h1z",
    fill: "#8e6f55",
    fillOpacity: 0.808
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M14 49h-1v-1h1z",
    fill: "#91694a"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M18 48h1v1h-1z",
    fill: "#976a48"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M19 49v-1h1v1z",
    fill: "#926444"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#8e623d"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#90623f"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#835531"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#8a5c38"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#855834"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#815430"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#7d5230"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#7f5633"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#7e5533"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#805837"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#855e3e"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#845b3b"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#895f3f"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#966c4c"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#936a4b"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#946e4f"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#926d50"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#9b765a"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#a07a61"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#a57f68"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#a78069"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#a37c65"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#ac856e"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#b28b73"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#b38b74"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#b28b71"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#b48c73"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#ae866d"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#b28a71"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#b18870"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#b28a74"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#b18670"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#aa7e65"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#aa7c61"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#ab7c5f"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#ae8264"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#a6795a"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#a97959"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#a87552"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#af7b57"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#ae7e59"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#ad7f58"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#aa7a52"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#b27e55"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49v-1h1v1z",
    fill: "#b58156"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49v-1h1v1z",
    fill: "#b47e53"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#bd875b"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#c18c5d"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#be8959"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#c18d5c"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#bc8a58"
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#ba8757"
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#ba8658"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#bc8c60"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#b9895d"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#bb8d63"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#c1946a"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#bc9570",
    fillOpacity: 0.992
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#bca088",
    fillOpacity: 0.286
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50v-1h1v1z",
    fill: "#8c6e52",
    fillOpacity: 0.714
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M13 49v1h-1v-1z",
    fill: "#9a6f54"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M15 50h-1v-1h1z",
    fill: "#986c50"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M17 49v1h-1v-1z",
    fill: "#8f6540"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50h-1v-1h1z",
    fill: "#936646"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M20 50v-1h1v1z",
    fill: "#926746"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#8e6542"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#8b603e"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#885c3b"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#8c5f3c"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#895b38"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#97633e"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#97643c"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#8d5a35"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#986441"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#996740"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#9a6841"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#95633c"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#98673f"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#a06f47"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#a7754e"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#aa7850"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#a3724a"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#af7d55"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#a9774e"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#a6754f"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#a77650"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#ab7953"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#ac7850"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#b27d58"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#ae7c54"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#af7d54"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#aa7b4f"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#b08055"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#ae7d55"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#b7855d"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1z",
    fill: "#b8845b"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M70 49h1v1h-1z",
    fill: "#b58157"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M71 49h1v1h-1z",
    fill: "#bb855e"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#b78357"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#be8d5f"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#bf8c5e"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#c38f63"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#bc8b60"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#ba8b5f"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#b88b61"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#c1966b"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#b99372",
    fillOpacity: 0.949
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#b8a28d",
    fillOpacity: 0.184
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M10 50h1v1h-1z",
    fill: "#8b6f54",
    fillOpacity: 0.58
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50v1h-1v-1z",
    fill: "#997357"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M14 50v1h-1v-1z",
    fill: "#966d51"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M15 51h-1v-1h1z",
    fill: "#996f53"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51h-1v-1h1z",
    fill: "#996e4b"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M17 50v1h-1v-1z",
    fill: "#946a44"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51v-1h1v1z",
    fill: "#926545"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#8f6141"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51h-1v-1h1z",
    fill: "#845938"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#875736"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#8c5d3c"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#95623f"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#97633f"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#9c6743"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#96633d"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#9a6644"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50h1v1h-1z",
    fill: "#9d6a45"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#9a663f"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#9f6a43"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#9d6842"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#aa754f"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#ab7752"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#ad7954"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#aa7650"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#ae7a54"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#b07c54"
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#aa754d"
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#a9744e"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#a9764f"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#b07d55"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#af7b53"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1z",
    fill: "#bb845f"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#be885f"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#c08a5f"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#bd865c"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#c79368"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#c29164"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#be8e62"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#bb8f64"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#c2966c"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#ba9575",
    fillOpacity: 0.878
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#cdb0a6",
    fillOpacity: 0.102
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M11 51v1h-1v-1z",
    fill: "#90755f",
    fillOpacity: 0.451
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M12 52h-1v-1h1z",
    fill: "#99775a"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M13 51v1h-1v-1z",
    fill: "#997052"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M14 52h-1v-1h1z",
    fill: "#966c53"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M14 51h1v1h-1z",
    fill: "#9d7055"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M16 51v1h-1v-1z",
    fill: "#9a6e4c"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M20 51v1h-1v-1z",
    fill: "#946745"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#916442"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#92613f"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#92613b"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v1z",
    fill: "#9e6946"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52h-1v-1h1z",
    fill: "#9d6943"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M47 51v1h-1v-1z",
    fill: "#a66f4a"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#a06a45"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52v-1h1v1z",
    fill: "#9f6843"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#ab7552"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#af7854"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#b37c56"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#b9815d"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#b88259"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h-1v-1h1z",
    fill: "#c28c61"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#c18d62"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#ba8f65"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#c4956d"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#bf9879",
    fillOpacity: 0.792
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#bfdfbf",
    fillOpacity: 0.031
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M10 52h1v1h-1z",
    fill: "#907a67",
    fillOpacity: 0.318
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53h-1v-1h1z",
    fill: "#947357",
    fillOpacity: 0.996
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M12 53v-1h1v1z",
    fill: "#9a7252"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M14 53h-1v-1h1z",
    fill: "#956b52"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M15 53h-1v-1h1z",
    fill: "#976b4e"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M16 52h1v1h-1z",
    fill: "#956b48"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M17 53v-1h1v1z",
    fill: "#986d4a"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#845734"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#895a39"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#92623f"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#8f5f3b"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52h1v1h-1z",
    fill: "#96623e"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#9b6742"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M46 53v-1h1v1z",
    fill: "#9f6944"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53v-1h1v1z",
    fill: "#ab7553"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#c49064"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#c18f63"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#bd9266"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#c7986f"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#c59e7f",
    fillOpacity: 0.675
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h-1v-1h1z",
    fill: "#938470",
    fillOpacity: 0.204
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54v-1h1v1z",
    fill: "#927459",
    fillOpacity: 0.973
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h-1v-1h1z",
    fill: "#9a7251"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#8b5b38"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#956040"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#996444"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#c49266"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#c09064"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#c09364"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#c79970"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#c19f83",
    fillOpacity: 0.533
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M10 55v-1h1v1z",
    fill: "#a59082",
    fillOpacity: 0.145
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M11 54h1v1h-1z",
    fill: "#92785d",
    fillOpacity: 0.922
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54v1h-1v-1z",
    fill: "#9a7250"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M13 54h1v1h-1z",
    fill: "#9a7053"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M14 54h1v1h-1z",
    fill: "#9d7454"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M16 54v1h-1v-1z",
    fill: "#9b704d"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#906541"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#966141"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#8f5a3c"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#956041"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M46 54v1h-1v-1z",
    fill: "#98643e"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#c28f62"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#c59367"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#be9064"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#c29467"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#c19566"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#c59872"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#c2a28a",
    fillOpacity: 0.412
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M11 56h-1v-1h1z",
    fill: "#998c7f",
    fillOpacity: 0.078
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M11 55h1v1h-1z",
    fill: "#8f775a",
    fillOpacity: 0.863
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M13 56h-1v-1h1z",
    fill: "#9b7451"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M14 55v1h-1v-1z",
    fill: "#9a7152"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h-1v-1h1z",
    fill: "#99704f"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#865a35"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#895938"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#8a5937"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#986743"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M41 55h1v1h-1z",
    fill: "#9a6545"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#976243"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M43 55h1v1h-1z",
    fill: "#935e3f"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#915d37"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h-1v-1h1z",
    fill: "#99633f"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1z",
    fill: "#ab754e"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M71 56h-1v-1h1z",
    fill: "#b47f55"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#c69266"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#c39063"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#c99669"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#c79569"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#c09165"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#be9367"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#bc9263"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#bc926d",
    fillOpacity: 0.992
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#bfa18a",
    fillOpacity: 0.267
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M11 56v1h-1v-1z",
    fill: "#8daaaa",
    fillOpacity: 0.035
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57h-1v-1h1z",
    fill: "#907557",
    fillOpacity: 0.812
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M13 56v1h-1v-1z",
    fill: "#9d7552"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56v1h-1v-1z",
    fill: "#986d4c"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M15 56h1v1h-1z",
    fill: "#926844"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57v-1h1v1z",
    fill: "#936a47"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M18 56v1h-1v-1z",
    fill: "#986d4b"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M20 56v1h-1v-1z",
    fill: "#8e6340"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#8f5e3e"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#8e5f3a"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#996944"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fill: "#946240"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57h-1v-1h1z",
    fill: "#915e3c"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1z",
    fill: "#986440"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56h1v1h-1z",
    fill: "#9d6843"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v1h-1z",
    fill: "#ba845c"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#c39062"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#c79364"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#c29166"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#bf9065"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#bc9774",
    fillOpacity: 0.933
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#bdab94",
    fillOpacity: 0.169
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M12 57v1h-1v-1z",
    fill: "#8e7156",
    fillOpacity: 0.773
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57v1h-1v-1z",
    fill: "#9e7553"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M13 57h1v1h-1z",
    fill: "#9c7257"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58h-1v-1h1z",
    fill: "#9a6f4d"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M16 58h-1v-1h1z",
    fill: "#976d49"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M16 57h1v1h-1z",
    fill: "#956c49"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M17 58v-1h1v1z",
    fill: "#8e6442"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#93633c"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fill: "#92623c"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#996845"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58h-1v-1h1z",
    fill: "#8d5937"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v-1h1v1z",
    fill: "#915d39"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M53 57h1v1h-1z",
    fill: "#a9734e"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M72 58h-1v-1h1z",
    fill: "#c08b5e"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#c59264"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#c08f63"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#c6956a"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#bb9876",
    fillOpacity: 0.847
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#c3b4a5",
    fillOpacity: 0.067
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M11 59v-1h1v1z",
    fill: "#93775d",
    fillOpacity: 0.671
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M13 58v1h-1v-1z",
    fill: "#9e7455"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M14 58h1v1h-1z",
    fill: "#9a704e"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M15 58h1v1h-1z",
    fill: "#976c48"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M20 58v1h-1v-1z",
    fill: "#996d4a"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M24 59h-1v-1h1z",
    fill: "#8f6240"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#90613f"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#926141"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1z",
    fill: "#8e5e3b"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h1v1h-1z",
    fill: "#966641"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1z",
    fill: "#9b6945"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M44 58v1h-1v-1z",
    fill: "#9b6743"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#98623e"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58h1v1h-1z",
    fill: "#9e6744"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M68 59v-1h1v1z",
    fill: "#c28d64"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#c59265"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#bd895b"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#c89466"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#c29065"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#c8986e"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#bb9877",
    fillOpacity: 0.753
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#d4d4ff",
    fillOpacity: 0.024
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M11 59h1v1h-1z",
    fill: "#91745c",
    fillOpacity: 0.549
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M13 60h-1v-1h1z",
    fill: "#9d7356"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M13 59h1v1h-1z",
    fill: "#9a7055"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M15 59v1h-1v-1z",
    fill: "#99704d"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M21 59h1v1h-1z",
    fill: "#956847"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v1h-1v-1z",
    fill: "#91623f"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#946441"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M39 60h-1v-1h1z",
    fill: "#92633f"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#93633e"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#96633f"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M45 60h-1v-1h1z",
    fill: "#a66e4a"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M46 60h-1v-1h1z",
    fill: "#9f6743"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#c79365"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#c49267"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#c49268"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#ca9b70"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#be9e7d",
    fillOpacity: 0.624
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M11 61v-1h1v1z",
    fill: "#987b64",
    fillOpacity: 0.478
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M13 61h-1v-1h1z",
    fill: "#9b7055"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M14 60v1h-1v-1z",
    fill: "#9b7056"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M15 61h-1v-1h1z",
    fill: "#986f4c"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M16 61h-1v-1h1z",
    fill: "#966b47"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M20 61h-1v-1h1z",
    fill: "#936543"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M33 61v-1h1v1z",
    fill: "#906240"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60v1h-1v-1z",
    fill: "#8b5c39"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1z",
    fill: "#8f5f3a"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h-1v-1h1z",
    fill: "#91613d"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M41 60h1v1h-1z",
    fill: "#966640"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v1h-1v-1z",
    fill: "#9a633f"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60h1v1h-1z",
    fill: "#9c623d"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#9f6641"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#bc885c"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#c18e60"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#c69263"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#c69365"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#c19065"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#bf8d62"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#c7986d"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#bc9e7c",
    fillOpacity: 0.529
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M12 62h-1v-1h1z",
    fill: "#987d69",
    fillOpacity: 0.4
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M13 62h-1v-1h1z",
    fill: "#997156"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M13 61h1v1h-1z",
    fill: "#9a6f50"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M15 62h-1v-1h1z",
    fill: "#976e4b"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M16 61h1v1h-1z",
    fill: "#996c4a"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#8a5b39"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1z",
    fill: "#946442"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M39 61h1v1h-1z",
    fill: "#976645"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M44 62h-1v-1h1z",
    fill: "#996340"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#9a6240"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1z",
    fill: "#a46c49"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#c58f69"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#c59365"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#c19164"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#c08e62"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#c3996e"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#bc9f7e",
    fillOpacity: 0.388
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M11 62h1v1h-1z",
    fill: "#927962",
    fillOpacity: 0.314
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M12 63v-1h1v1z",
    fill: "#957055"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M14 62v1h-1v-1z",
    fill: "#9d7252"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M14 63v-1h1v1z",
    fill: "#98704d"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M20 62h1v1h-1z",
    fill: "#926642"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M22 62h1v1h-1z",
    fill: "#916642"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M30 62h1v1h-1z",
    fill: "#835634"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M41 62v1h-1v-1z",
    fill: "#996846"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63h-1v-1h1z",
    fill: "#9d6645"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M45 63v-1h1v1z",
    fill: "#9f6846"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M67 63v-1h1v1z",
    fill: "#c08b62"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M71 63h-1v-1h1z",
    fill: "#c89368"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M76 63v-1h1v1z",
    fill: "#cc976b"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#c69567"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#c09164"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#c19b71",
    fillOpacity: 0.984
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#bba383",
    fillOpacity: 0.251
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M12 64h-1v-1h1z",
    fill: "#8f7762",
    fillOpacity: 0.243
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64h-1v-1h1z",
    fill: "#937056",
    fillOpacity: 0.988
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v-1h1v1z",
    fill: "#997051"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63h1v1h-1z",
    fill: "#8c5b3b"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M40 63h1v1h-1z",
    fill: "#8e5d3b"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h-1v-1h1z",
    fill: "#97603e"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M57 64h-1v-1h1z",
    fill: "#b17a55"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M62 63v1h-1v-1z",
    fill: "#bc8663"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63h1v1h-1z",
    fill: "#c69467"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v-1h1v1z",
    fill: "#c29669"
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#bc9b76",
    fillOpacity: 0.922
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#c2ae93",
    fillOpacity: 0.149
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M11 64h1v1h-1z",
    fill: "#8e7a66",
    fillOpacity: 0.196
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64v1h-1v-1z",
    fill: "#937157",
    fillOpacity: 0.957
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M13 64h1v1h-1z",
    fill: "#9d7457"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v-1h1v1z",
    fill: "#9a6e4f"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M16 64h1v1h-1z",
    fill: "#936947"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M18 64h1v1h-1z",
    fill: "#926543"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M20 64v1h-1v-1z",
    fill: "#936643"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M31 65v-1h1v1z",
    fill: "#8a5f3c"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1z",
    fill: "#926341"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M40 64h1v1h-1z",
    fill: "#936240"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M41 65v-1h1v1z",
    fill: "#8d5b38"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M60 64h1v1h-1z",
    fill: "#bc8662"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M61 65v-1h1v1z",
    fill: "#be8865"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65h-1v-1h1z",
    fill: "#b98360"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#c19263"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#c5996e"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M83 65h-1v-1h1z",
    fill: "#bb997a",
    fillOpacity: 0.847
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M84 64v1h-1v-1z",
    fill: "#cfafaf",
    fillOpacity: 0.063
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M12 65v1h-1v-1z",
    fill: "#907c67",
    fillOpacity: 0.145
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M13 66h-1v-1h1z",
    fill: "#917057",
    fillOpacity: 0.922
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M14 65v1h-1v-1z",
    fill: "#9b7356"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M15 66h-1v-1h1z",
    fill: "#9d7053"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66h-1v-1h1z",
    fill: "#9c7252"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M16 66v-1h1v1z",
    fill: "#916948"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v-1h1v1z",
    fill: "#8f6342"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M32 66h-1v-1h1z",
    fill: "#835935"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M32 65h1v1h-1z",
    fill: "#7e5330"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66h-1v-1h1z",
    fill: "#8e5c38"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#96623f"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M60 66v-1h1v1z",
    fill: "#bb8562"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M62 65v1h-1v-1z",
    fill: "#be8866"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M63 65v1h-1v-1z",
    fill: "#bd8764"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#c28c67"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65h1v1h-1z",
    fill: "#be8861"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#be885d"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1z",
    fill: "#be8c5f"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65v1h-1v-1z",
    fill: "#c29264"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#c6976e"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M82 65h1v1h-1z",
    fill: "#bf9a7f",
    fillOpacity: 0.753
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M84 65v1h-1v-1z",
    fill: "#ffd4d4",
    fillOpacity: 0.024
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M12 67h-1v-1h1z",
    fill: "#a18678",
    fillOpacity: 0.075
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M12 66h1v1h-1z",
    fill: "#916e55",
    fillOpacity: 0.867
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M13 66h1v1h-1z",
    fill: "#9b7050"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M15 66v1h-1v-1z",
    fill: "#9a6d52"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M16 67v-1h1v1z",
    fill: "#91684a"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66v1h-1v-1z",
    fill: "#946a4a"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M18 66h1v1h-1z",
    fill: "#946848"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#865534"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#926040"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M40 66h1v1h-1z",
    fill: "#996847"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#92603d"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h-1v-1h1z",
    fill: "#9a6744"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-1h1v1z",
    fill: "#be8763"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67h-1v-1h1z",
    fill: "#bf8b5d"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M71 67v-1h1v1z",
    fill: "#c49062"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#c79264"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M76 67h-1v-1h1z",
    fill: "#bc8759"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66v1h-1v-1z",
    fill: "#c59063"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M80 66v1h-1v-1z",
    fill: "#be8e60"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#c39467"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v-1h1v1z",
    fill: "#c89a73"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M83 66v1h-1v-1z",
    fill: "#bd9b81",
    fillOpacity: 0.624
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M11 68v-1h1v1z",
    fill: "#99997f",
    fillOpacity: 0.039
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68v-1h1v1z",
    fill: "#916e55",
    fillOpacity: 0.812
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M14 67v1h-1v-1z",
    fill: "#9e7250"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M15 68h-1v-1h1z",
    fill: "#986d51"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M15 67h1v1h-1z",
    fill: "#976e54"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67v1h-1v-1z",
    fill: "#956c4f"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M17 67h1v1h-1z",
    fill: "#976c4e"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M18 67h1v1h-1z",
    fill: "#986c4c"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M27 68h-1v-1h1z",
    fill: "#885d39"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67v1h-1v-1z",
    fill: "#9e6b48"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#a26b47"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67h1v1h-1z",
    fill: "#955f3b"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M61 67h1v1h-1z",
    fill: "#c28b65"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M63 67v1h-1v-1z",
    fill: "#bf8963"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68v-1h1v1z",
    fill: "#c48e67"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67h1v1h-1z",
    fill: "#b88455"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67v1h-1v-1z",
    fill: "#c49060"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#bf8c60"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#c39568"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h1v1h-1z",
    fill: "#c49a73"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68v-1h1v1z",
    fill: "#bb9e82",
    fillOpacity: 0.506
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M11 69v-1h1v1z",
    fill: "#ccc",
    fillOpacity: 0.02
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M12 68h1v1h-1z",
    fill: "#927259",
    fillOpacity: 0.745
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M13 69v-1h1v1z",
    fill: "#9f7655"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M14 68h1v1h-1z",
    fill: "#9a7054"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M17 68h1v1h-1z",
    fill: "#976d4d"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M26 69h-1v-1h1z",
    fill: "#8d613f"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M27 69h-1v-1h1z",
    fill: "#8a5f3b"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M33 69v-1h1v1z",
    fill: "#835633"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1z",
    fill: "#966543"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69h-1v-1h1z",
    fill: "#905e3b"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M45 69v-1h1v1z",
    fill: "#976440"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69v-1h1v1z",
    fill: "#c08c5d"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v-1h1v1z",
    fill: "#c18d5e"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M77 69h-1v-1h1z",
    fill: "#c28c60"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M79 69h-1v-1h1z",
    fill: "#c49166"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M81 68v1h-1v-1z",
    fill: "#c39569"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M81 69v-1h1v1z",
    fill: "#c39b73"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M82 68h1v1h-1z",
    fill: "#b89d7f",
    fillOpacity: 0.369
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70v-1h1v1z",
    fill: "#91745b",
    fillOpacity: 0.655
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70h-1v-1h1z",
    fill: "#9c7656"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69v1h-1v-1z",
    fill: "#936a4d"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M16 69h1v1h-1z",
    fill: "#966d4e"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M17 70v-1h1v1z",
    fill: "#976d4c"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v1h-1v-1z",
    fill: "#8b5935"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#8e5c39"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h1v1z",
    fill: "#986542"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70h-1v-1h1z",
    fill: "#c08a60"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#be8a5b"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69v1h-1v-1z",
    fill: "#b78354"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70h-1v-1h1z",
    fill: "#c59267"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h-1v-1h1z",
    fill: "#c29369"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#bf9a75",
    fillOpacity: 0.988
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#c1a78a",
    fillOpacity: 0.275
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M12 70h1v1h-1z",
    fill: "#8d735c",
    fillOpacity: 0.565
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M14 70v1h-1v-1z",
    fill: "#987556"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M16 70v1h-1v-1z",
    fill: "#966d50"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M17 71h-1v-1h1z",
    fill: "#976e4e"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M33 70v1h-1v-1z",
    fill: "#8b603c"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M33 71v-1h1v1z",
    fill: "#835936"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#966541"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M46 70h1v1h-1z",
    fill: "#a26d48"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M58 71h-1v-1h1z",
    fill: "#bb8561"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M62 71v-1h1v1z",
    fill: "#c18c63"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M69 71v-1h1v1z",
    fill: "#bd885a"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#bd8a5a"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M73 71h-1v-1h1z",
    fill: "#b48151"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M78 70v1h-1v-1z",
    fill: "#c89269"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M79 70v1h-1v-1z",
    fill: "#c08d63"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1z",
    fill: "#c7976d"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70h1v1h-1z",
    fill: "#c19d7c",
    fillOpacity: 0.933
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#c2aa97",
    fillOpacity: 0.165
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71v1h-1v-1z",
    fill: "#927a64",
    fillOpacity: 0.459
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M13 71h1v1h-1z",
    fill: "#9a7758"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M15 71h1v1h-1z",
    fill: "#946c4e"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M16 71h1v1h-1z",
    fill: "#966c4d"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72v-1h1v1z",
    fill: "#845533"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M42 71v1h-1v-1z",
    fill: "#8d5d3a"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M42 72v-1h1v1z",
    fill: "#93613f"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M44 71v1h-1v-1z",
    fill: "#a06d4b"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#9d6948"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h1v1h-1z",
    fill: "#9d6746"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71v1h-1v-1z",
    fill: "#a8724f"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M56 72h-1v-1h1z",
    fill: "#ba8461"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M57 72h-1v-1h1z",
    fill: "#b7815e"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71v1h-1v-1z",
    fill: "#bd875d"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M63 71h1v1h-1z",
    fill: "#b68057"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M64 71h1v1h-1z",
    fill: "#bf8960"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#bf885f"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72h-1v-1h1z",
    fill: "#b58154"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M75 71h1v1h-1z",
    fill: "#bf8a5b"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M76 71h1v1h-1z",
    fill: "#c48d61"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M77 71h1v1h-1z",
    fill: "#c89268"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-1h1v1z",
    fill: "#c38f65"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#c6956b"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#c89a6e"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#c4a07e",
    fillOpacity: 0.867
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#c2b6aa",
    fillOpacity: 0.082
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M12 72h1v1h-1z",
    fill: "#9a846d",
    fillOpacity: 0.31
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M14 72v1h-1v-1z",
    fill: "#937152"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M15 73h-1v-1h1z",
    fill: "#977052"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M16 73h-1v-1h1z",
    fill: "#946d50"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M18 73h-1v-1h1z",
    fill: "#926646"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#805230"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73h-1v-1h1z",
    fill: "#996646"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M43 73v-1h1v1z",
    fill: "#a16a4b"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72h1v1h-1z",
    fill: "#a0694a"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73v-1h1v1z",
    fill: "#986142"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-1v-1z",
    fill: "#9d6647"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#9f6948"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72v1h-1v-1z",
    fill: "#aa7452"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72h1v1h-1z",
    fill: "#b27c59"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72v1h-1v-1z",
    fill: "#be8960"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M64 72v1h-1v-1z",
    fill: "#ba835c"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v-1h1v1z",
    fill: "#bb835d"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#c08660"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M70 72v1h-1v-1z",
    fill: "#ab764a"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#c58e64"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#c0895e"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M74 73v-1h1v1z",
    fill: "#c28c5f"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#c69061"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M77 72v1h-1v-1z",
    fill: "#c38b5e"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v1h-1v-1z",
    fill: "#c69468"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#c69469"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#c4996d"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M82 72v1h-1v-1z",
    fill: "#c2a180",
    fillOpacity: 0.78
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73h-1v-1h1z",
    fill: "#e2c6e2",
    fillOpacity: 0.035
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M12 73h1v1h-1z",
    fill: "#9e8872",
    fillOpacity: 0.271
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M13 74v-1h1v1z",
    fill: "#957356",
    fillOpacity: 0.996
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74v-1h1v1z",
    fill: "#976f53"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74h-1v-1h1z",
    fill: "#966c4e"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M19 74h-1v-1h1z",
    fill: "#926745"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#7d4f2d"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#825231"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#9d6747"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74v-1h1v1z",
    fill: "#9e6847"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h1v1h-1z",
    fill: "#9f6a49"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-1v-1z",
    fill: "#a7714e"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#b78059"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M66 73v1h-1v-1z",
    fill: "#bd865f"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M75 74h-1v-1h1z",
    fill: "#c38d60"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#c79164"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#c58e63"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74v-1h1v1z",
    fill: "#c69569"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#c39268"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#c69c70"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#bca07e",
    fillOpacity: 0.675
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M12 75v-1h1v1z",
    fill: "#a18c77",
    fillOpacity: 0.192
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M14 74v1h-1v-1z",
    fill: "#917055",
    fillOpacity: 0.953
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M15 75h-1v-1h1z",
    fill: "#976e50"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M15 74h1v1h-1z",
    fill: "#956c51"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M17 74v1h-1v-1z",
    fill: "#956b4e"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M17 75v-1h1v1z",
    fill: "#956a4a"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M19 75v-1h1v1z",
    fill: "#946846"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#986140"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M62 75h-1v-1h1z",
    fill: "#c59068"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1z",
    fill: "#bf8861"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h1v1h-1z",
    fill: "#c28b64"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1z",
    fill: "#bd895f"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#c8976a"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#c3946a"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#c89f76"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1z",
    fill: "#bca181",
    fillOpacity: 0.557
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M12 75h1v1h-1z",
    fill: "#ad998e",
    fillOpacity: 0.098
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M14 75v1h-1v-1z",
    fill: "#947358",
    fillOpacity: 0.894
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M14 75h1v1h-1z",
    fill: "#9a7153"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v-1h1v1z",
    fill: "#8a5d3a"
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#916241"
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#9c6643"
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#9a6540"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1z",
    fill: "#a97350"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M60 75h1v1h-1z",
    fill: "#b9845e"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1z",
    fill: "#b6825b"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M64 76v-1h1v1z",
    fill: "#ba835e"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M66 76h-1v-1h1z",
    fill: "#bf8863"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#c08c61"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#be9062"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#c19469"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#c59e77"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v1h-1v-1z",
    fill: "#bfa585",
    fillOpacity: 0.412
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M12 76h1v1h-1z",
    fill: "#b8aa9b",
    fillOpacity: 0.071
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M13 77v-1h1v1z",
    fill: "#937258",
    fillOpacity: 0.859
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M15 76h1v1h-1z",
    fill: "#966d52"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M17 77h-1v-1h1z",
    fill: "#956a4e"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M18 77h-1v-1h1z",
    fill: "#936749"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#8e613e"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#8f603f"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#8f5c3a"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#98623f"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1z",
    fill: "#996440"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#98633f"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M50 76h1v1h-1z",
    fill: "#a36d48"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v-1h1v1z",
    fill: "#a56f4c"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M64 77h-1v-1h1z",
    fill: "#ba845d"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#c38e60"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#c48f65"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#c19063"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#bd9265"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#be9771",
    fillOpacity: 0.996
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#bea487",
    fillOpacity: 0.31
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M13 78h-1v-1h1z",
    fill: "#d4d4bf",
    fillOpacity: 0.047
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77v1h-1v-1z",
    fill: "#94735b",
    fillOpacity: 0.816
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M14 77h1v1h-1z",
    fill: "#9b6f54"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h-1v-1h1z",
    fill: "#936a4e"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M30 78v-1h1v1z",
    fill: "#815431"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#956745"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#8c5c3b"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#96603f"
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#9c6644"
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M48 77v1h-1v-1z",
    fill: "#a46e4d"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M57 77v1h-1v-1z",
    fill: "#b17b59"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M66 78h-1v-1h1z",
    fill: "#c8946b"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M67 77v1h-1v-1z",
    fill: "#c48f67"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1z",
    fill: "#c28d62"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#bc9268"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#c89568"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#c09771",
    fillOpacity: 0.953
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M82 78h-1v-1h1z",
    fill: "#c1ad93",
    fillOpacity: 0.196
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79v-1h1v1z",
    fill: "#92715b",
    fillOpacity: 0.722
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M15 78v1h-1v-1z",
    fill: "#9a6e53"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M16 78h1v1h-1z",
    fill: "#93684b"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79h-1v-1h1z",
    fill: "#966b4b"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M18 79v-1h1v1z",
    fill: "#8d6241"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1z",
    fill: "#936342"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#956442"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#9a6946"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78h1v1h-1z",
    fill: "#9c6745"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78h1v1h-1z",
    fill: "#a26c4a"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79h-1v-1h1z",
    fill: "#ad7754"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M56 79v-1h1v1z",
    fill: "#b37d5b"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h-1v-1h1z",
    fill: "#b8825f"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M59 78h1v1h-1z",
    fill: "#ba845b"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79h-1v-1h1z",
    fill: "#c28d65"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78h1v1h-1z",
    fill: "#c18d61"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#c59466"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#be9268"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#ca9469"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79v-1h1v1z",
    fill: "#c39877",
    fillOpacity: 0.914
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M82 79h-1v-1h1z",
    fill: "#ccb2a1",
    fillOpacity: 0.118
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M13 79h1v1h-1z",
    fill: "#947562",
    fillOpacity: 0.631
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M15 79v1h-1v-1z",
    fill: "#996f55"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M17 79v1h-1v-1z",
    fill: "#926849"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h-1v-1h1z",
    fill: "#96694a"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#996946"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#94623e"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1z",
    fill: "#9a6743"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M47 79h1v1h-1z",
    fill: "#9e6846"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#b27b58"
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79h1v1h-1z",
    fill: "#b47d55"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M60 79v1h-1v-1z",
    fill: "#b27c51"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80v-1h1v1z",
    fill: "#be885c"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M76 79h1v1h-1z",
    fill: "#c79268"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80v-1h1v1z",
    fill: "#c39163"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79v1h-1v-1z",
    fill: "#bc9065"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v-1h1v1z",
    fill: "#ce9870"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M81 79v1h-1v-1z",
    fill: "#c79b7e",
    fillOpacity: 0.824
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80h-1v-1h1z",
    fill: "#dcb",
    fillOpacity: 0.059
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80v1h-1v-1z",
    fill: "#947665",
    fillOpacity: 0.592
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M14 80h1v1h-1z",
    fill: "#9a7157"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M16 80v1h-1v-1z",
    fill: "#997050"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M17 81h-1v-1h1z",
    fill: "#996f4f"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81v-1h1v1z",
    fill: "#976b4b"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M19 80h1v1h-1z",
    fill: "#946748"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M20 80h1v1h-1z",
    fill: "#8f6243"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#976745"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#9a6843"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#9e6b47"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80v1h-1v-1z",
    fill: "#b57c59"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#b27a56"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1z",
    fill: "#b37b55"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#b78058"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M60 80h1v1h-1z",
    fill: "#bc855c"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M70 80h1v1h-1z",
    fill: "#bb8659"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#c49161"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M79 80v1h-1v-1z",
    fill: "#c3976a"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1z",
    fill: "#cd9b72"
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#c49d82",
    fillOpacity: 0.722
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M13 82v-1h1v1z",
    fill: "#927564",
    fillOpacity: 0.525
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M15 81v1h-1v-1z",
    fill: "#9a7258"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M18 81h1v1h-1z",
    fill: "#8e6343"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M20 81v1h-1v-1z",
    fill: "#956849"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M24 81v1h-1v-1z",
    fill: "#885c38"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M25 82h-1v-1h1z",
    fill: "#885c37"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#936341"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#986744"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1z",
    fill: "#905f3b"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#96643f"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81h1v1h-1z",
    fill: "#a06d49"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#9f6947"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#b8805b"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#ba835d"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82v-1h1v1z",
    fill: "#bb845e"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M59 82v-1h1v1z",
    fill: "#bc855f"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#b9825c"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#b78358"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#c5976a"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#ca9b71"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#c2a084",
    fillOpacity: 0.643
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M14 83h-1v-1h1z",
    fill: "#907565",
    fillOpacity: 0.435
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h-1v-1h1z",
    fill: "#976e55"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M15 82h1v1h-1z",
    fill: "#976c50"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M16 83v-1h1v1z",
    fill: "#9a6d53"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83h-1v-1h1z",
    fill: "#8c613c"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M21 83v-1h1v1z",
    fill: "#956945"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M29 83v-1h1v1z",
    fill: "#875b35"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M31 82v1h-1v-1z",
    fill: "#8a5e3a"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#895737"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h1v1z",
    fill: "#855433"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h1v1h-1z",
    fill: "#905e3d"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M41 83h-1v-1h1z",
    fill: "#8d5b39"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M45 82h1v1h-1z",
    fill: "#a26f4d"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#a56f4d"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-1z",
    fill: "#b27d53"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#b07b51"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h1v1h-1z",
    fill: "#bd8b60"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M69 82v1h-1v-1z",
    fill: "#bd895e"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#b88355"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1z",
    fill: "#c59468"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#c39167"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#c79a71"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#bda386",
    fillOpacity: 0.537
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M13 84v-1h1v1z",
    fill: "#907162",
    fillOpacity: 0.345
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83v1h-1v-1z",
    fill: "#926951"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M15 83h1v1h-1z",
    fill: "#91684b"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M18 83v1h-1v-1z",
    fill: "#976c4d"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M18 84v-1h1v1z",
    fill: "#956a49"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M30 83v1h-1v-1z",
    fill: "#895d38"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M38 84v-1h1v1z",
    fill: "#915f3f"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83v1h-1v-1z",
    fill: "#93603e"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M45 84h-1v-1h1z",
    fill: "#9b6846"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h1v1h-1z",
    fill: "#9b6744"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M59 83h1v1h-1z",
    fill: "#b47f56"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M66 84v-1h1v1z",
    fill: "#bd8960"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#b98556"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#c59364"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#c19466"
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84h-1v-1h1z",
    fill: "#c09266"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#c29973"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#bca28a",
    fillOpacity: 0.42
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M14 84v1h-1v-1z",
    fill: "#8e7060",
    fillOpacity: 0.31
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M15 84v1h-1v-1z",
    fill: "#8f6850"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M18 85h-1v-1h1z",
    fill: "#966d4c"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M20 84h1v1h-1z",
    fill: "#8e633f"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#996343"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#9d6846"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#9b6643"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h1z",
    fill: "#9f6a46"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1z",
    fill: "#b07b52"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#bb885d"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1z",
    fill: "#c38d62"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v-1h1v1z",
    fill: "#be9163"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#c69a6c"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v-1h1v1z",
    fill: "#be9874",
    fillOpacity: 0.996
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85h-1v-1h1z",
    fill: "#c2a895",
    fillOpacity: 0.314
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M14 86h-1v-1h1z",
    fill: "#97776b",
    fillOpacity: 0.251
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M14 85h1v1h-1z",
    fill: "#8f6851",
    fillOpacity: 0.984
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M16 85v1h-1v-1z",
    fill: "#956d4e"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M17 86h-1v-1h1z",
    fill: "#956c4d"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M18 86h-1v-1h1z",
    fill: "#916847"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M19 85v1h-1v-1z",
    fill: "#916946"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86h-1v-1h1z",
    fill: "#926843"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M23 86v-1h1v1z",
    fill: "#956848"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86v-1h1v1z",
    fill: "#8a5d3e"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#926442"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#9e6949"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#996441"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#a06c47"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#a6704a"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#a9744b"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v1h-1v-1z",
    fill: "#b68259"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1z",
    fill: "#b88559"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#b88356"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1z",
    fill: "#c69164"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85v1h-1v-1z",
    fill: "#c39766"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#bd9972",
    fillOpacity: 0.961
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#c0a691",
    fillOpacity: 0.192
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h-1v-1h1z",
    fill: "#92796c",
    fillOpacity: 0.157
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v-1h1v1z",
    fill: "#8a654c",
    fillOpacity: 0.937
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M16 86h1v1h-1z",
    fill: "#936b4c"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M17 87v-1h1v1z",
    fill: "#8c6342"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h-1v-1h1z",
    fill: "#906744"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v-1h1v1z",
    fill: "#916641"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M25 86v1h-1v-1z",
    fill: "#8b5e3e"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87h-1v-1h1z",
    fill: "#8d6040"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M26 87v-1h1v1z",
    fill: "#885b3b"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M29 86h1v1h-1z",
    fill: "#845737"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#976042"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#915a3a"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#97623f"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#97613e"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#9f6a45"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#9d6641"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#ab7653"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#aa7552"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#b37d56"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#b07c53"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#bf8a5c"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#c59765"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M79 86h1v1h-1z",
    fill: "#bd9a73",
    fillOpacity: 0.91
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#bfaf97",
    fillOpacity: 0.125
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87v1h-1v-1z",
    fill: "#848466",
    fillOpacity: 0.098
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M14 87h1v1h-1z",
    fill: "#86674b",
    fillOpacity: 0.898
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88h-1v-1h1z",
    fill: "#926a4d"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M16 87h1v1h-1z",
    fill: "#91674c"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88h-1v-1h1z",
    fill: "#926649"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87v1h-1v-1z",
    fill: "#936846"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M19 87h1v1h-1z",
    fill: "#916745"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M27 88h-1v-1h1z",
    fill: "#895c3c"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#946140"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#915c3c"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#966140"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#a8734f"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#a7734f"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#a77248"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#be885b"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#b98355"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#bf8a5d"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M75 88v-1h1v1z",
    fill: "#c9946a"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#c29464"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#cc9b6e"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#be9e7d",
    fillOpacity: 0.812
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#c4d7c4",
    fillOpacity: 0.051
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M13 89v-1h1v1z",
    fill: "#a3a391",
    fillOpacity: 0.055
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M14 88h1v1h-1z",
    fill: "#886b50",
    fillOpacity: 0.827
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M16 88v1h-1v-1z",
    fill: "#926b4b"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M17 89h-1v-1h1z",
    fill: "#8f6749"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M18 88v1h-1v-1z",
    fill: "#94694b"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M20 88v1h-1v-1z",
    fill: "#916747"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M34 88v1h-1v-1z",
    fill: "#7b4f2c"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#936141"
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#946040"
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#935e3d"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#905a38"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#9e6945"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#ae7951"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#bd875f"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#b98459"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#bd875c"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#bd875a"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#b47f53"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#ca996c"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#bd9a7c",
    fillOpacity: 0.729
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h-1v-1h1z",
    fill: "#876b51",
    fillOpacity: 0.71
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M16 90h-1v-1h1z",
    fill: "#8e6b4a"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M16 89h1v1h-1z",
    fill: "#8d6748"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M17 90v-1h1v1z",
    fill: "#92684a"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M19 90v-1h1v1z",
    fill: "#906646"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M22 90h-1v-1h1z",
    fill: "#8d5f3e"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M26 89v1h-1v-1z",
    fill: "#926743"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#8f5d3c"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#925d3c"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#9d6542"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#9c6843"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#bc865b"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v1h-1v-1z",
    fill: "#c68f68"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#ca996f"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#be9c7f",
    fillOpacity: 0.62
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91h-1v-1h1z",
    fill: "#8a715a",
    fillOpacity: 0.608
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M15 90h1v1h-1z",
    fill: "#8e6c4d"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91v-1h1v1z",
    fill: "#8d694a"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M18 90v1h-1v-1z",
    fill: "#8f6648"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M20 91h-1v-1h1z",
    fill: "#916746"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M21 90v1h-1v-1z",
    fill: "#906443"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M25 90h1v1h-1z",
    fill: "#8c603b"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#986343"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#8e5939"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#925c3a"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#aa744f"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#c48e64"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#c28e66"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1z",
    fill: "#bb8d62"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M79 91h-1v-1h1z",
    fill: "#c99b72"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#bfa081",
    fillOpacity: 0.486
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M15 91v1h-1v-1z",
    fill: "#927a66",
    fillOpacity: 0.431
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M16 92h-1v-1h1z",
    fill: "#8c6d50"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M16 91h1v1h-1z",
    fill: "#896548"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M17 92v-1h1v1z",
    fill: "#8c6446"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92h-1v-1h1z",
    fill: "#946a49"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h-1v-1h1z",
    fill: "#8b5f39"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#805330"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#845432"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#8e5938"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#af7a56"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#ab744e"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#bb875d"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#b9855d"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1z",
    fill: "#c69167"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#be8b64"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#bc8f63"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M78 91h1v1h-1z",
    fill: "#c49971"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#c5a689",
    fillOpacity: 0.384
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93h-1v-1h1z",
    fill: "#887d65",
    fillOpacity: 0.286
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93h-1v-1h1z",
    fill: "#81684a"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93h-1v-1h1z",
    fill: "#8b6947"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M18 93h-1v-1h1z",
    fill: "#876142"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M19 92v1h-1v-1z",
    fill: "#8e6348"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M19 93v-1h1v1z",
    fill: "#8e6141"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v-1h1v1z",
    fill: "#8d623e"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M22 93h-1v-1h1z",
    fill: "#8c613e"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M22 92h1v1h-1z",
    fill: "#8d623f"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M26 92h1v1h-1z",
    fill: "#8b5f3b"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M27 92h1v1h-1z",
    fill: "#875b37"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#915f3e"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#90593a"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#945b3b"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#a06945"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#b07c57"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#af7c57"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#ac7954"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#ae794f"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#b38054"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#bd8a60"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92v1h-1v-1z",
    fill: "#bc865d"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1z",
    fill: "#bc895e"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#b88962"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#bf9163"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#bc966e",
    fillOpacity: 0.976
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92h1v1h-1z",
    fill: "#bba18c",
    fillOpacity: 0.235
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M15 93v1h-1v-1z",
    fill: "#997f7f",
    fillOpacity: 0.039
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M16 93v1h-1v-1z",
    fill: "#80694d",
    fillOpacity: 0.569
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h-1v-1h1z",
    fill: "#846644"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M17 93h1v1h-1z",
    fill: "#87603c"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M19 94h-1v-1h1z",
    fill: "#8d6143"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93v1h-1v-1z",
    fill: "#8c6244"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M20 93h1v1h-1z",
    fill: "#8b613f"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v-1h1v1z",
    fill: "#8b603d"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M30 93v1h-1v-1z",
    fill: "#835635"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1z",
    fill: "#875c39"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#8c5636"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#915938"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#945d3c"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#a46e49"
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93v1h-1v-1z",
    fill: "#a76f4c"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#aa7752"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#aa7853"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#be8a61"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#c28e64"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#c39567"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#b79877",
    fillOpacity: 0.835
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M80 93v1h-1v-1z",
    fill: "#c3b4b4",
    fillOpacity: 0.067
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94v1h-1v-1z",
    fill: "#826e51",
    fillOpacity: 0.443
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M17 94h1v1h-1z",
    fill: "#80613f",
    fillOpacity: 0.961
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M21 94v1h-1v-1z",
    fill: "#865b39"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95h-1v-1h1z",
    fill: "#895e3c"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M26 94v1h-1v-1z",
    fill: "#845937"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95v-1h1v1z",
    fill: "#855a38"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M28 95h-1v-1h1z",
    fill: "#875c3a"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M29 95h-1v-1h1z",
    fill: "#845837"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#966342"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#9a6443"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1z",
    fill: "#a9724e"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1z",
    fill: "#a8704d"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M53 94v1h-1v-1z",
    fill: "#af7855"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#a97450"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#a97651"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#a87551"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#ac7750"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#b48156"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#b9865c"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#b48058"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#b8875d"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#ba885d"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#b68358"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1z",
    fill: "#b8865a"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#c08c5c"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#be9167"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M79 94v1h-1v-1z",
    fill: "#b59a7f",
    fillOpacity: 0.478
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h-1v-1h1z",
    fill: "#b1a087",
    fillOpacity: 0.643
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96v-1h1v1z",
    fill: "#947659"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M19 95h1v1h-1z",
    fill: "#835c3c"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M21 95v1h-1v-1z",
    fill: "#845c39"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M22 95v1h-1v-1z",
    fill: "#845d3a"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M22 96v-1h1v1z",
    fill: "#865e3b"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h-1v-1h1z",
    fill: "#835937"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M25 96h-1v-1h1z",
    fill: "#855a39"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96h-1v-1h1z",
    fill: "#875e3d"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M26 95h1v1h-1z",
    fill: "#845c3b"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96v-1h1v1z",
    fill: "#865d3b"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96v-1h1v1z",
    fill: "#815534"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#936040"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#915e3d"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#925d3b"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h1v1h-1z",
    fill: "#aa724f"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1z",
    fill: "#a8714d"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#a8734e"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#a5734e"
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#b27c55"
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1z",
    fill: "#b57e5a"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M64 96h-1v-1h1z",
    fill: "#be8864"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#b48157"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#b7865c"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#bc8a5e"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1z",
    fill: "#b78459"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95h1v1h-1z",
    fill: "#b9885d"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M75 95h1v1h-1z",
    fill: "#b98c5f"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95h1v1h-1z",
    fill: "#b78b5f"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v-1h1v1z",
    fill: "#b99474",
    fillOpacity: 0.749
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1z",
    fill: "#c9bbae",
    fillOpacity: 0.075
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M17 97v-1h1v1z",
    fill: "#e2dcd0",
    fillOpacity: 0.49
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M18 96h1v1h-1z",
    fill: "#dfd2c1"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M19 96h1v1h-1z",
    fill: "#af9783"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97v-1h1v1z",
    fill: "#836244"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M21 96h1v1h-1z",
    fill: "#7a5533"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M23 96v1h-1v-1z",
    fill: "#845f3d"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96v1h-1v-1z",
    fill: "#825b3a"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96h1v1h-1z",
    fill: "#835b3a"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M26 96v1h-1v-1z",
    fill: "#815939"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v-1h1v1z",
    fill: "#835b3b"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M27 96h1v1h-1z",
    fill: "#805736"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M28 96h1v1h-1z",
    fill: "#7d5231"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v-1h1v1z",
    fill: "#7d5130"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M31 96v1h-1v-1z",
    fill: "#7c512e"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#976541"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M51 96v1h-1v-1z",
    fill: "#a16b46"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1z",
    fill: "#a36b48"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#a66f4b"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#9f6b46"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#a6734e"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97v-1h1v1z",
    fill: "#a97652"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M58 97v-1h1v1z",
    fill: "#b8815b"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97v-1h1v1z",
    fill: "#b17e57"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96v1h-1v-1z",
    fill: "#b6855b"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#b9865a"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v-1h1v1z",
    fill: "#b18255"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1z",
    fill: "#b48b5e"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M77 96v1h-1v-1z",
    fill: "#c6ac8c",
    fillOpacity: 0.988
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M77 97v-1h1v1z",
    fill: "#e7dac5",
    fillOpacity: 0.298
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98h-1v-1h1z",
    fill: "#d9d4d1",
    fillOpacity: 0.396
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98v-1h1v1z",
    fill: "#ded7d3"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M19 97h1v1h-1z",
    fill: "#e1d6cd"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M20 97h1v1h-1z",
    fill: "#d4c3b0"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M21 97h1v1h-1z",
    fill: "#aa9277"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M22 97h1v1h-1z",
    fill: "#846747"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97v1h-1v-1z",
    fill: "#7a5734"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M24 97h1v1h-1z",
    fill: "#7d5332"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M26 97v1h-1v-1z",
    fill: "#7c5331"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h-1v-1h1z",
    fill: "#825634"
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M28 98h-1v-1h1z",
    fill: "#815231"
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97v1h-1v-1z",
    fill: "#805533"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M29 97h1v1h-1z",
    fill: "#7a512e"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M33 97v1h-1v-1z",
    fill: "#805231"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#774b2a"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#7b4f2e"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-1h1v1z",
    fill: "#7a4c2d"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#7d4c2d"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M38 97v1h-1v-1z",
    fill: "#855535"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M38 98v-1h1v1z",
    fill: "#865737"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97h1v1h-1z",
    fill: "#8a5936"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1z",
    fill: "#a26d4a"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#a16b45"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1z",
    fill: "#9f6943"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M51 98v-1h1v1z",
    fill: "#a9744f"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#a7704d"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#ab7451"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#ac7551"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M59 97v1h-1v-1z",
    fill: "#b67e59"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M61 98h-1v-1h1z",
    fill: "#b17a53"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#b07952"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v-1h1v1z",
    fill: "#ae7954"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#b17a54"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#b5805a"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#b48258"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#b6855a"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#b78558"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#b38157"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97h1v1h-1z",
    fill: "#b68f6c"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M76 97v1h-1v-1z",
    fill: "#dfc5ac"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M76 98v-1h1v1z",
    fill: "#f0e8dc",
    fillOpacity: 0.902
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#eff7ef",
    fillOpacity: 0.129
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M18 98v1h-1v-1z",
    fill: "#d6d3d3",
    fillOpacity: 0.298
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99h-1v-1h1z",
    fill: "#d5d2cd",
    fillOpacity: 0.996
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M20 98v1h-1v-1z",
    fill: "#d7d3ca"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M24 99h-1v-1h1z",
    fill: "#b8a38c"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h-1v-1h1z",
    fill: "#96795c"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99v-1h1v1z",
    fill: "#7e5e38"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98v1h-1v-1z",
    fill: "#775028"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M27 98h1v1h-1z",
    fill: "#7b4e2a"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M31 99h-1v-1h1z",
    fill: "#835432"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M31 98h1v1h-1z",
    fill: "#815633"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#7e5230"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#805433"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h-1v-1h1z",
    fill: "#7b4e2e"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#835435"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#815234"
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1z",
    fill: "#8f6242"
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99v-1h1v1z",
    fill: "#936140"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M51 99v-1h1v1z",
    fill: "#97643f"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1z",
    fill: "#a97650"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1z",
    fill: "#a6724d"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99v-1h1v1z",
    fill: "#a46f4a"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1z",
    fill: "#ac7755"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#a97451"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h1v1z",
    fill: "#b37e58"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98v1h-1v-1z",
    fill: "#b27c5a"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M64 99h-1v-1h1z",
    fill: "#b17a59"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M65 98v1h-1v-1z",
    fill: "#b07a58"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M68 99v-1h1v1z",
    fill: "#a9734c"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M69 98h1v1h-1z",
    fill: "#ad7951"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M72 98v1h-1v-1z",
    fill: "#ae8660"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#be9b79"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99h-1v-1h1z",
    fill: "#d8bda5"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99h-1v-1h1z",
    fill: "#f1e1d3"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M75 99v-1h1v1z",
    fill: "#f4eee9"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98v1h-1v-1z",
    fill: "#eae9e6",
    fillOpacity: 0.82
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M17 100v-1h1v1z",
    fill: "#d5d5d1",
    fillOpacity: 0.243
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M19 99v1h-1v-1z",
    fill: "#d2d2cd",
    fillOpacity: 0.984
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v-1h1v1z",
    fill: "#d4d4ca"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M21 99v1h-1v-1z",
    fill: "#d1d4c9"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M21 100v-1h1v1z",
    fill: "#d1d3cb"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M22 99h1v1h-1z",
    fill: "#d7d5ce"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100h-1v-1h1z",
    fill: "#ded8cc"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100v-1h1v1z",
    fill: "#d9d2bc"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M25 99h1v1h-1z",
    fill: "#cabca1"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100h-1v-1h1z",
    fill: "#b59d81"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M27 100v-1h1v1z",
    fill: "#9c7d62"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M28 100v-1h1v1z",
    fill: "#846344"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100h-1v-1h1z",
    fill: "#795330"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v-1h1v1z",
    fill: "#724824"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M32 100h-1v-1h1z",
    fill: "#7a4f2b"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M33 100h-1v-1h1z",
    fill: "#784b29"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#875835"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-1z",
    fill: "#835532"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#815330"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#875837"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#835433"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h1v1h-1z",
    fill: "#885838"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1z",
    fill: "#845333"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M42 99h1v1h-1z",
    fill: "#8d5b3a"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#92613e"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M45 100h-1v-1h1z",
    fill: "#976642"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M47 100h-1v-1h1z",
    fill: "#94603e"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h1v1z",
    fill: "#a6734d"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M52 99v1h-1v-1z",
    fill: "#a46d4a"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M55 99v1h-1v-1z",
    fill: "#a36c48"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-1z",
    fill: "#a46f4b"
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100v-1h1v1z",
    fill: "#ab754d"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99h1v1h-1z",
    fill: "#b27951"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M63 99v1h-1v-1z",
    fill: "#b17751"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M63 100v-1h1v1z",
    fill: "#b47a57"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#b47b57"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1z",
    fill: "#ad7550"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99h1v1h-1z",
    fill: "#ac7a56"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h1v1h-1z",
    fill: "#ab7f58"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M69 99v1h-1v-1z",
    fill: "#a7805a"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100v-1h1v1z",
    fill: "#ba9b78"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100v-1h1v1z",
    fill: "#cdb394"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M71 99h1v1h-1z",
    fill: "#e2cfb7"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M73 100h-1v-1h1z",
    fill: "#f2e4d4"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v1h-1v-1z",
    fill: "#ede7de"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 100v-1h1v1z",
    fill: "#eae9e6"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1z",
    fill: "#f0efef"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M76 100v-1h1v1z",
    fill: "#eaeae8",
    fillOpacity: 0.725
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M77 99h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M18 101h-1v-1h1z",
    fill: "#d1d1d1",
    fillOpacity: 0.196
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M19 100v1h-1v-1z",
    fill: "#d4d4ce",
    fillOpacity: 0.957
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M20 100v1h-1v-1z",
    fill: "#d6d6ce"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101h-1v-1h1z",
    fill: "#d5d3c9"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M23 101v-1h1v1z",
    fill: "#d2d3c8"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101h-1v-1h1z",
    fill: "#d1d3c6"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M25 100h1v1h-1z",
    fill: "#d5d5c8"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M27 101v-1h1v1z",
    fill: "#e0d4c8"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M29 101h-1v-1h1z",
    fill: "#d6cbb6"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M30 100v1h-1v-1z",
    fill: "#c8b89b"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101h-1v-1h1z",
    fill: "#b69e80"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100h1v1h-1z",
    fill: "#a5866a"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101v-1h1v1z",
    fill: "#8f6c4f"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#7e5839"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v1h-1v-1z",
    fill: "#795331"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#734f2b"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#77522e"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#805835"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1z",
    fill: "#825734"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1z",
    fill: "#825432"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M42 100h1v1h-1z",
    fill: "#885a37"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#865734"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101v-1h1v1z",
    fill: "#94633f"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M46 101v-1h1v1z",
    fill: "#9a6a46"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h1v1z",
    fill: "#a5714a"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M51 100v1h-1v-1z",
    fill: "#a46f48"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M52 100v1h-1v-1z",
    fill: "#a36a48"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-1v-1h1z",
    fill: "#a16946"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101h-1v-1h1z",
    fill: "#aa7350"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1z",
    fill: "#ab7350"
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M56 100v1h-1v-1z",
    fill: "#aa734f"
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M58 101h-1v-1h1z",
    fill: "#ab7751"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h-1v-1h1z",
    fill: "#a8754f"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v-1h1v1z",
    fill: "#a87752"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M61 100v1h-1v-1z",
    fill: "#9d6c46"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101v-1h1v1z",
    fill: "#a06d44"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#a6744d"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#a57754"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#a97e5d"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#b8906f"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101v-1h1v1z",
    fill: "#c9a989"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M68 100v1h-1v-1z",
    fill: "#d8bfa3"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h-1v-1h1z",
    fill: "#e6d6bf"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h1v1h-1z",
    fill: "#ede5d3"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M70 100h1v1h-1z",
    fill: "#eae7d8"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M71 100h1v1h-1z",
    fill: "#eae6dc"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M76 101h-1v-1h1z",
    fill: "#f5f1eb"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M77 100v1h-1v-1z",
    fill: "#ebe9e6",
    fillOpacity: 0.608
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M17 101h1v1h-1z",
    fill: "#dbdbdb",
    fillOpacity: 0.114
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M18 101h1v1h-1z",
    fill: "#d2d0cc",
    fillOpacity: 0.894
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M20 102h-1v-1h1z",
    fill: "#d8d4d0"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h-1v-1h1z",
    fill: "#d5d2cb"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101v1h-1v-1z",
    fill: "#d4d3c9"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M22 101h1v1h-1z",
    fill: "#d4d3c6"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M24 101v1h-1v-1z",
    fill: "#d4d4c6"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M25 101v1h-1v-1z",
    fill: "#d4d3ca"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102v-1h1v1z",
    fill: "#d4d4c9"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M28 102h-1v-1h1z",
    fill: "#d5d3cb"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M28 101h1v1h-1z",
    fill: "#d4d6ca"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M30 101v1h-1v-1z",
    fill: "#d6d6c5"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M31 101v1h-1v-1z",
    fill: "#d9d6c5"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M31 102v-1h1v1z",
    fill: "#d9d4c4"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M32 101h1v1h-1z",
    fill: "#dbcfbe"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M34 101v1h-1v-1z",
    fill: "#d3c5ae"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102v-1h1v1z",
    fill: "#c6b99d"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1z",
    fill: "#b5a688"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#a79174"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#9e8366"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M39 102h-1v-1h1z",
    fill: "#927254"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M39 101h1v1h-1z",
    fill: "#876344"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1z",
    fill: "#85603d"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h1v1z",
    fill: "#835f39"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M43 101v1h-1v-1z",
    fill: "#825935"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M43 102v-1h1v1z",
    fill: "#80542f"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M46 102v-1h1v1z",
    fill: "#8b5d39"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M47 101h1v1h-1z",
    fill: "#8c5d38"
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v-1h1v1z",
    fill: "#976640"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102h-1v-1h1z",
    fill: "#95623b"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M50 101h1v1h-1z",
    fill: "#96633c"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M51 101h1v1h-1z",
    fill: "#996540"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101v1h-1v-1z",
    fill: "#9c6945"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M54 101v1h-1v-1z",
    fill: "#9b6944"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101v1h-1v-1z",
    fill: "#9e6d48"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M55 102v-1h1v1z",
    fill: "#9c6d48"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M57 102h-1v-1h1z",
    fill: "#9e704c"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#a67a59"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101v1h-1v-1z",
    fill: "#aa8262"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M59 101h1v1h-1z",
    fill: "#b69173"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#b69477"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#c2a585"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M63 101v1h-1v-1z",
    fill: "#d1b99c"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v-1h1v1z",
    fill: "#decbb4"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M65 101v1h-1v-1z",
    fill: "#eaddc9"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M65 102v-1h1v1z",
    fill: "#f0e6d4"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#efe8d9"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M68 102h-1v-1h1z",
    fill: "#ede8e0"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#e9e6e3"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M71 102h-1v-1h1z",
    fill: "#e9e7de"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101v1h-1v-1z",
    fill: "#ebe9e2"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101h1v1h-1z",
    fill: "#eeeae4"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102h-1v-1h1z",
    fill: "#efeae2"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M75 102v-1h1v1z",
    fill: "#f0f1ec"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M77 102h-1v-1h1z",
    fill: "#eaeae8",
    fillOpacity: 0.478
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M17 103v-1h1v1z",
    fill: "#dadada",
    fillOpacity: 0.055
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M19 102v1h-1v-1z",
    fill: "#d1cfcb",
    fillOpacity: 0.839
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103h-1v-1h1z",
    fill: "#d7d6d1"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102v1h-1v-1z",
    fill: "#d2d2ca"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M21 102h1v1h-1z",
    fill: "#d1d2c8"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M24 102v1h-1v-1z",
    fill: "#d4d0c8"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M24 103v-1h1v1z",
    fill: "#d6d1ca"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M25 102h1v1h-1z",
    fill: "#d7d1c8"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M29 103h-1v-1h1z",
    fill: "#d8d4ca"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M30 102v1h-1v-1z",
    fill: "#d9d3ca"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M31 103h-1v-1h1z",
    fill: "#d8d3ca"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1z",
    fill: "#ded6c6"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1z",
    fill: "#ded5c3"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h1v1z",
    fill: "#ddd2be"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M39 103v-1h1v1z",
    fill: "#dccfba"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M40 103v-1h1v1z",
    fill: "#d7c9b1"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1z",
    fill: "#cfc2a4"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M42 102h1v1h-1z",
    fill: "#caba9d"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#c6b195"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#c6ad92"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#c6ac91"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1z",
    fill: "#c2a88c"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1z",
    fill: "#c4aa8e"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1z",
    fill: "#c3a98c"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M50 102v1h-1v-1z",
    fill: "#c6ac8d"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h-1v-1h1z",
    fill: "#c8ad8f"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h1z",
    fill: "#ceb296"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M53 103h-1v-1h1z",
    fill: "#d2b89b"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M53 102h1v1h-1z",
    fill: "#d3bc9f"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M54 102h1v1h-1z",
    fill: "#d8c4a7"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-1v-1h1z",
    fill: "#dbc9ad"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1z",
    fill: "#e0cfba"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#e4d4c1"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#eadbca"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1z",
    fill: "#eedfd0"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102h1v1h-1z",
    fill: "#f1e3d5"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#eee9db"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#edeade"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M64 102v1h-1v-1z",
    fill: "#edebe2"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#ecebe5"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#e9e9e4"
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#ece8e6"
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#efeae6"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M76 103h-1v-1h1z",
    fill: "#ecede9",
    fillOpacity: 0.996
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h-1v-1h1z",
    fill: "#e9e9e6",
    fillOpacity: 0.325
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M17 104v-1h1v1z",
    fill: "#dadada",
    fillOpacity: 0.027
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104h-1v-1h1z",
    fill: "#d4d4d1",
    fillOpacity: 0.784
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M20 103v1h-1v-1z",
    fill: "#d8d7d3"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M25 103v1h-1v-1z",
    fill: "#d6d1cb"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104v-1h1v1z",
    fill: "#d6d1c8"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M35 103h1v1h-1z",
    fill: "#dbd7ca"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1z",
    fill: "#dcd7c9"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1z",
    fill: "#ddd8ca"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#dedacb"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#dfdbcb"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103v1h-1v-1z",
    fill: "#e3dbd3"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1z",
    fill: "#e4dbd4"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1z",
    fill: "#e3dcd3"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1z",
    fill: "#e1dfd4"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#e2e1d6"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104v-1h1v1z",
    fill: "#e4e3d7"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h-1v-1h1z",
    fill: "#e6e4d8"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M52 104h-1v-1h1z",
    fill: "#e4e1d5"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h1v1h-1z",
    fill: "#e4e3d6"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M54 103v1h-1v-1z",
    fill: "#e6e7d9"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104v-1h1v1z",
    fill: "#e5e7d8"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h1v1z",
    fill: "#e5e7d9"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103v1h-1v-1z",
    fill: "#e8e4dc"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M58 103h1v1h-1z",
    fill: "#e9e5de"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#e9e5df"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#eae5e0"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M62 104h-1v-1h1z",
    fill: "#eae9e1"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M62 103h1v1h-1z",
    fill: "#eaebe3"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M63 103h1v1h-1z",
    fill: "#ebeae4"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103v1h-1v-1z",
    fill: "#eae9e4"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M73 103h1v1h-1z",
    fill: "#efeae7"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104h-1v-1h1z",
    fill: "#efebe8"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M75 104v-1h1v1z",
    fill: "#eae9e5",
    fillOpacity: 0.941
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103v1h-1v-1z",
    fill: "#e8eee8",
    fillOpacity: 0.18
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M19 104v1h-1v-1z",
    fill: "#d2d0cc",
    fillOpacity: 0.694
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105v-1h1v1z",
    fill: "#d6d6d1"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M23 104h1v1h-1z",
    fill: "#d3d0c8"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M25 105h-1v-1h1z",
    fill: "#d5d1ca"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M25 104h1v1h-1z",
    fill: "#d3d2c7"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#ded8ca"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#ddd9cb"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1z",
    fill: "#dfddd1"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#deded1"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#ddded1"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#dfdfd2"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1z",
    fill: "#e4e1d8"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#e5e3db"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M51 104h1v1h-1z",
    fill: "#e5e3dc"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M55 105h-1v-1h1z",
    fill: "#e8e6db"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M56 105h-1v-1h1z",
    fill: "#e9e6db"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#e8e6e0"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-1z",
    fill: "#e8e6e3"
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1z",
    fill: "#eceae3"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M63 105h-1v-1h1z",
    fill: "#ece9e2"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105h-1v-1h1z",
    fill: "#f0edea"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v-1h1v1z",
    fill: "#eaeae5",
    fillOpacity: 0.863
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M76 105v-1h1v1z",
    fill: "#f2f2f2",
    fillOpacity: 0.078
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106h-1v-1h1z",
    fill: "#cececb",
    fillOpacity: 0.604
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M19 105h1v1h-1z",
    fill: "#d6d4d0"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M20 106v-1h1v1z",
    fill: "#d0d0c9"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#dcd8cb"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#e2dcd1"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1z",
    fill: "#dfded2"
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#e1e0d3"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1z",
    fill: "#e2e1d4"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#e3e1d6"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#e6e3dd"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1z",
    fill: "#e7e6e4"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#e9e4e0"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#e9e4e1"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v-1h1v1z",
    fill: "#ebe6e2"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106v-1h1v1z",
    fill: "#ebe7e1"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M75 105v1h-1v-1z",
    fill: "#f1efeb"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M76 106h-1v-1h1z",
    fill: "#e8e9e4",
    fillOpacity: 0.761
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M19 106v1h-1v-1z",
    fill: "#d0d0cc",
    fillOpacity: 0.514
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M19 107v-1h1v1z",
    fill: "#d5d4d0"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M27 106h1v1h-1z",
    fill: "#d1d1c5"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#e1dad1"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#e2d9d3"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#e2e2d5"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#e4e3d9"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#e4e2dc"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1z",
    fill: "#e6e4e2"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#e6e5e1"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M52 106h1v1h-1z",
    fill: "#e4e5e1"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#e5e5e2"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#e5e5e3"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#e5e5e4"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#e6e5e2"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M75 106v1h-1v-1z",
    fill: "#f3f1ed"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#e9ebe6",
    fillOpacity: 0.659
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M19 108h-1v-1h1z",
    fill: "#cfd1c9",
    fillOpacity: 0.396
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M20 107v1h-1v-1z",
    fill: "#d1d1cc"
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M21 108h-1v-1h1z",
    fill: "#d0cfc7"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#ded9cd"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M64 107v1h-1v-1z",
    fill: "#ebe7e2"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#f1f1ec"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107h1v1h-1z",
    fill: "#e9ebe6",
    fillOpacity: 0.569
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M18 108h1v1h-1z",
    fill: "#d2d2cc",
    fillOpacity: 0.294
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M20 109h-1v-1h1z",
    fill: "#cecfca"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M24 108v1h-1v-1z",
    fill: "#d1cdc4"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M25 108v1h-1v-1z",
    fill: "#d2cec6"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#eee9e6"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#eff0eb"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#e7e9e2",
    fillOpacity: 0.463
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M18 109h1v1h-1z",
    fill: "#d2d2d2",
    fillOpacity: 0.224
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M19 110v-1h1v1z",
    fill: "#cdcec9",
    fillOpacity: 0.973
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M29 109v1h-1v-1z",
    fill: "#d5d1c7"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#e2dfd4"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#e4e2d5"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#e4e2d7"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#e5e2d9"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#ecece7"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#eaeae7",
    fillOpacity: 0.341
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111h-1v-1h1z",
    fill: "#dbdbd4",
    fillOpacity: 0.141
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111h-1v-1h1z",
    fill: "#cbccc8",
    fillOpacity: 0.918
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M29 111h-1v-1h1z",
    fill: "#d3d0c6"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111v-1h1v1z",
    fill: "#e5e2d8"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#eaeae6"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#e9e8e5",
    fillOpacity: 0.973
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1z",
    fill: "#eeeeea",
    fillOpacity: 0.239
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M19 111v1h-1v-1z",
    fill: "#d6d6d6",
    fillOpacity: 0.075
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111v1h-1v-1z",
    fill: "#caccc7",
    fillOpacity: 0.863
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M20 111h1v1h-1z",
    fill: "#d2d0c8"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M28 111h1v1h-1z",
    fill: "#d2cfc5"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112h-1v-1h1z",
    fill: "#d8d5c8"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1z",
    fill: "#eaeae5"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#ecebe8"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#e9e8e4",
    fillOpacity: 0.929
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1z",
    fill: "#eaeaea",
    fillOpacity: 0.149
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M19 112h1v1h-1z",
    fill: "#cacbc6",
    fillOpacity: 0.776
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M21 113v-1h1v1z",
    fill: "#cecac2"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M22 113v-1h1v1z",
    fill: "#cfcbc4"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M24 113h-1v-1h1z",
    fill: "#d1ccc5"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M30 113h-1v-1h1z",
    fill: "#d6cec3"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M30 113v-1h1v1z",
    fill: "#d6cec5"
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#dedbcf"
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#e1ddd0"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v1h-1v-1z",
    fill: "#e5e1da"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#efeee9"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#eae9e6",
    fillOpacity: 0.827
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#efefef",
    fillOpacity: 0.063
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M20 113v1h-1v-1z",
    fill: "#cbccc6",
    fillOpacity: 0.659
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h-1v-1h1z",
    fill: "#cfcfc7"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M23 114h-1v-1h1z",
    fill: "#cec9c3"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114h-1v-1h1z",
    fill: "#d0ccc4"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M27 113h1v1h-1z",
    fill: "#d2ccc2"
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M29 113v1h-1v-1z",
    fill: "#d5ccc3"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M29 114v-1h1v1z",
    fill: "#d7cdc3"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M31 113v1h-1v-1z",
    fill: "#d7cdc4"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M33 113h1v1h-1z",
    fill: "#d8d1c7"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h-1v-1h1z",
    fill: "#e6e2da"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114h-1v-1h1z",
    fill: "#eae8e5",
    fillOpacity: 0.718
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M19 115v-1h1v1z",
    fill: "#c9c9c4",
    fillOpacity: 0.576
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M21 114h1v1h-1z",
    fill: "#ccc8c1"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M24 114v1h-1v-1z",
    fill: "#cdc9c2"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M26 114v1h-1v-1z",
    fill: "#d0cec4"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M28 114v1h-1v-1z",
    fill: "#d2cec4"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M29 114v1h-1v-1z",
    fill: "#d4cdc4"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M30 115h-1v-1h1z",
    fill: "#d5cdc6"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114v1h-1v-1z",
    fill: "#d7cdc6"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115v-1h1v1z",
    fill: "#e6e1db"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h1v1h-1z",
    fill: "#e5e3df"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#f2f1ec"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h1v1h-1z",
    fill: "#e9e7e4",
    fillOpacity: 0.604
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M20 115v1h-1v-1z",
    fill: "#cacac3",
    fillOpacity: 0.455
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M22 115v1h-1v-1z",
    fill: "#ccc8c3"
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M25 116h-1v-1h1z",
    fill: "#cdcac2"
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M27 116v-1h1v1z",
    fill: "#d1cec6"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M29 116h-1v-1h1z",
    fill: "#d1cdc5"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M30 115v1h-1v-1z",
    fill: "#d2ccc7"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M49 116h-1v-1h1z",
    fill: "#e2ded7"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M51 115v1h-1v-1z",
    fill: "#e6e1dd"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M75 116h-1v-1h1z",
    fill: "#eaeae6",
    fillOpacity: 0.482
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M19 117v-1h1v1z",
    fill: "#c5c5bf",
    fillOpacity: 0.314
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M20 116h1v1h-1z",
    fill: "#c9c9c2"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M26 116v1h-1v-1z",
    fill: "#ccccc2"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M26 117v-1h1v1z",
    fill: "#cecdc5"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M28 116h1v1h-1z",
    fill: "#d0cdc7"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M29 117v-1h1v1z",
    fill: "#d0cdc8"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M31 116v1h-1v-1z",
    fill: "#d2cdc6"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h-1v-1h1z",
    fill: "#d3cec3"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M50 117h-1v-1h1z",
    fill: "#e3dedb"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M52 116v1h-1v-1z",
    fill: "#e3e2da"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M52 117v-1h1v1z",
    fill: "#e4e4dc"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M65 116h1v1h-1z",
    fill: "#ebe9e3"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M71 116h1v1h-1z",
    fill: "#eee9e5"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M73 116v1h-1v-1z",
    fill: "#eeebe6"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M74 116v1h-1v-1z",
    fill: "#eeede8"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M75 117h-1v-1h1z",
    fill: "#ebebe8",
    fillOpacity: 0.353
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M19 118v-1h1v1z",
    fill: "#c4c4bd",
    fillOpacity: 0.153
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118v-1h1v1z",
    fill: "#c5c4bf",
    fillOpacity: 0.925
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M22 117v1h-1v-1z",
    fill: "#cccac6"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M24 117h1v1h-1z",
    fill: "#cbcac2"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M25 117h1v1h-1z",
    fill: "#ccccc1"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M27 118v-1h1v1z",
    fill: "#ceccc3"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M29 118h-1v-1h1z",
    fill: "#cfcdc4"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M30 117v1h-1v-1z",
    fill: "#d0cdc5"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M30 118v-1h1v1z",
    fill: "#d2cdc4"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h-1v-1h1z",
    fill: "#d5d0c5"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h-1v-1h1z",
    fill: "#d7d2c8"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M52 117v1h-1v-1z",
    fill: "#e5e1db"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M53 117v1h-1v-1z",
    fill: "#e5e3dd"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M72 117h1v1h-1z",
    fill: "#eeece7"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M73 118v-1h1v1z",
    fill: "#ebe9e6",
    fillOpacity: 0.965
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118h-1v-1h1z",
    fill: "#f0f0ec",
    fillOpacity: 0.212
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118v1h-1v-1z",
    fill: "#bfbfbf",
    fillOpacity: 0.016
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M20 118h1v1h-1z",
    fill: "#c3c3bf",
    fillOpacity: 0.694
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M22 118v1h-1v-1z",
    fill: "#cdccc8"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M23 119h-1v-1h1z",
    fill: "#c7c7c3"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119h-1v-1h1z",
    fill: "#c9c8c2"
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M25 119h-1v-1h1z",
    fill: "#cacac0"
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M30 118h1v1h-1z",
    fill: "#d2cdc2"
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119v-1h1v1z",
    fill: "#d4cec4"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M50 118h1v1h-1z",
    fill: "#e3deda"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h-1v-1h1z",
    fill: "#e6dedc"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119h-1v-1h1z",
    fill: "#eceae7",
    fillOpacity: 0.847
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M75 118v1h-1v-1z",
    fill: "#f1f1f1",
    fillOpacity: 0.075
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M21 120h-1v-1h1z",
    fill: "#c2c2bf",
    fillOpacity: 0.298
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M21 119h1v1h-1z",
    fill: "#c5c4c1",
    fillOpacity: 0.976
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M23 120h-1v-1h1z",
    fill: "#c9c8c4"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119v1h-1v-1z",
    fill: "#c8c8c1"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M24 119h1v1h-1z",
    fill: "#c9c9bf"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M26 120h-1v-1h1z",
    fill: "#cbcabf"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M52 119h1v1h-1z",
    fill: "#e5e3de"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M73 119v1h-1v-1z",
    fill: "#f3f2ee"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M74 119v1h-1v-1z",
    fill: "#eceae7",
    fillOpacity: 0.592
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M20 120h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.012
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M22 120v1h-1v-1z",
    fill: "#c0bebc",
    fillOpacity: 0.573
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M22 121v-1h1v1z",
    fill: "#cbcac5"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M23 120h1v1h-1z",
    fill: "#cacac2"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M25 121h-1v-1h1z",
    fill: "#c8c8c0"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M25 121v-1h1v1z",
    fill: "#cbcac0"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M31 121h-1v-1h1z",
    fill: "#d0ccc2"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M32 120v1h-1v-1z",
    fill: "#d0ccc1"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M49 120v1h-1v-1z",
    fill: "#e2ddd7"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M51 120v1h-1v-1z",
    fill: "#e5e0d9"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h-1z",
    fill: "#ecece7",
    fillOpacity: 0.953
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M74 121h-1v-1h1z",
    fill: "#edede9",
    fillOpacity: 0.227
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M22 122h-1v-1h1z",
    fill: "#bfbfbf",
    fillOpacity: 0.047
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M23 121v1h-1v-1z",
    fill: "#bfbfba",
    fillOpacity: 0.58
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M23 121h1v1h-1z",
    fill: "#c9c9c1",
    fillOpacity: 0.984
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M24 121h1v1h-1z",
    fill: "#cdcdc4"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M26 121v1h-1v-1z",
    fill: "#cac8c0"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M28 121h1v1h-1z",
    fill: "#ccc9c0"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M31 121v1h-1v-1z",
    fill: "#cfccc2"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M33 122h-1v-1h1z",
    fill: "#cecdc1"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M33 121h1v1h-1z",
    fill: "#cfcfc3"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M37 121v1h-1v-1z",
    fill: "#d9cfc6"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121v1h-1v-1z",
    fill: "#e1dcd8"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M52 122h-1v-1h1z",
    fill: "#e4e2dd"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M53 121v1h-1v-1z",
    fill: "#e3e4de"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M71 122h-1v-1h1z",
    fill: "#f2eeeb"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122h-1v-1h1z",
    fill: "#eeeeea",
    fillOpacity: 0.992
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M72 122v-1h1v1z",
    fill: "#eceee8",
    fillOpacity: 0.486
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M22 122h1v1h-1z",
    fill: "#aa5",
    fillOpacity: 0.012
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M23 123v-1h1v1z",
    fill: "#bfbfb6",
    fillOpacity: 0.361
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M24 122h1v1h-1z",
    fill: "#c5c5be",
    fillOpacity: 0.831
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M25 122h1v1h-1z",
    fill: "#cccbc2"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M27 122v1h-1v-1z",
    fill: "#cfcdc2"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M29 123h-1v-1h1z",
    fill: "#cbc9bf"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M30 122v1h-1v-1z",
    fill: "#cccac1"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M30 123v-1h1v1z",
    fill: "#ceccc2"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h-1v-1h1z",
    fill: "#d2cec5"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M36 122h1v1h-1z",
    fill: "#d7cfc5"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1z",
    fill: "#d9d1c8"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M42 123h-1v-1h1z",
    fill: "#dcd6ca"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M47 123h-1v-1h1z",
    fill: "#e0dcd4"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123h-1v-1h1z",
    fill: "#e1ddd7"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122v1h-1v-1z",
    fill: "#e5e0da"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1z",
    fill: "#e3e1dc"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M54 123h-1v-1h1z",
    fill: "#e4e4df"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M55 122v1h-1v-1z",
    fill: "#e5e4df"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122v1h-1v-1z",
    fill: "#efece8"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M69 122h1v1h-1z",
    fill: "#f4f1ed"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M71 122v1h-1v-1z",
    fill: "#edece9",
    fillOpacity: 0.918
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M71 123v-1h1v1z",
    fill: "#eeecea",
    fillOpacity: 0.431
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M24 123h1v1h-1z",
    fill: "#b1b1b1",
    fillOpacity: 0.09
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M25 124v-1h1v1z",
    fill: "#c2c2b9",
    fillOpacity: 0.463
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M27 123v1h-1v-1z",
    fill: "#c5c5bb",
    fillOpacity: 0.855
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M27 124v-1h1v1z",
    fill: "#cbcbc2"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M29 123h1v1h-1z",
    fill: "#cdcdc6"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M31 124h-1v-1h1z",
    fill: "#cdccc3"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M34 124v-1h1v1z",
    fill: "#d4cdc6"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h1v1h-1z",
    fill: "#d5ccc5"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M43 123v1h-1v-1z",
    fill: "#ded7cb"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123v1h-1v-1z",
    fill: "#dfddd0"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123h1v1h-1z",
    fill: "#e0ddd3"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124h-1v-1h1z",
    fill: "#e2ded6"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124h-1v-1h1z",
    fill: "#e6dedb"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M51 124h-1v-1h1z",
    fill: "#e6dfdc"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124h-1v-1h1z",
    fill: "#eae7df"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M65 124h-1v-1h1z",
    fill: "#eeebe5"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M68 123v1h-1v-1z",
    fill: "#f3f2ec"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M68 124v-1h1v1z",
    fill: "#ebeae6",
    fillOpacity: 0.945
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v-1h1v1z",
    fill: "#ecece7",
    fillOpacity: 0.647
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M71 124h-1v-1h1z",
    fill: "#eaefea",
    fillOpacity: 0.192
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M26 124h1v1h-1z",
    fill: "#b7b7ad",
    fillOpacity: 0.098
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M28 125h-1v-1h1z",
    fill: "#c0c0bb",
    fillOpacity: 0.4
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M29 124v1h-1v-1z",
    fill: "#c7c7c3",
    fillOpacity: 0.733
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M30 124v1h-1v-1z",
    fill: "#cacac5",
    fillOpacity: 0.945
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M32 125h-1v-1h1z",
    fill: "#d5d2ca"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M33 125h-1v-1h1z",
    fill: "#d4d1c9"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124h1v1h-1z",
    fill: "#d8cdc4"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M38 125v-1h1v1z",
    fill: "#dad2c9"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M41 124h1v1h-1z",
    fill: "#dbd6ca"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M50 124v1h-1v-1z",
    fill: "#e5e0d8"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M51 125h-1v-1h1z",
    fill: "#e7e0da"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M63 124v1h-1v-1z",
    fill: "#f1eee8"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M64 124v1h-1v-1z",
    fill: "#f4f1ec"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M64 125v-1h1v1z",
    fill: "#f5f1ed"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124v1h-1v-1z",
    fill: "#ece9e5",
    fillOpacity: 0.973
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M67 124v1h-1v-1z",
    fill: "#ebe9e4",
    fillOpacity: 0.8
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M68 125h-1v-1h1z",
    fill: "#ebebe5",
    fillOpacity: 0.518
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v1h-1v-1z",
    fill: "#efefea",
    fillOpacity: 0.196
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M30 126h-1v-1h1z",
    fill: "#c1c1c1",
    fillOpacity: 0.196
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M30 125h1v1h-1z",
    fill: "#c9c7c2",
    fillOpacity: 0.431
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M31 126v-1h1v1z",
    fill: "#cbc8c3",
    fillOpacity: 0.675
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M32 126v-1h1v1z",
    fill: "#cdccc6",
    fillOpacity: 0.851
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M33 125h1v1h-1z",
    fill: "#cecec6",
    fillOpacity: 0.957
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M34 125h1v1h-1z",
    fill: "#d4d0c9"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126h-1v-1h1z",
    fill: "#dbd4cc"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M37 125v1h-1v-1z",
    fill: "#ded4cb"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126v-1h1v1z",
    fill: "#ddd4cb"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M39 125v1h-1v-1z",
    fill: "#ded6cc"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M39 126v-1h1v1z",
    fill: "#ddd8cd"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M42 126v-1h1v1z",
    fill: "#dbd8cb"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M49 126v-1h1v1z",
    fill: "#e3e0d7"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v1h-1v-1z",
    fill: "#e6e4dd"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M58 125h1v1h-1z",
    fill: "#f0ede9"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126v-1h1v1z",
    fill: "#f0eee9"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126h-1v-1h1z",
    fill: "#ebe8e2",
    fillOpacity: 0.961
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126v-1h1v1z",
    fill: "#ebe7e4",
    fillOpacity: 0.859
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M63 126v-1h1v1z",
    fill: "#eeeae7",
    fillOpacity: 0.686
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h-1v-1h1z",
    fill: "#efebe7",
    fillOpacity: 0.463
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h-1v-1h1z",
    fill: "#eee9e9",
    fillOpacity: 0.235
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126v-1h1v1z",
    fill: "#e9ffe9",
    fillOpacity: 0.047
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M33 127h-1v-1h1z",
    fill: "#ccc",
    fillOpacity: 0.078
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M33 127v-1h1v1z",
    fill: "#c6c6c6",
    fillOpacity: 0.196
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M34 126h1v1h-1z",
    fill: "#cdcac4",
    fillOpacity: 0.361
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126v1h-1v-1z",
    fill: "#cfcdc5",
    fillOpacity: 0.506
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M36 126h1v1h-1z",
    fill: "#d3cdc7",
    fillOpacity: 0.643
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126h1v1h-1z",
    fill: "#d7d0ca",
    fillOpacity: 0.757
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M38 127v-1h1v1z",
    fill: "#d7d2ca",
    fillOpacity: 0.882
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M40 127h-1v-1h1z",
    fill: "#d9d5ce",
    fillOpacity: 0.953
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M41 127h-1v-1h1z",
    fill: "#dad6ce",
    fillOpacity: 0.992
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M41 126h1v1h-1z",
    fill: "#dad9cf"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M43 127h-1v-1h1z",
    fill: "#dedcd3"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126h1v1h-1z",
    fill: "#e3ddd5"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v1h-1v-1z",
    fill: "#e3ddd6"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126h1v1h-1z",
    fill: "#e1dfd7"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M48 127v-1h1v1z",
    fill: "#e3e2d9"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M50 127h-1v-1h1z",
    fill: "#e4e4db"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M51 127h-1v-1h1z",
    fill: "#e5e6dd"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M52 126v1h-1v-1z",
    fill: "#e7e8e2"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M53 126v1h-1v-1z",
    fill: "#e8e9e3"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M53 126h1v1h-1z",
    fill: "#e9e9e5"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v1h-1v-1z",
    fill: "#e7e7e5"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126h1v1h-1z",
    fill: "#e4e4e2",
    fillOpacity: 0.98
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M56 126h1v1h-1z",
    fill: "#e4e4e2",
    fillOpacity: 0.933
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M57 127v-1h1v1z",
    fill: "#e4e4e2",
    fillOpacity: 0.831
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M58 126h1v1h-1z",
    fill: "#e6e6e1",
    fillOpacity: 0.686
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126h1v1h-1z",
    fill: "#e7e7e3",
    fillOpacity: 0.514
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126v1h-1v-1z",
    fill: "#e6e6e3",
    fillOpacity: 0.361
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126h1v1h-1z",
    fill: "#ebebe6",
    fillOpacity: 0.2
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M62 127v-1h1v1z",
    fill: "#e6e6e6",
    fillOpacity: 0.082
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M39 127v1h-1v-1z",
    fill: "#cdcdc5",
    fillOpacity: 0.122
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M39 128v-1h1v1z",
    fill: "#d2caca",
    fillOpacity: 0.247
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M40 127h1v1h-1z",
    fill: "#d8d3cd",
    fillOpacity: 0.365
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M42 128h-1v-1h1z",
    fill: "#d3d3cc",
    fillOpacity: 0.51
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M42 128v-1h1v1z",
    fill: "#d9d8d1",
    fillOpacity: 0.616
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M44 128h-1v-1h1z",
    fill: "#dcd7d1",
    fillOpacity: 0.663
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M45 127v1h-1v-1z",
    fill: "#dbd6d1",
    fillOpacity: 0.698
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M46 128h-1v-1h1z",
    fill: "#dfdad6",
    fillOpacity: 0.737
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M46 127h1v1h-1z",
    fill: "#dcdbd6",
    fillOpacity: 0.784
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M48 128h-1v-1h1z",
    fill: "#ddddd5",
    fillOpacity: 0.824
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M49 127v1h-1v-1z",
    fill: "#ddddd6",
    fillOpacity: 0.808
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M49 128v-1h1v1z",
    fill: "#dedfd7",
    fillOpacity: 0.769
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M50 128v-1h1v1z",
    fill: "#dee0d9",
    fillOpacity: 0.698
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M51 128v-1h1v1z",
    fill: "#e0e1db",
    fillOpacity: 0.62
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M53 128h-1v-1h1z",
    fill: "#e0e1db",
    fillOpacity: 0.584
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M54 128h-1v-1h1z",
    fill: "#e1e2dd",
    fillOpacity: 0.569
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M54 128v-1h1v1z",
    fill: "#e3e5e1",
    fillOpacity: 0.475
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M56 127v1h-1v-1z",
    fill: "#e3e3e3",
    fillOpacity: 0.329
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M57 127v1h-1v-1z",
    fill: "#e4e4e4",
    fillOpacity: 0.192
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M58 127v1h-1v-1z",
    fill: "#d8d8d8",
    fillOpacity: 0.078
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeCup);
export default __webpack_public_path__ + "static/media/coffee-cup.93fdd3668f57fc5f838fa4a6cbbfeed1.svg";
export { ForwardRef as ReactComponent };